/* sp-chat.js - our own shop chat: the engine and the screen.
 *
 * Plain JavaScript. No framework, no outside library, one global: window.SPChat.
 * Everything it puts in the page is named `sp-chat`.
 *
 * It expects `sp-chat-flows.js` to have run first (the theme snippet loads both
 * deferred, in that order) and one root element in the page:
 *
 *   <div id="sp-chat-root"
 *        data-sp-chat-fn="https://.../functions/v1/shop-chat"
 *        data-sp-chat-logo="..."
 *        data-sp-chat-practice=""></div>
 *
 * BOTH SIDES SEE THE OTHER TYPING, AND THE CUSTOMER IS TOLD SOMEBODY IS COMING
 * (30 October 2026, migration 1853 and shop-chat v15). Lorenzo asked for two
 * things in one breath: "Can we show a message to the csutomer after they send
 * the first message to say that someone will be with them in a moment," and
 * "When we are typing the customer should see we are typing and same when the
 * customer is rttype we should see that too".
 *
 * THREE PIECES, AND THEY DO NOT NEED EACH OTHER:
 *   1. THE LINE. "Someone will be with you in a moment." - drawn here, never
 *      saved, once per waiting episode, and only while the server says we are
 *      online. See sayWaiting(), which also says the one thing about it Lorenzo
 *      has to choose: it REPLACES `after_thanks_live` in that slot. It needs
 *      nothing of the server's and nothing of the ERP's.
 *   2. OUR DOTS, ON THE CUSTOMER'S SCREEN. `chat_poll` answers `team_typing`
 *      since 1853, and the LIVE shop-chat already passes its whole JSON through,
 *      so this works the day the file goes on a theme. See showTeamTyping().
 *   3. THEIR DOTS, ON OUR SCREEN. The poll that happens anyway carries
 *      `typing: true`; shop-chat v15 turns that into one database call. THE WORDS
 *      TYPED ARE NEVER SENT OR STORED. See customerTyping(). This one needs v15
 *      deployed AND the ERP's own half; until then it is a key nobody reads.
 *
 * NOTHING NEW IS REQUESTED FROM THE CUSTOMER'S BROWSER for any of the three. The
 * line is drawn, the dots are read off a poll that was already being made, and the
 * customer's typing rides on that same poll.
 *
 * A REPLY CARD ABOVE THE BUTTON (29 October 2026). Lorenzo: "when we send a
 * message to the customer, and if they have closed the chat, all they see is a
 * small dot on top of the chat icon ... lets show the message like you
 * suggested". What he accepted: a small card just above the chat button saying
 * who replied and the first line or two of the reply, tapping it opens the chat,
 * a cross puts it away, and the browser tab says so if they are on another one.
 *
 *   IT DOES NOT OPEN THE CHAT BY ITSELF. On a phone the panel is the whole
 *   screen, so a chat that opened on its own would cover the page the customer
 *   came to read. The card is the knock on the door; they decide whether to open
 *   it.
 *
 *   IT IS SHOWN IN TWO PLACES, because the gap was in two places. `takePoll` has
 *   always known when a reply lands while the panel is shut - that is what put
 *   the dot there. `resume` did NOT: a reply that arrived between two page loads
 *   was drawn silently into the hidden panel with no dot at all, so a customer
 *   who answered and then carried on browsing was never told. Both now show the
 *   card AND the dot.
 *
 *   WHAT COUNTS AS SEEN IS THIS BROWSER'S BUSINESS and is kept here, not on the
 *   server: `sp-chat-seen` holds, for the chat whose token is in hand, the id of
 *   the newest team message the panel has been open for, and the id whose card
 *   was crossed off. Opening the chat marks everything drawn as seen; the cross
 *   silences only that one card, so it does not come back on every page, and the
 *   dot stays until they open the chat. Nothing about it reaches the database -
 *   two devices on the same chat each keep their own answer, which is right,
 *   because what has been SEEN is a fact about a screen.
 *
 *   NOTHING TAKES FOCUS. The card is announced politely through one clipped live
 *   region and the cursor is not moved, because the customer is in the middle of
 *   reading a shop page. Lorenzo, of the message box: "I dont want the field
 *   focused until its pressed" - this is the same rule one step further out.
 *
 * THE FLOATING ADD TO CART (29 October 2026). Lorenzo: "can you move the chat
 * icon up a bit. It overlaps the add to cart button when on the product page and
 * scroll down with floating add to cart".
 *
 *   WHOSE BAR IT IS. The theme's own, `[data-sp-sticky]` (`.sp-sticky`), fixed to
 *   the foot of a product page, PHONES AND SMALL TABLETS ONLY - its whole block
 *   lives inside the theme's `max-width: 768px` query, so on a computer there is
 *   nothing to get out of the way of. It is transparent, with the Add to cart
 *   button inside it, and the theme shows and hides it with `hidden`.
 *
 *   IT IS MEASURED, NOT WRITTEN DOWN. The button is put 16px of clear air above
 *   the top of the bar's own Add to cart button, read off the page every time it
 *   could have moved - a look on scroll and resize throttled to 50ms, which is the
 *   theme's own beat for the same bar, a ResizeObserver for the moment the webfont
 *   lands and the bar grows, and a MutationObserver for the theme putting it away.
 *
 *   WHY NOT THE THEME'S OWN FIGURE. The theme publishes `--sp-sticky-h` and a
 *   `body.sp-has-sticky` class for exactly this, and lifts Gorgias's old
 *   `#chat-button` off them. MEASURED on V5.13.15 at 390x844 on 29 October 2026:
 *   the bar is 73px tall and `--sp-sticky-h` says 50px - it is set once, before
 *   the type and the price have settled, and never set again. Lifting by the
 *   theme's figure leaves 7px of overlap, so it is read directly instead. That
 *   stale figure is the theme's to fix, not this file's.
 *
 *   IT FAILS SAFE. If the page has no such bar - every page that is not a product
 *   page, and a product page on a computer - nothing is looked at and nothing
 *   moves: the button, the card and the panel are exactly where they are today.
 *
 * NO PRIVACY LINK (28 October 2026). Lorenzo: "Remove the privacy link from the
 * chat". The theme snippet still carries `data-sp-chat-privacy`, and nothing
 * reads it any more - left there so this change is two files, not three.
 *
 * A PAPERCLIP IN THE MESSAGE BOX (28 October 2026). Lorenzo: "We need the
 * cuystomer to be able to upload a file/photo". It is on the three boxes that
 * take a MESSAGE - the first one, the first one of a live chat, and the one that
 * stays open while the chat is going - and on none of the boxes that ask for one
 * particular thing: not the email box, not the phone box, not the code box.
 *
 *   PICTURES AND PDF, five in one message and twenty in a chat. The browser's own
 *   file chooser does the choosing, which is what offers a phone's photo library
 *   and its camera; nothing here could offer either.
 *
 *   WHAT WAS CHOSEN SITS ABOVE THE BOX, each with a cross on it, and the send
 *   button then works with words, with files, or with both.
 *
 *   NOTHING IS DRAWN UNTIL IT IS SENT. A message of words alone goes on screen the
 *   moment it is pressed, because it cannot half-arrive; an upload can, so the box
 *   holds everything and says it is sending. See sendWithFiles.
 *
 *   IT NEEDS A NEWER shop-chat THAN THE ONE THAT IS DEPLOYED. `send_files` is
 *   version 13 and `upload_urls` in version 7 refuses any chat that is not
 *   answering, so against the live function a paperclip press is told we could not
 *   send it. Migration 1775 and shop-chat v13 go first, then the theme.
 *
 * ONE SCREEN, AND IT IS A PLAIN MESSAGING WINDOW (27 October 2026). Lorenzo,
 * with two pictures of the window he wants: "All chats on the website should
 * look like this when opened, If offline should say offline and grey insterad of
 * green and leae a message to inform we are going to be back soon." Asked four
 * questions he chose: the hours in that message come FROM CHAT SETTINGS; the
 * email is asked for AFTER THEIR FIRST MESSAGE; the topic list is REMOVED; and
 * reopening the chat shows THEIR CONVERSATION.
 *
 * So opening the chat shows the header, the conversation and the message box, and
 * nothing else. There is no home screen, no topic list, no question flow, no
 * "Your previous chats" and no order row.
 *
 *   THE KIND OF CHAT IS DECIDED BY THE PAGE, SILENTLY. `SPChatFlows.pages` names
 *   the pages that are their own kind - /pages/wedding-dress-ring is
 *   `wedding_ring` - and every other page is `SPChatFlows.general` (`chat`). The
 *   customer is never asked and never sees a key. wedding_ring has to stay
 *   exactly that string: the Wedding ring live switch (1737) and the AI reply
 *   drafts (1748) both read it.
 *
 *   ONLINE is the header saying "Online" with a green mark, an EMPTY message
 *   area, and the box. The first thing they type opens the conversation in live
 *   mode and hands it to a person, exactly as live mode has always done.
 *
 *   OFFLINE is the header saying "Offline" with a grey mark and ONE bubble from
 *   us, which says when we are back - built here from the hours the server sends
 *   off Chat settings. The first thing they type is recorded; then the chat asks
 *   for an email, and once it has one the chat goes to email and a Gorgias
 *   ticket, which is the ending every chat nobody answers has always had.
 *
 *   NOTHING IS OPENED UNTIL THEY TYPE. `start` is sent with the first message and
 *   not when the panel opens, so somebody who opens the chat and walks away
 *   leaves no answerless chat in the ERP. Page mode used to, and that was named
 *   as a consequence; it is gone.
 *
 *   REOPENING redraws the conversation they are having, our replies included -
 *   AND THAT NOW INCLUDES A CHAT THAT HAS ENDED (30 October 2026, migration 1829).
 *   Lorenzo: "once the chat ends its not appear on the customer side too. If I
 *   have a chat as a customer, it should stay there but I dont see it anymore.
 *   chat 365 was test yesterday. The customers need to see their chats and start
 *   replying to previous chats and when they do the chat should re open." Until
 *   today the token was dropped the moment a chat ended, so the next page load
 *   showed a fresh screen and the conversation was gone.
 *   WHAT HAPPENS NOW: an ended chat draws like any other, with its ending line and
 *   the message box under it, and the customer's next message REOPENS it - there
 *   is nothing for them to press, which is what he chose ("for the customer there
 *   is no button they just send a new message and it re opens"). With no current
 *   token the newest chat on this browser's own list is picked up instead, so a
 *   chat an older version of this file threw away comes back as well.
 *   THREE PLACES STILL DROP THE TOKEN ON PURPOSE and are unchanged: "Remove from
 *   this device", which is the customer asking; and the orders screens' two
 *   restarts, which are not reached (`HOME.show_orders` is false).
 *
 * THE OLD SCREENS ARE KEPT IN THIS FILE AND ARE NOT REACHED. The question flows,
 * order management and the two history screens are all still here, with their
 * words, because Lorenzo may ask for any of them back and because the chats they
 * already made are still read by the ERP and by the Gorgias ticket. Nothing calls
 * pickFlow, pickOrders, askStep, askContact or renderFlowList any more. What
 * follows is how the chat worked before 27 October 2026.
 *
 * THE ORDER OF THE CHAT. The email is asked LAST, after the flow's own
 * questions, and an OPTIONAL PHONE NUMBER after it. Lorenzo, later on 25 October
 * 2026: "can we collect the email of the customer as the last step and after the
 * email ask them for a number too", and he chose the phone optional. This
 * REVERSES his earlier "email first": a chat stopped partway now leaves its
 * answers and no contact details, which he was asked about and accepted ("Yes,
 * email at the end"). The two questions come before the flow's thank-you where
 * it has one and before `finish` where it has none, and they are sent together
 * in one `contact` call. ORDER MANAGEMENT IS NOT CHANGED: its email still comes
 * first, because the 6-digit code is sent to it.
 *
 * IT ALSO ANSWERS THE THEME'S OWN GORGIAS COMMANDS. The theme's sections call
 * `GorgiasChat.init()`, `.open()` and `.sendMessage(<flow label>)`, listen for
 * `gorgias-widget-loaded`, and put about forty `#open-gorgias-chat` links on the
 * shop. With the Gorgias embed off all of those would quietly fall back to the
 * custom request form, so this file defines `window.GorgiasChat` ITSELF - but
 * only if there is none, so the real Gorgias widget is never overwritten. See
 * "ANSWERING THE THEME'S COMMANDS" at the foot of this file.
 *
 * AND ONE PAGE CAN BE ONE FLOW. `SPChatFlows.pages` lists the pages that are a
 * single flow and nothing else - the wedding-dress page, on Lorenzo's word - and
 * on one of those the launcher, `GorgiasChat.open()` and every chat link go
 * straight into that flow, with no home screen, no other flow and no order row.
 * It is only on for a flow that EXISTS AND HAS STEPS, so a page whose flow is
 * still waiting for his questions behaves like any other page.
 *
 * LIVE MODE: A GREETING INSTEAD OF THE QUESTIONS. Lorenzo, 26 October 2026:
 * "when someone is online, dpeneding on if its for thwedding dress or the all
 * the rest, the first message they see is hell how can we hlep or something like
 * this. they say something and after that there is a notification in the app
 * where the number is added to the chat to show that there is a live
 * conversation." He chose the "greeting instead of the questions", and asked for
 * a line in the chat saying we are online. And: "We dont want to ask any
 * additional details from them."
 *
 * So when a flow is answered live at the moment it is opened, the chat shows
 * "We're online now", greets them, and the first thing they type goes straight
 * to a person - no questions, no email, no phone. THE SERVER DECIDES, not this
 * file: `status` asks about one flow, `start` ASKS for live mode and
 * chat_start_live answers whether it got it, and a browser whose answer has gone
 * stale runs the questions exactly as it does today. The wording is all in the
 * flow file's `live`. The one time a live chat asks for anything is when nobody
 * answered in time: the server then writes "Sorry we missed you..." and says so
 * with `ask_email`, and the email box is shown under it.
 *
 * NEVER FOCUS A TEXT BOX BY ITSELF. Not on open, not after a question, not
 * after an error, and not the 6-digit code box. Gorgias does; ours does not.
 * Lorenzo: "I dont want the field focused until its pressed". There is no
 * .focus() call on a textarea or an input anywhere in this file, and that is on
 * purpose - see focusPanel().
 *
 * TWO THINGS RUN HERE. The Gorgias question flows (Customize a Ring) are a list
 * of steps from the flow file; ORDER MANAGEMENT is not, and has its own half of
 * this file, marked ORDER MANAGEMENT further down. Both save every answer as it
 * is given and both end the same way, live or by email.
 *
 * A RETURNING CUSTOMER'S OWN CHATS, two ways, on Lorenzo's word (25 October
 * 2026): "how can we preserve the chat of a customer. So that when the same
 * customer returns they see their chat hisotyr". He chose both.
 *   1. THE SAME BROWSER, with no proof of anything: this browser keeps the token
 *      of every chat it started under `sp-chat-history`, and only this browser
 *      has them. The home screen lists them above the flow rows.
 *   2. ANY DEVICE, after the 6-digit code: the server sends the verified
 *      customer's past chats with their orders, and `history_view` opens one.
 * EITHER WAY A PAST CHAT OPENS READ ONLY - the whole conversation drawn again
 * with no message box, and "Back to the start" at the foot - UNLESS it is still
 * waiting or live, when it opens exactly as it does today, able to type.
 * (That is the `history_view` screens, which are not reached. THE ONE SCREEN'S own
 * ended chat is NOT read only since 30 October 2026: see "REOPENING" above.)
 */
(function () {
  'use strict';

  var ROOT_ID = 'sp-chat-root';
  var TOKEN_KEY = 'sp-chat-token';
  var HISTORY_KEY = 'sp-chat-history';
  /* What this browser has been shown of a reply - see "THE REPLY CARD" below. */
  var SEEN_KEY = 'sp-chat-seen';
  /* The visit's open key, in sessionStorage - see "THE CHAT WAS OPENED" below. */
  var OPEN_KEY = 'sp-chat-open';
  var HISTORY_MAX = 20;            /* about twenty, as the design says */
  var FN_DEFAULT = 'https://ofaevaqsuppeqtrtypra.supabase.co/functions/v1/shop-chat';

  /* 28 October 2026: TWO CEILINGS WHERE THERE WAS ONE. Five in a message is what MAX_FILES always
     was, and it stays; the whole chat now holds twenty, because five per CHAT was a question
     flow's number and a conversation goes on. Both are the server's numbers really
     (chat_files_per_message, chat_files_per_chat) - these two are here so the chat can say so
     before a customer's data is spent uploading something that will be refused. */
  var MAX_FILES = 5;
  var MAX_FILES_IN_CHAT = 20;
  var MAX_FILE_BYTES = 15 * 1024 * 1024;   /* 15 MB, as the contract says */
  var MAX_TEXT = 2000;                     /* the function caps every text at 2,000 */
  var POLL_OPEN_MS = 3000;                 /* every 3s while the chat is open */
  var POLL_SHUT_MS = 15000;                /* every 15s while it is shut */

  /* HOW LONG A KEYSTROKE COUNTS AS "STILL TYPING" (30 October 2026, shop-chat v15).
     Four seconds, against the three-second poll above - so one poll always falls inside the window
     after a keystroke and the ERP's dots do not flicker between words, and they stop within about
     four seconds of the customer stopping. It is NOT a timer: nothing is scheduled, the poll that
     was going to happen anyway reads the clock. */
  var TYPING_FOR_MS = 4000;
  var PHONE_UNDER = 640;                   /* under 640px is a phone: full screen */
  var TEXTAREA_MAX = 120;

  var PRACTICE_WAIT_MS = 180;              /* a practice call still takes a moment */
  var PRACTICE_REPLY_MS = 4000;            /* "after about 4 seconds" */
  var PRACTICE_TYPING_MS = 2000;           /* and the dots about two seconds before it */
  var PRACTICE_REPLY_NAME = 'Sesto Synergy';
  var PRACTICE_REPLY_BODY =
    'This is a practice reply, to show how a reply from the team looks.';

  /* The shape of an email address, not whether it exists. The function checks
     it again and refuses a malformed one. */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

  /* A PHONE NUMBER IS TAKEN LOOSELY, as the design says: digits with `+`,
     spaces, dashes, dots or brackets, and 7 to 20 digits in it. Nothing is
     reformatted and no country is assumed - the ERP shows what the customer
     typed. The server checks it again and refuses a bad one with `bad_phone`. */
  var PHONE_CHARS = /^[0-9+().\s-]+$/;
  var PHONE_MIN_DIGITS = 7;
  var PHONE_MAX_DIGITS = 20;
  /* 40, which is what the server and the column's own CHECK allow. A tighter cap
     here would be a `maxLength` quietly cutting the end off a number the server
     would have taken - 20 digits with brackets and spaces around them can run
     past 32 - and the customer would never see why it was refused. */
  var PHONE_MAX_CHARS = 40;

  var FILE_OK = /^image\//;

  /* The theme's own event, fired once this file is ready, and the window in
     which the same flow will not be started twice - so two document listeners
     on one page (custom-ring-hero's and ours) cannot open it twice. */
  var GORGIAS_EVENT = 'gorgias-widget-loaded';
  var SAME_FLOW_MS = 1500;

  var S = {
    ready: false,
    root: null,
    fnUrl: FN_DEFAULT,
    logoUrl: '',
    practice: null,        /* null, 'online' or 'offline' */
    open: false,
    openKey: null,         /* this visit's open key, once made - see "THE CHAT WAS OPENED" */
    openReported: false,   /* the `opened` call has gone for this page load */
    view: 'home',          /* 'home' or 'convo' */
    token: null,
    flow: null,
    stepId: null,
    phase: 'home',         /* home | flow | contact | waiting | live | over */
    email: '',
    phone: null,
    /* The email and the phone are recorded TOGETHER, in one `contact` call, at
       the end of a flow. So an email on the row means both were asked and the
       call went through, which is how a redrawn chat knows not to ask again. */
    contactDone: false,
    status: null,          /* answering | waiting | live | emailed | closed */
    lastId: 0,
    files: [],
    /* The message box as composeBox handed it back, kept for ONE job: when an
       ended chat is reopened the box has to be built again - the ended one has no
       paperclip and the open one does - and anything typed in between is carried
       into the new one rather than lost. See recompose(). */
    box: null,
    /* THE BOX ANYTHING IS BEING TYPED INTO, whichever composer made it - set by
       composeBox and cleared by clearCompose, so it is never a box that has been
       taken off the screen. `box` above is the MESSAGE box specifically, kept for
       recompose; this is "the one on screen now", which is the question the
       typing mark asks. */
    typingBox: null,
    /* WHEN A KEY WAS LAST PRESSED IN IT. The poll reads this and nothing else -
       NEVER what was typed. See customerTyping(). */
    typedAt: 0,
    /* "Someone will be with you in a moment." has been said for THIS waiting
       episode. It goes back to false when the chat ends, so a chat that is
       reopened says it again - once for each, which is what Lorenzo asked for. */
    saidWaiting: false,
    /* THE ONE BUBBLE THAT SAYS WE ARE NOT ON, for a chat picked up again - kept
       so it can be taken away the minute somebody switches on, and so there can
       never be a second one. See sayOffline(). */
    offlineNote: null,
    pollTimer: null,
    locked: false,
    scrollY: 0,
    practiceId: 0,
    practiceQueue: [],
    unread: false,
    stick: true,           /* keep the log pinned to its newest line */

    /* THE REPLY CARD (29 October 2026).
       `lastTeamId` is the newest team message this screen has drawn, which is what
       opening the chat records as seen. `seen` and `hid` are that chat's two
       remembered ids, read from the browser once and written back as they change.
       `practiceSeen` stands in for the stored object in practice mode, which
       writes nothing to the browser it is being previewed in.
       `titleWas` is the page's own title, kept only while the tab is saying there
       is a new message, and `titleCount` is how many have landed unseen. */
    lastTeamId: 0,
    lastTeam: null,        /* that message itself, so a resumed chat can card it */
    cardId: 0,             /* the message the card is showing, 0 for no card */
    seen: 0,
    hid: 0,
    practiceSeen: null,
    titleWas: null,
    titleCount: 0,

    /* THE FLOATING ADD TO CART. `bar` is the theme's bar once it has been found on
       this page - null means there is none and nothing is ever looked at again.
       `liftAsked` is the one frame a look is already booked for. */
    bar: null,
    barWatched: null,
    barRo: null,
    barMo: null,
    liftAsked: false,

    /* ORDER MANAGEMENT. `orders` is the verified customer's orders exactly as
       the server sent them, kept so "Back to my orders" can draw the list again
       without asking twice; `order` is the one they chose. `verified` is only
       ever set by a successful `orders_verify`. */
    orders: null,
    order: null,
    verified: false,

    /* CHAT HISTORY. `history` is the verified customer's past chats as the
       server sent them (after the code, so good on any device); the same
       browser's own list is not held here at all - it is read from
       localStorage every time it is drawn, so two tabs cannot disagree about
       it. `practiceHistory` stands in for that list in practice mode, which
       writes nothing anywhere. */
    history: null,
    practiceHistory: null,
    practiceStore: null,

    /* PAGE MODE. The flow key this page NAMES, or null for every ordinary page.
       Worked out once, at boot, from `location.pathname` and the flow file's
       `pages` list. Until 27 October 2026 it was only set for a flow that existed
       AND HAD STEPS, because it meant "go into that flow's questions"; now it
       means "this page's chat is of that kind", so steps have nothing to do with
       it. */
    pageFlowKey: null,

    /* ONE SCREEN (27 October 2026).
       `kind` is the flow key every chat opened on this page carries: the page's
       own kind, or the flow file's `general`. Worked out once, at boot.
       `onlineNow` and `hours` are the last answer `status` gave - whether a chat
       of this kind would be answered live this minute, and the opening hours the
       offline sentence is written from. Both are asked again every time the
       screen begins, because both are facts about this minute.
       `started` is true once this screen has drawn itself, so opening the panel a
       second time does not draw it again over the top of a conversation. */
    kind: null,
    onlineNow: false,
    hours: null,
    started: false,

    /* LIVE MODE. `live` is true only when the SERVER said so - `start` answered
       `live: true` for this conversation, or `resume` answered `live_started` -
       and it is what decides whether the chat is a greeting and a message box or
       a list of questions. `liveAskedEmail` is true once the email box has been
       shown for a live chat nobody answered in time, so the server saying so on
       every poll shows it once. */
    live: false,
    liveAskedEmail: false,
    liveSoftAsked: false,
    leadEventId: null,
    /* practice mode only: whether the practised chat is now waiting for an
       email, which the signposted first message "missed" turns on */
    practiceAskEmail: false,
    /* practice mode only: whether the practised colleague is "typing" this
       moment, so a practice run shows the three dots before its reply arrives the
       way the real one does. The real shop reads chat_poll's `team_typing` and
       never this. */
    practiceTyping: false,

    /* `resume` is in flight. Page mode waits for it rather than starting a new
       chat on top of one the customer already has going. */
    resuming: false,
    /* THE RESUME FAILED, and the token it failed on: `{ token, adopted }`, null
       when there is nothing wrong. A chat we could not read is not a chat that is
       gone, so the screen offers Try again and NO MESSAGE BOX - a box there opens
       a SECOND chat with the first word typed into it. See resumeToken() and
       beginScreen(). */
    resumeFailed: null,
    /* WORDS HALF TYPED IN THIS TAB while another tab started the chat. The box is
       about to be built again for that chat, and what they had typed is theirs -
       see the `storage` listener and the foot of redrawOne. */
    carryTyped: '',

    /* The last flow started by a COMMAND - the theme's `sendMessage`, a
       `[data-gorgias-flow]` button or an `#open-gorgias-chat` link - so the same
       one is not started twice by two listeners in the same moment. A row
       pressed on the home screen does not go through this. */
    lastStartKey: null,
    lastStartAt: 0
  };

  var F = null;   /* the flow file: window.SPChatFlows */
  var D = {};     /* the elements we keep hold of */

  /* ------------------------------------------------------------- small helpers */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function svg(paths, extra) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', (extra && extra.box) || '0 0 24 24');
    s.setAttribute('fill', (extra && extra.fill) || 'none');
    s.setAttribute('stroke', (extra && extra.stroke) || 'currentColor');
    s.setAttribute('stroke-width', (extra && extra.width) || '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < paths.length; i++) {
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', paths[i]);
      s.appendChild(p);
    }
    return s;
  }

  function iconChat() {
    return svg(['M21 11.5a8.4 8.4 0 0 1-9 8.4 9.3 9.3 0 0 1-3.3-.6L3 21l1.8-4.4A8.2 8.2 0 0 1 3.6 11.5 8.4 8.4 0 0 1 12 3.1a8.4 8.4 0 0 1 9 8.4z'],
      { fill: 'none', stroke: 'currentColor', width: '1.8' });
  }
  /* NOT REACHED SINCE 27 OCTOBER 2026: there is no back arrow, because there is
     no home screen for it to lead to. */
  function iconBack() { return svg(['M15 19l-7-7 7-7']); }
  function iconClose() { return svg(['M18 6 6 18', 'm6 6 12 12']); }
  /* A PAPER PLANE since 27 October 2026, which is what Lorenzo drew in the round
     gold send button. It was an upward arrow before. */
  function iconSend() {
    return svg(['M22 2 11 13', 'M22 2 15 22 11 13 2 9z'], { width: '1.7' });
  }
  /* the chevron on an option row, the same mark the ring page's folding cards
     carry on theirs */
  function iconChevron() { return svg(['m9 18 6-6-6-6'], { width: '1.7' }); }

  /* THE PAPERCLIP (28 October 2026). Lorenzo: "We need the cuystomer to be able to
     upload a file/photo". One stroke, the same weight as the other marks in this
     file, drawn as a clip hanging from the top right. */
  function iconClip() {
    return svg([
      'M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84'
      + 'l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48'
    ], { width: '1.7' });
  }

  /* THE MARK AT THE START OF EACH HOME-SCREEN ROW (Lorenzo, 25 October 2026:
     "Add appropriate icon at the start of each selection to start the chat").
     The flow file names one per flow (`icon:`); a name not here draws nothing,
     so a new flow without one still gets its row. Line drawings in the same
     weight as the chevron, ink until the row is pressed, then gold.
       ring      Customize a Ring - a band, seen face on
       heart     Use Personal Materials - something of theirs
       sparkles  Create Something Original - a new design
       gold      Heirloom Gold - an ingot */
  var ICONS = {
    ring: ['M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z', 'M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0z'],
    heart: ['M12 20.5S3.5 15.6 3.5 9.4A4.4 4.4 0 0 1 12 7.1a4.4 4.4 0 0 1 8.5 2.3c0 6.2-8.5 11.1-8.5 11.1z'],
    sparkles: ['M10 3.5l1.6 4.9 4.9 1.6-4.9 1.6L10 16.5l-1.6-4.9L3.5 10l4.9-1.6z',
               'M18 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z'],
    gold: ['M7 6.5h10l4.5 11h-19z', 'M8.5 10.5h7']
  };
  function iconFor(name) {
    var paths = ICONS[String(name || '')];
    return paths ? svg(paths, { width: '1.6' }) : null;
  }

  function isPhone() {
    return window.innerWidth < PHONE_UNDER;
  }

  function trim(s) { return String(s === undefined || s === null ? '' : s).trim(); }

  function cap(s) { return trim(s).slice(0, MAX_TEXT); }

  function fill(line, email) {
    return String(line).replace('{email}', email || '');
  }

  /* localStorage can throw outright in a private window or with site data
     blocked, so every read and write is wrapped. */
  function readToken() {
    try { return window.localStorage.getItem(TOKEN_KEY) || null; } catch (e) { return null; }
  }
  function writeToken(v) {
    try { window.localStorage.setItem(TOKEN_KEY, v); } catch (e) { /* nothing */ }
  }
  function dropToken() {
    try { window.localStorage.removeItem(TOKEN_KEY); } catch (e) { /* nothing */ }
  }

  /* ------------------------------------------- what this browser has been shown
   *
   * `sp-chat-seen` is one small object, `{ t, seen, hid }`, and it belongs to ONE
   * chat: `t` is the token it was written for. A different token reads as nothing,
   * which is what starts a new chat with a clean slate - no tidying up to
   * remember, and a chat that ended cannot leave a figure behind that silences
   * the next one's first reply.
   *
   * `seen` is the newest team message the panel has been open for. `hid` is the
   * one whose card was crossed off: the card does not come back for it, and the
   * dot is left alone, because the cross puts the CARD away and the customer has
   * still not read the message.
   *
   * EVERY READ AND WRITE IS WRAPPED, the storage call and the JSON both, exactly
   * as the history list's are: a private window and blocked site data each throw
   * outright, and a stored string can be anything. None of it may ever be the
   * reason a reply is not shown, so every failure reads as "nothing seen yet",
   * which shows the card rather than hiding it.
   */
  function readSeen() {
    var raw = null;
    if (S.practice) {
      raw = S.practiceSeen;
    } else {
      try { raw = window.localStorage.getItem(SEEN_KEY); } catch (e) { raw = null; }
    }
    S.seen = 0;
    S.hid = 0;
    if (!raw) return;
    var o = null;
    try { o = JSON.parse(raw); } catch (e) { return; }
    if (!o || o.t !== S.token) return;
    S.seen = whole(o.seen);
    S.hid = whole(o.hid);
  }

  function writeSeen() {
    if (!S.token) return;
    var raw = JSON.stringify({ t: S.token, seen: S.seen, hid: S.hid });
    if (S.practice) { S.practiceSeen = raw; return; }
    try { window.localStorage.setItem(SEEN_KEY, raw); } catch (e) { /* nothing */ }
  }

  /* A whole number at least zero, whatever was stored. */
  function whole(v) {
    var n = parseInt(v, 10);
    return (isNaN(n) || n < 0) ? 0 : n;
  }

  /* THE CHAT WAS OPENED (shop-chat v11, migration 1765, 27 October 2026). The
     dashboard's funnel starts at "Chat opened", and nothing could count it: a
     conversation only exists once somebody writes, so a visitor who opened the
     chat, looked and left was invisible. Lorenzo chose to record it ("Yes, on a
     theme copy").

     ONE KEY PER VISIT, made here: 32 random hex characters, kept in
     sessionStorage, so opening and closing the chat on five pages of one visit is
     ONE open - and the first page it was opened on is the one the dashboard
     keeps. It is not a cookie, it is not kept after the tab closes, and it names
     nobody: the server keeps the moment, the kind of chat and the page, and no
     IP address or browser string.

     The same key rides on `start` (and `orders_start`), and the server joins the
     open to the conversation it became. Once it has, the key is dropped, so a
     second chat later in the visit is a second open. Practice mode writes
     nothing to the browser, so its key lives in memory only - and practice never
     reaches the server anyway. */
  function newOpenKey() {
    var b = new Uint8Array(16);
    try {
      window.crypto.getRandomValues(b);
    } catch (e) {
      for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
    }
    var s = '';
    for (var j = 0; j < 16; j++) s += (b[j] < 16 ? '0' : '') + b[j].toString(16);
    return s;
  }
  function openKey() {
    if (S.openKey) return S.openKey;
    var k = null;
    if (!S.practice) {
      try { k = window.sessionStorage.getItem(OPEN_KEY); } catch (e) { k = null; }
    }
    if (!k || !/^[0-9a-f]{32}$/.test(k)) {
      k = newOpenKey();
      if (!S.practice) {
        try { window.sessionStorage.setItem(OPEN_KEY, k); } catch (e) { /* nothing */ }
      }
    }
    S.openKey = k;
    return k;
  }
  function dropOpenKey() {
    S.openKey = null;
    try { window.sessionStorage.removeItem(OPEN_KEY); } catch (e) { /* nothing */ }
  }
  /* Once per page load, and only when no conversation is in hand: a customer
     coming back to a chat they are already having is not opening a new one.
     Nothing waits for it and nothing is said if it fails - it is a count, and
     the chat must work exactly the same without it. */
  function reportOpen() {
    if (S.openReported || S.token || S.resuming) return;
    S.openReported = true;
    api('opened', { open: openKey(), flow: S.kind, page: location.href })
      .catch(function () { /* a count, never a fault the customer sees */ });
  }

  /* ------------------------------------------- the chats this browser started
   *
   * A small list under `sp-chat-history`, newest first, about twenty of them:
   * { token, flow_key, started_at }. The token is the only thing that opens a
   * chat, and only this browser has these, so no proof of identity is asked for
   * or possible - which is also why "Remove from this device" exists.
   *
   * EVERY READ AND WRITE IS WRAPPED, both the storage call and the JSON: a
   * private window and blocked site data each throw outright, and a stored
   * string can be anything. A list of past chats is a convenience and must
   * never be the reason the chat itself does not open.
   *
   * PRACTICE MODE TOUCHES NOTHING. It answers from an invented list held in
   * memory, so the preview can show the screen without writing to the browser
   * the preview is being looked at in.
   */
  function readHistory() {
    if (S.practice) return S.practiceHistory || [];
    var raw = null;
    try { raw = window.localStorage.getItem(HISTORY_KEY); } catch (e) { return []; }
    if (!raw) return [];
    var list = null;
    try { list = JSON.parse(raw); } catch (e) { return []; }
    if (!list || typeof list.length !== 'number') return [];
    var out = [];
    for (var i = 0; i < list.length && out.length < HISTORY_MAX; i++) {
      var x = list[i];
      if (x && typeof x.token === 'string' && x.token) {
        out.push({
          token: x.token,
          flow_key: String(x.flow_key || ''),
          started_at: x.started_at || null
        });
      }
    }
    return out;
  }

  function writeHistory(list) {
    var kept = (list || []).slice(0, HISTORY_MAX);
    if (S.practice) { S.practiceHistory = kept; return; }
    try {
      window.localStorage.setItem(HISTORY_KEY, JSON.stringify(kept));
    } catch (e) { /* nothing */ }
  }

  /* Newest first, and never the same token twice. */
  function pushHistory(token, flowKey) {
    if (!token) return;
    var list = readHistory().filter(function (x) { return x.token !== token; });
    list.unshift({
      token: token,
      flow_key: String(flowKey || ''),
      started_at: new Date().toISOString()
    });
    writeHistory(list);
  }

  /* One chat off this device's list: used when the SERVER says that token is
     not a chat any more, so a row that cannot open is not left sitting there. */
  function forgetOne(token) {
    writeHistory(readHistory().filter(function (x) { return x.token !== token; }));
    if (readToken() === token) dropToken();
  }

  function clearHistory() {
    if (S.practice) { S.practiceHistory = []; return; }
    try { window.localStorage.removeItem(HISTORY_KEY); } catch (e) { /* nothing */ }
  }

  /* NO FONT IS FETCHED HERE ANY MORE. It used to pull Inter from Google Fonts
     the first time the chat was opened. The chat now takes the shop's own type -
     Poppins, through the theme's `--typeBasePrimary` - which is already on every
     page of the site, so there is nothing left to load and nothing to wait for.
     See the font note in sp-chat.css. */

  /* ---------------------------------------------------------- the server call */

  /* ONE door. Every POST to the function goes through here, so there is one
     place that knows about credentials, JSON and what an error looks like. */
  function api(action, payload) {
    if (S.practice) return practiceApi(action, payload);
    var body = { action: action };
    for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) body[k] = payload[k];
    return fetch(S.fnUrl, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : {}; } catch (e) { data = null; }
        if (!res.ok || !data || data.error) {
          var e2 = new Error((data && data.error) || ('shop-chat ' + action + ' ' + res.status));
          e2.status = res.status;
          /* The server answers a REFUSAL - a wrong code, say - with 400 and a body
             that names it ({ok:false, state:'bad_code'}). That is an answer, not a
             fault, so the body travels with the error and a caller that expects a
             refusal can read it. (Found 25 Oct 2026: practice mode resolves
             refusals, so a wrong code passed every practice test and would have
             said "Something went wrong" against the real server.) */
          e2.data = data;
          throw e2;
        }
        return data;
      });
    });
  }

  /* PRACTICE MODE. No server is called at all: every action is answered here.
     It is on when the page says so (the preview forces it) or when the address
     carries ?sp_chat_practice=online or =offline. */
  function practiceApi(action, payload) {
    return new Promise(function (resolve) {
      window.setTimeout(function () {
        resolve(practiceAnswer(action, payload));
      }, PRACTICE_WAIT_MS);
    });
  }

  /* A PRACTISED COLLEAGUE TYPES BEFORE THEY REPLY (30 October 2026), so a practice
     run shows the three dots the way the shop does: the dots go up about two
     seconds before the made-up reply lands and are taken down by the reply itself.
     It is the one practice behaviour the three reply paths below share, written
     once here so they cannot come to disagree. THE REAL SHOP READS `team_typing`
     off chat_poll (migration 1853) and never this. */
  function practiceReplySoon() {
    window.setTimeout(function () { S.practiceTyping = true; }, PRACTICE_TYPING_MS);
    window.setTimeout(function () {
      S.practiceTyping = false;
      S.practiceQueue.push({
        id: ++S.practiceId,
        sender: 'team',
        name: PRACTICE_REPLY_NAME,
        body: PRACTICE_REPLY_BODY,
        created_at: new Date().toISOString()
      });
      S.status = 'live';
    }, PRACTICE_REPLY_MS);
  }

  function practiceAnswer(action, p) {
    var online = S.practice === 'online';
    /* `status` IS ASKED ABOUT ONE FLOW now, and practice answers per flow. ONE
       FLOW ALWAYS ANSWERS "nobody online" even in the online mode - the flow
       file's `live.practice_offline_flow` - so the preview can show the greeting
       and the questions side by side instead of one or the other. It is written
       on the preview page. The real shop reads the switches and never this. */
    if (action === 'status') {
      var asked = String((p && p.flow) || '');
      /* THE OPENING HOURS COME BACK TOO since shop-chat v10, because the offline
         sentence is written from them. A practice run has no server to read Chat
         settings, so the flow file carries a copy of what they hold today
         (`offline.practice_hours`), named there as the preview's and not the
         shop's. With none, the widget says the shorter sentence - which is also
         what it would do against an older shop-chat. */
      var hours = offlineData().practice_hours || null;
      if (online && asked && asked === liveData().practice_offline_flow) {
        return { online: false, hours: hours };
      }
      return { online: online, hours: hours };
    }
    /* `start` CARRIES `live` BACK, because the server decides live mode and not
       the browser. Practice answers it the same way `status` just did, so the
       two cannot disagree in the preview. */
    if (action === 'start') {
      var out = { token: 'practice-' + Date.now().toString(16) };
      if (p && p.live === true) {
        out.live = online && String(p.flow || '') !== liveData().practice_offline_flow;
      }
      return out;
    }
    /* THE FIRST MESSAGE OF A LIVE CHAT, practised: it goes to `waiting` and a
       made-up reply follows after about four seconds, exactly as a practice
       `finish` does while somebody is online. No email is queued anywhere,
       because practice calls no server at all. */
    if (action === 'live_message') {
      S.status = 'waiting';
      /* ONE SIGNPOSTED MESSAGE SHOWS THE OTHER ENDING. The five minutes with no
         reply is the minute check on the SERVER, which a practice run has none
         of - so a first message of exactly "missed" practises that instead of
         the reply: the chat is told "Sorry we missed you..." and asked for an
         email, which is the one thing a live chat ever asks for. It is written
         on the preview page, like the three codes and refuse@example.com. */
      var missed = String((p && p.text) || '').trim().toLowerCase() === 'missed';
      if (missed) {
        window.setTimeout(function () {
          S.practiceAskEmail = true;
          S.practiceQueue.push({
            id: ++S.practiceId,
            sender: 'system',
            name: null,
            body: (F.live && F.live.missed) || '',
            created_at: new Date().toISOString()
          });
        }, PRACTICE_REPLY_MS);
      } else {
        practiceReplySoon();
      }
      return { ok: true, status: 'waiting', mode: 'live', notified: true };
    }
    if (action === 'answer') return { ok: true };
    if (action === 'upload_urls') {
      return {
        uploads: (p.files || []).map(function (f, i) {
          /* no signed_url: practice keeps the file in the browser and PUTs nothing */
          return { path: 'practice/' + i + '-' + f.name, signed_url: null };
        })
      };
    }
    if (action === 'uploaded') return { ok: true };
    /* A MESSAGE WITH FILES ON IT, PRACTISED (28 October 2026). No server, so no path is
       checked and no object exists: the chosen file never left the browser (see
       `upload_urls` above, which answers with no signed_url). What this DOES practise is
       the chat's own behaviour, which is the thing being looked at - and that behaviour
       depends on where the chat is, exactly as chat_customer_files decides from the
       chat's own state.
         * still answering and somebody is online - the first message of a live chat, so
           it is the handover: `waiting`, and a made-up reply after about four seconds,
           the same as a practice `live_message`;
         * still answering and nobody is online - the offline chat's first answer, which
           changes nothing and is followed by the email question;
         * waiting or live - one more message, and no reply.
       `said` IS WHAT THE SERVER WOULD HAVE WRITTEN as the body of a message with no
       words. Practice answers it so the preview is reading the same shape the shop
       answers, not a shorter one. */
    if (action === 'send_files') {
      var sfFiles = (p && p.files) || [];
      var sfText = String((p && p.text) || '').trim();
      var sfSaid = sfText || filesSaid(sfFiles);
      if (S.status === 'answering' && online && S.live) {
        S.status = 'waiting';
        practiceReplySoon();
        return {
          ok: true, id: ++S.practiceId, status: 'waiting', mode: 'live',
          notified: true, said: sfSaid
        };
      }
      return { ok: true, id: ++S.practiceId, status: S.status, said: sfSaid };
    }
    /* THE EMAIL AND THE PHONE AT THE END OF A FLOW, practised. The browser has
       already checked the shape of both, so nothing malformed reaches here. TWO
       SIGNPOSTED ANSWERS let the preview show the SERVER'S own refusals, which
       the browser's own checks would otherwise hide: the address
       `refuse@example.com` comes back `bad_email`, and the number `0000000`
       comes back `bad_phone`. They are written on the preview page. */
    if (action === 'contact') {
      var pEmail = String((p && p.email) || '');
      var pPhone = p && p.phone ? String(p.phone) : null;
      if (pEmail.toLowerCase() === 'refuse@example.com') {
        return { ok: false, state: 'bad_email' };
      }
      if (pPhone && pPhone.replace(/\D/g, '') === '0000000') {
        return { ok: false, state: 'bad_phone' };
      }
      /* An address given at the end of a live chat is what the server was
         waiting for, so it stops asking - exactly as `ask_email` turns false by
         itself once chat_contact records one. */
      S.practiceAskEmail = false;
      return { ok: true };
    }
    if (action === 'finish') {
      if (online) {
        S.status = 'waiting';
        practiceReplySoon();
      } else {
        S.status = 'emailed';
      }
      return { mode: online ? 'live' : 'email' };
    }
    if (action === 'send') {
      /* A MESSAGE ON AN ENDED CHAT REOPENS IT, practised (1829). The server
         decides and answers `reopened`, so practice answers it the same way and
         from the practised chat's own state - which is how the preview can show
         the line that says somebody will be with them. A message on a chat that
         is already open gets no practice reply, as it always has. */
      if (S.status === 'emailed' || S.status === 'closed') {
        S.status = 'waiting';
        if (online) practiceReplySoon();
        return { ok: true, id: ++S.practiceId, status: 'waiting', reopened: true };
      }
      return { ok: true, id: ++S.practiceId };
    }
    if (action === 'poll') {
      var queued = S.practiceQueue;
      S.practiceQueue = [];
      /* `ask_email` is the server's own fact (migration 1747), and `team_typing`
         is chat_poll's since 1853. Practice answers both from its own state:
         `ask_email` for the signposted "missed" message above, and `team_typing`
         while the practised colleague is "typing" - see practiceReplySoon. */
      return {
        status: S.status,
        messages: queued,
        ask_email: !!S.practiceAskEmail,
        team_typing: !!S.practiceTyping
      };
    }
    if (action === 'resume') {
      /* One of the invented PAST chats, if that is the token being asked about:
         the preview has to be able to open one and see a whole conversation. */
      var kept = practiceEntry('token', p && p.token);
      if (kept) return kept.transcript;
      return { status: S.status, messages: [] };
    }
    if (action === 'history_list') {
      return { ok: true, history: practiceServerHistory() };
    }
    if (action === 'history_view') {
      var seen = practiceEntry('id', p && p.conversation_id);
      if (!seen) return { ok: false, state: 'not_yours' };
      var copy = {};
      for (var key in seen.transcript) {
        if (Object.prototype.hasOwnProperty.call(seen.transcript, key)) {
          copy[key] = seen.transcript[key];
        }
      }
      copy.read_only = true;
      copy.conversation_id = seen.id;
      return copy;
    }

    /* ORDER MANAGEMENT, practised. Three invented orders come from the flow
       file, and ANY 6-DIGIT CODE IS ACCEPTED - except three signposted ones, so
       the preview can also show what a wrong, an expired and a stopped code look
       like. They are written on the preview page itself:
         000000 wrong, 000001 run out, 000002 too many tries. */
    if (action === 'orders_start') {
      S.status = 'answering';
      return { ok: true, token: 'practice-' + Date.now().toString(16) };
    }
    if (action === 'orders_resend') return { ok: true };
    if (action === 'orders_verify') {
      var code = String((p && p.code) || '');
      if (code === '000000') return { ok: false, state: 'bad_code' };
      if (code === '000001') return { ok: false, state: 'expired' };
      if (code === '000002') return { ok: false, state: 'locked' };
      if (!/^\d{6}$/.test(code)) return { ok: false, state: 'bad_code' };
      return {
        ok: true,
        orders: F.practiceOrders(Date.now()),
        history: practiceServerHistory()
      };
    }
    if (action === 'orders_list') return { ok: true, orders: S.orders || F.practiceOrders(Date.now()) };
    if (action === 'order_choose') {
      var want = (S.orders || []).filter(function (o) { return o.id === p.order_id; })[0];
      return want ? { ok: true, order: want } : { ok: false, error: 'no such order' };
    }
    if (action === 'orders_done') {
      S.status = 'closed';
      return { ok: true };
    }
    return {};
  }

  /* The invented past chats, as a practice run sees them. They are made once per
     page load from the flow file, so the dates never go stale, and they are kept
     in memory only - practice mode writes nothing to the browser. */
  function practiceChats() {
    if (!F.practiceHistory) return [];
    if (!S.practiceStore) S.practiceStore = F.practiceHistory(Date.now());
    return S.practiceStore;
  }

  function practiceEntry(key, value) {
    var all = practiceChats();
    for (var i = 0; i < all.length; i++) {
      if (String(all[i][key]) === String(value)) return all[i];
    }
    return null;
  }

  /* The shape the SERVER sends after the code: no tokens in it, because on
     another device there are none to have. */
  function practiceServerHistory() {
    return practiceChats().map(function (x) {
      return {
        id: x.id,
        flow_key: x.flow_key,
        started_at: x.started_at,
        status: x.status,
        last_at: x.last_at
      };
    });
  }

  /* And the shape THIS BROWSER would have kept: just the token, the flow and
     when it started. */
  function practiceOwnHistory() {
    return practiceChats().map(function (x) {
      return { token: x.token, flow_key: x.flow_key, started_at: x.started_at };
    });
  }

  /* ------------------------------------------------------------ building it */

  function build() {
    var root = S.root;
    root.classList.add('sp-chat');
    root.innerHTML = '';

    D.launcher = el('button', 'sp-chat-launcher');
    D.launcher.type = 'button';
    D.launcher.setAttribute('aria-label', F.ui.open);
    D.launcher.setAttribute('aria-expanded', 'false');
    D.launcher.appendChild(iconChat());
    D.dot = el('span', 'sp-chat-launcher-dot');
    D.dot.hidden = true;
    D.launcher.appendChild(D.dot);
    D.launcher.addEventListener('click', function () {
      if (S.open) closeChat(); else openChat();
    });

    /* THE REPLY CARD, built empty and hidden, once. It is drawn before the panel
       so it sits under it in the stacking order as well as behind it in the
       markup - it is never on screen at the same time as the panel, and that is
       two ways of saying so rather than one. */
    D.card = el('div', 'sp-chat-card');
    D.card.hidden = true;
    D.cardMain = el('button', 'sp-chat-card-main');
    D.cardMain.type = 'button';
    D.cardName = el('span', 'sp-chat-card-name');
    D.cardBody = el('span', 'sp-chat-card-body');
    D.cardMain.appendChild(D.cardName);
    D.cardMain.appendChild(D.cardBody);
    /* THE WHOLE FACE OF IT OPENS THE CHAT. openChat puts the card and the dot
       away itself, so there is nothing to undo here. */
    D.cardMain.addEventListener('click', function () { openChat(); });
    D.cardX = el('button', 'sp-chat-card-x');
    D.cardX.type = 'button';
    D.cardX.setAttribute('aria-label', F.ui.reply_card_hide);
    D.cardX.title = F.ui.reply_card_hide;
    D.cardX.appendChild(iconClose());
    /* THE CROSS PUTS THE CARD AWAY AND LEAVES THE DOT. It also records which
       message it was, so the card does not come back on the next page. */
    D.cardX.addEventListener('click', function () {
      S.hid = Math.max(S.hid, S.cardId);
      writeSeen();
      hideCard();
    });
    D.card.appendChild(D.cardMain);
    D.card.appendChild(D.cardX);
    root.appendChild(D.card);

    /* The one thing a screen reader is told, politely, with no focus moved. */
    D.say = el('span', 'sp-chat-say');
    D.say.setAttribute('role', 'status');
    D.say.setAttribute('aria-live', 'polite');
    root.appendChild(D.say);

    D.panel = el('div', 'sp-chat-panel');
    D.panel.hidden = true;
    D.panel.setAttribute('role', 'dialog');
    D.panel.setAttribute('aria-modal', 'true');
    D.panel.setAttribute('aria-label', F.home.title);
    D.panel.setAttribute('tabindex', '-1');

    /* THE HEADER BAR LORENZO DREW (27 October 2026): a near-black bar with the
       round logo on the left, a thin upright divider, then "Chat with us" in white
       with a small mark and one word under it saying whether anybody is there, and
       the close cross on the right.
       THERE IS NO BACK ARROW. It led to the home screen, and there is no home
       screen any more, so it is not drawn at all rather than drawn and disabled.
       NO NEW WORDS EXCEPT THOSE TWO: the title is `ui.home_title`, the same words
       the launcher carries, and the state is `ui.online` / `ui.offline`. */
    var head = el('div', 'sp-chat-header');

    /* NO `src` HERE: openChat sets it, so a visitor who never opens the chat does
       not download the logo (31.8 KB on every page, measured 30 Oct 2026).
       `loading = 'lazy'` does not do this: Edge fetched it anyway. */
    D.headLogo = el('img', 'sp-chat-head-logo');
    D.headLogo.alt = '';
    D.headLogo.setAttribute('aria-hidden', 'true');
    D.headLogo.width = 32;
    D.headLogo.height = 32;
    if (!S.logoUrl) D.headLogo.hidden = true;

    /* The divider between the logo and the words, exactly as his picture has it.
       It is decoration, so a reader is not told about it. */
    D.headRule = el('span', 'sp-chat-head-rule');
    D.headRule.setAttribute('aria-hidden', 'true');

    /* the title is said once, by the panel's own aria-label, so this copy is
       hidden from a reader rather than read out a second time */
    var headWords = el('div', 'sp-chat-head-words');
    D.headTitle = el('span', 'sp-chat-head-title', F.home.title);
    D.headTitle.setAttribute('aria-hidden', 'true');

    /* WHETHER ANYBODY IS THERE, in one word with a mark before it. The mark's
       colour is the only thing that changes besides the word; the word carries the
       meaning on its own, so nothing here depends on seeing a colour.
       `aria-live` is polite because this can change while the panel is open - a
       status answer arriving, or a stale "online" turning out not to be. */
    D.headState = el('div', 'sp-chat-head-state');
    D.headState.setAttribute('aria-live', 'polite');
    D.stateDot = el('span', 'sp-chat-state-dot');
    D.stateWord = el('span', 'sp-chat-state-word');
    D.headState.appendChild(D.stateDot);
    D.headState.appendChild(D.stateWord);
    D.headState.hidden = true;             /* until `status` has answered */

    headWords.appendChild(D.headTitle);
    headWords.appendChild(D.headState);

    D.badge = el('span', 'sp-chat-practice-badge', F.ui.practice);
    D.badge.hidden = true;

    var spacer = el('div', 'sp-chat-header-spacer');

    D.close = el('button', 'sp-chat-round');
    D.close.type = 'button';
    D.close.setAttribute('aria-label', F.ui.close);
    D.close.appendChild(iconClose());
    D.close.addEventListener('click', closeChat);

    head.appendChild(D.headLogo);
    head.appendChild(D.headRule);
    head.appendChild(headWords);
    head.appendChild(D.badge);
    head.appendChild(spacer);
    head.appendChild(D.close);

    /* body: the conversation, and nothing else. THE HOME SCREEN IS NOT BUILT AT
       ALL (27 October 2026) - not built and hidden, not built. `D.home`,
       `D.history` and `D.flowlist` are therefore undefined, and the functions that
       drew them say so and return. That is the difference between a screen that
       is switched off and a screen that is gone. */
    D.body = el('div', 'sp-chat-body');

    D.convo = el('div', 'sp-chat-convo');
    D.convo.hidden = true;
    D.log = el('div', 'sp-chat-log');
    /* new lines are announced; nothing here is ever re-written in place, only
       appended, so a reader is told once */
    D.log.setAttribute('aria-live', 'polite');
    D.log.setAttribute('role', 'log');
    D.convo.appendChild(D.log);

    D.body.appendChild(D.convo);

    /* foot: whatever is being asked for, and nothing under it - the Privacy
       link went on 28 October 2026 (see the top of this file) */
    var foot = el('div', 'sp-chat-foot');
    D.compose = el('div', 'sp-chat-compose');
    foot.appendChild(D.compose);

    D.panel.appendChild(head);
    D.panel.appendChild(D.body);
    D.panel.appendChild(foot);

    root.appendChild(D.launcher);
    root.appendChild(D.panel);

    /* renderFlowList() and renderHistory() used to run here. There is nothing for
       either to draw into any more; both now return at once. */
    pinToBottom();
  }

  /* NOT REACHED SINCE 27 OCTOBER 2026: the big logo belonged to the home screen,
     and the header's own small one is built in build(). The bubble avatar is built
     in addTeam. */
  function logoImg() {
    var img = el('img', 'sp-chat-logo');
    img.src = S.logoUrl;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.width = 108;
    img.height = 108;
    if (!S.logoUrl) img.hidden = true;
    return img;
  }

  /* One option row: the label, and the chevron on the right that says it opens
     something - the ring product page's folding cards, which is what the home
     screen is drawn as now. */
  function flowRow(cls, label, iconName) {
    var b = el('button', cls);
    b.type = 'button';
    var icon = iconFor(iconName);
    if (icon) {
      var mark = el('span', 'sp-chat-flow-icon');
      mark.appendChild(icon);
      b.appendChild(mark);
    }
    b.appendChild(el('span', 'sp-chat-flow-label', label));
    var chev = el('span', 'sp-chat-flow-chev');
    chev.appendChild(iconChevron());
    b.appendChild(chev);
    return b;
  }

  /* Whether the order row is offered at all: the flow file's `show_orders`,
     false since 25 October 2026 on Lorenzo's word. Anything but an explicit
     false shows it, so a flow file written before the switch still does. */
  function ordersShown() {
    return !!(F.home.orders && F.flows[F.home.orders] && F.home.show_orders !== false);
  }

  function renderFlowList() {
    /* NOT DRAWN SINCE 27 OCTOBER 2026: build() does not make the list, so there is
       nothing to draw into. Lorenzo chose "Remove them". */
    if (!D.flowlist) return;
    D.flowlist.innerHTML = '';
    /* PAGE MODE HAS NO HOME SCREEN AT ALL - no other flow and no order row -
       so there is nothing to draw. The home screen is never shown on such a
       page; this is here so that it cannot be, even by accident. */
    if (S.pageFlowKey) return;
    var keys = F.home.flows || [];
    for (var i = 0; i < keys.length; i++) {
      (function (key) {
        var flow = F.flows[key];
        if (!flow) return;
        var b = flowRow('sp-chat-flow', flow.label, flow.icon);
        b.addEventListener('click', function () { pickFlow(key); });
        D.flowlist.appendChild(b);
      }(keys[i]));
    }
    /* The order row, UNDER the flow rows, because it is not one of Gorgias's
       question flows: it asks for an email, sends a code and then shows what the
       ERP holds. It is the next row of the same card, divided from the one above
       it by that card's own hairline. NOT DRAWN while the flow file hides it. */
    var orders = ordersShown() && F.flows[F.home.orders];
    if (!orders) return;
    var p = flowRow('sp-chat-flow sp-chat-flow-orders', orders.label);
    p.addEventListener('click', function () { pickOrders(); });
    D.flowlist.appendChild(p);
  }

  /* ------------------------------------------------------ the past chats, drawn
   *
   * ONE DRAWING FOR BOTH WAYS IN. The home screen's list comes out of this
   * browser's localStorage and is opened by its token; the list after the
   * 6-digit code comes from the server and is opened by its conversation id.
   * They carry different keys and the same two facts - which flow it was and
   * when it started - so they are drawn by the same function and look the same.
   */

  /* The flow's own name. A key the flow file no longer knows is drawn as the key
     itself rather than as an empty row, so a flow that is ever renamed leaves
     something a customer can still press. */
  function historyLabel(key) {
    var flow = F.flows[String(key || '')];
    return (flow && flow.label) || String(key || '');
  }

  function historyList(items, onOpen) {
    var wrap = el('div', 'sp-chat-history');
    wrap.appendChild(el('h3', 'sp-chat-history-title', F.ui.previous_chats));
    var list = el('div', 'sp-chat-history-list');
    items.forEach(function (item) {
      var b = el('button', 'sp-chat-hist');
      b.type = 'button';
      b.appendChild(el('span', 'sp-chat-hist-label', historyLabel(item.flow_key)));
      b.appendChild(el('span', 'sp-chat-hist-when', dayWords(item.started_at)));
      b.addEventListener('click', function () { onOpen(item); });
      list.appendChild(b);
    });
    wrap.appendChild(list);
    return wrap;
  }

  /* The home screen's own list, with the quiet way to clear it underneath. */
  function renderHistory() {
    if (!D.history) return;
    D.history.innerHTML = '';
    var items = readHistory();
    D.history.hidden = items.length === 0;
    if (!items.length) return;
    D.history.appendChild(historyList(items, openPast));
    var row = el('div', 'sp-chat-history-foot');
    var forget = el('button', 'sp-chat-quiet', F.ui.forget_device);
    forget.type = 'button';
    forget.addEventListener('click', forgetDevice);
    row.appendChild(forget);
    D.history.appendChild(row);
  }

  /* "Remove from this device". IT DELETES NOTHING ON THE SERVER - the chats are
     still there, and the same customer can still reach them anywhere with the
     6-digit code. It exists because a shared family computer would otherwise
     show the next person somebody's chats, which is the surprise-ring worry
     Lorenzo raised about orders.

     The CURRENT chat's token goes with the list, unless that chat is still
     going: a finished one has nothing to come back to, and leaving its token
     would quietly put it back on the next page. */
  function forgetDevice() {
    clearHistory();
    if (!(S.status === 'answering' || S.status === 'waiting' || S.status === 'live')) {
      dropToken();
    }
    renderHistory();
    focusPanel();
  }

  /* Opening one of THIS BROWSER'S past chats: `resume` by its token.
     - still waiting or live: it opens exactly as it does today, able to type;
     - still part way through the questions (`answering`): it carries on from
       the next question, exactly as it does when carried onto another page.
       Lorenzo, 25 October 2026: start a chat, answer one question, go back to
       the home screen and open it again from "Your previous chats" - "it does
       not allow me continue with it. Its giving me an option to back to start
       only", because this used to draw every chat that was not waiting or live
       as a finished one;
     - anything else: the whole conversation, read only.
     A token the SERVER says is not a chat is dropped from the list rather than
     left as a row that cannot open. A call that simply failed is not: that is a
     bad moment, not a missing chat, so it offers Try again. */
  function openPast(entry) {
    var token = entry && entry.token;
    if (!token) return;
    D.log.innerHTML = '';
    atHome(false);
    clearCompose();
    addMine(historyLabel(entry.flow_key));
    api('resume', { token: token }).then(function (res) {
      var key = (res && (res.flow_key || res.flow)) || entry.flow_key;
      if (!res || !res.status) { forgetOne(token); goHome(); return; }
      if (res.status === 'waiting' || res.status === 'live' || res.status === 'answering') {
        S.token = token;
        S.lastId = 0;
        if (!S.practice) writeToken(token);
        if (key === F.home.orders) redrawOrders(res); else redraw(res);
        return;
      }
      /* A finished chat is not the current one: the token is not written back,
         so the next page shows the home screen and not this. */
      S.token = null;
      stopPoll();
      drawPast(res, key, false);
    }).catch(function (e) {
      if (e && e.data && e.data.state) { forgetOne(token); goHome(); return; }
      composeBackToStart();
      addTrouble(function () { openPast(entry); });
    });
  }

  /* ONE PAST CHAT, READ ONLY. The questions come back from the flow file by step
     id (the server keeps the answers and never the questions), the team's
     replies and the system's lines follow, photos are drawn as their names
     because a signed link is the ERP's business and not the shop's - and there
     is no message box at all, only the way back. */
  function drawPast(res, key, keepOrders) {
    var isOrders = String(key || '') === F.home.orders;
    var flow = F.flows[String(key || '')] || F.flows[F.home.flows[0]];
    var wasLastId = S.lastId;
    S.phase = 'past';
    S.status = (res && res.status) || null;
    S.email = (res && res.email) || '';
    S.phone = (res && res.phone) || null;
    D.log.innerHTML = '';
    atHome(false);
    if (!isPageFlow(String(key || ''))) addMine((flow && flow.label) || String(key || ''));

    var msgs = (res && res.messages) || [];
    var answers = (res && res.answers) || {};
    var loose;
    if (isLiveConvo(res)) {
      /* A LIVE CHAT READ BACK: the greeting, then everything that was said. No
         questions and no email question, because this customer was asked
         neither - and if the server did ask for an address in the end, its own
         system line is in the messages and says so. */
      addAsk(greetingFor(String(key || '')), null);
      drawLiveLines(msgs);
      loose = [];
    } else if (isOrders) {
      /* AN ORDERS CHAT ASKED FOR THE EMAIL FIRST and still does: the 6-digit
         code is sent to it. */
      addAsk(F.strings.email_bold, F.strings.email_italic);
      if (S.email) addMine(S.email);
      loose = drawOrderAnswers(msgs, answers);
    } else {
      /* A QUESTION FLOW ASKED FOR IT LAST: the questions, then the email and the
         phone, then the thank-you. */
      var walked = drawFlowAnswers(flow, msgs, answers);
      drawContactAnswers(res);
      if (walked.atThanks) addAskStep(walked.atThanks);
      loose = walked.loose;
    }
    drawLoose(loose);

    /* Reading an old chat must not move where the CURRENT one has got to. */
    S.lastId = wasLastId;

    clearCompose();
    composeBackToStart(keepOrders ? backToOrdersExtra() : null);
  }

  /* ------------------------------------------------------- opening and closing */

  function openChat() {
    if (S.open) {
      /* Already open and asked to open again - the theme's own
         `GorgiasChat.open()` does this. Nothing to do: the one screen is already
         the one on show. */
      return;
    }
    S.open = true;
    S.unread = false;
    D.dot.hidden = true;
    /* OPENING THE CHAT MARKS EVERYTHING DRAWN AS SEEN, and that is the whole rule
       - not "the card was pressed", because reaching the conversation any other
       way (the launcher, the theme's own link, Escape and back again) reads the
       same replies. The card goes with it, and so does the tab's mark. */
    S.seen = Math.max(S.seen, S.lastTeamId);
    writeSeen();
    hideCard();
    restoreTitle();
    if (S.logoUrl && !D.headLogo.getAttribute('src')) D.headLogo.src = S.logoUrl;
    D.panel.hidden = false;
    D.launcher.setAttribute('aria-expanded', 'true');
    atHome(false);
    /* ONE SCREEN, EVERY TIME (27 October 2026). There is no home screen to go back
       to any more. Closing and reopening shows the conversation they are having,
       because the panel is hidden and shown rather than rebuilt - AND THAT NOW
       INCLUDES ONE THAT HAS ENDED (31 October 2026): its token is kept, so there is
       one chat and reopening shows it. That is what Lorenzo chose ("Their
       conversation", and see ONE CHAT).
       `beginScreen` draws itself once and then does nothing, so reopening never
       draws over a conversation. It WAITS while `resume` is in flight: a chat
       already going must not have a fresh screen started on top of it.
       A CONVERSATION THAT IS ALREADY DRAWN IS ASKED AGAIN INSTEAD, because the
       panel may have been shut since this morning: the header and the offline
       sentence are facts about this minute. A fresh screen is not asked twice -
       beginScreen is asking as it draws. */
    if (!S.resuming) {
      if (S.token) refreshOnline();
      else beginScreen();
    }
    reportOpen();
    if (isPhone()) lockPage(true);
    fitViewport();
    focusPanel();
    scrollDown();
    /* A webfont that is still arriving makes the lines taller after the first
       scroll, which left the newest message just under the box. Scroll again
       once the page's own type has settled. */
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(scrollDown); } catch (e) { /* nothing */ }
    restartPoll();
  }

  function closeChat() {
    if (!S.open) return;
    S.open = false;
    D.panel.hidden = true;
    D.launcher.setAttribute('aria-expanded', 'false');
    lockPage(false);
    restartPoll();
    try { D.launcher.focus({ preventScroll: true }); } catch (e) { D.launcher.focus(); }
  }

  /* ------------------------------------------------------- the reply card
   *
   * See "A REPLY CARD ABOVE THE BUTTON" at the head of this file for why it is
   * here at all. These are the four things it does.
   */

  /* SHOW IT FOR ONE MESSAGE - the newest, when several land together. Everything
     that could say no is asked here, in one place, so the two callers
     (`takePoll` and a resumed conversation) cannot come to disagree:
       - never while the panel is open: they are reading the reply already;
       - never for a message already seen, or one whose card was crossed off;
       - never without a message to show. */
  function showCard(m) {
    if (!m || S.open) return;
    var id = whole(m.id);
    if (!id || id <= S.seen || id <= S.hid) return;
    var words = cardWords(m);
    /* NO WORDS AND NO FILES IS NO CARD. There should be no such reply, and if one
       ever arrives an empty card would be worse than none - and writing "Sent a
       file" over it would be telling the customer something that did not happen.
       The dot is set by the caller either way, so they are still told there is
       something to read. */
    if (!words) return;
    S.cardId = id;
    D.cardName.textContent = cardName(m);
    D.cardBody.textContent = words;
    D.card.hidden = false;
    /* The name and the words, in one sentence, said once. */
    D.say.textContent = D.cardName.textContent + ': ' + D.cardBody.textContent;
  }

  /* WHO REPLIED, exactly as the conversation itself puts it over their words -
     `addTeam` is handed the same `m.name`. A reply with no name on it (the older
     rows have none) falls back to the words the header already carries, so the
     card never has an empty line where a person should be. */
  function cardName(m) {
    return trim(m && m.name) || F.ui.home_title;
  }

  /* THE FIRST PART OF THE REPLY. The card's own CSS cuts it to two lines, so the
     whole body is handed over and the browser decides where it ends - a count of
     characters here would cut a word in half and would not know how wide the
     phone is.
     A REPLY WITH NO WORDS IS A PICTURE OR A FILE, and it gets the line the chat
     already uses for one (`filesSaid`) rather than an empty card. Nothing at all
     comes back empty, and `showCard` then draws no card - see there. */
  function cardWords(m) {
    var body = trim(m && m.body);
    if (body) return body;
    var files = (m && m.attachments) || [];
    if (files.length) return filesSaid(files);
    return '';
  }

  /* PUT THE CARD AWAY. Used by the cross, by opening the chat any other way, and
     by starting again. It says nothing about what has been READ: the dot and the
     stored `seen` are not touched here, which is what lets the cross leave the
     dot on the button. */
  function hideCard() {
    S.cardId = 0;
    if (!D.card) return;
    D.card.hidden = true;
    D.say.textContent = '';
  }

  /* THE BROWSER TAB, while the customer is looking at a different one. The page's
     own title is kept and put back untouched; nothing else writes it. If the tab
     is the one being looked at, this does nothing at all - the card is already on
     screen and the tab needs no mark. */
  function bumpTitle() {
    if (!document.hidden) return;
    if (S.titleWas === null) S.titleWas = document.title;
    S.titleCount++;
    try {
      document.title = '(' + S.titleCount + ') ' + F.ui.tab_new_message
        + ' - ' + S.titleWas;
    } catch (e) { /* nothing */ }
  }

  function restoreTitle() {
    if (S.titleWas === null) return;
    var was = S.titleWas;
    S.titleWas = null;
    S.titleCount = 0;
    try { document.title = was; } catch (e) { /* nothing */ }
  }

  /* The panel itself takes focus, NOT a text box. The panel is a div with
     tabindex="-1": a reader lands in the dialog, and no keyboard opens. */
  function focusPanel() {
    try { D.panel.focus({ preventScroll: true }); } catch (e) {
      try { D.panel.focus(); } catch (e2) { /* nothing */ }
    }
  }

  /* THERE IS ONLY THE CONVERSATION NOW (27 October 2026). Every call that used to
     ask for the home screen gets the conversation instead - the argument is read
     and ignored on purpose, because thirty-odd calls pass it and changing them all
     would be thirty chances to change one wrongly. The home screen is not hidden
     here; it does not exist, so there is nothing to hide. */
  function atHome(/* yes - ignored */) {
    S.view = 'convo';
    D.convo.hidden = false;
    D.panel.classList.remove('sp-chat-at-home');
  }

  function goHome() {
    /* "Home" is a fresh chat on the one screen. */
    reset();
  }

  /* Start again from nothing: used by the back arrow's end-of-chat button and
     by the preview when it switches practice mode. */
  function reset() {
    stopPoll();
    S.token = null;
    S.flow = null;
    S.stepId = null;
    S.phase = 'home';
    S.email = '';
    S.leadSent = false;
    S.leadEventId = null;
    S.liveSoftAsked = false;
    S.phone = null;
    S.contactDone = false;
    /* live mode belongs to one conversation and goes with it: the next one asks
       the server again rather than assuming this one's answer still holds */
    S.live = false;
    S.liveAskedEmail = false;
    S.practiceAskEmail = false;
    S.practiceTyping = false;
    S.status = null;
    S.lastId = 0;
    S.files = [];
    S.practiceId = 0;
    S.practiceQueue = [];
    S.orders = null;
    S.order = null;
    S.verified = false;
    /* `history` is this conversation's copy of the server's list and goes with
       it. THE BROWSER'S OWN LIST IS NOT TOUCHED: it is not part of a chat, it is
       part of the device, and only "Remove from this device" clears it. */
    S.history = null;
    /* A FRESH CHAT HAS SAID NOTHING AND NOBODY IS TYPING IN IT. `typingBox` goes
       with the composer below; `typedAt` belongs to the box that is being thrown
       away, so leaving it would make the first poll of the NEXT chat say somebody
       was typing. */
    S.saidWaiting = false;
    S.typedAt = 0;
    S.typingBox = null;
    /* The offline bubble belongs to the chat being left, and the log below is
       about to be emptied under it. NOTHING HERE LIFTS `resumeFailed`: a fresh box
       over a chat this browser could not read IS the second chat. */
    S.offlineNote = null;
    S.carryTyped = '';
    D.log.innerHTML = '';
    D.compose.innerHTML = '';
    /* START AGAIN IS A FRESH SCREEN OF THE SAME KIND: the header's state and the
       offline sentence are asked for again, because both are facts about this
       minute and the last answer may be minutes old. The kind itself belongs to
       the page and does not change. */
    S.started = false;
    S.onlineNow = false;
    S.hours = null;
    /* A FRESH CHAT HAS NOTHING TO BE TOLD ABOUT. The card and the tab's mark
       belong to the conversation that is being left, and the two remembered ids
       belong to its token, which is already gone. */
    hideCard();
    restoreTitle();
    S.lastTeamId = 0;
    S.seen = 0;
    S.hid = 0;
    atHome(false);
    beginScreen();
  }

  function lockPage(on) {
    var b = document.body;
    if (!b) return;
    if (on) {
      if (S.locked) return;
      S.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.classList.add('sp-chat-page-locked');
      b.style.top = (-S.scrollY) + 'px';
      S.locked = true;
    } else {
      if (!S.locked) return;
      b.classList.remove('sp-chat-page-locked');
      b.style.top = '';
      window.scrollTo(0, S.scrollY);
      S.locked = false;
    }
  }

  /* The iPhone keyboard shrinks the visual viewport without moving the layout
     one, so a fixed panel ends up under the keys. These two custom properties
     put it back on top of them. */
  function fitViewport() {
    var vv = window.visualViewport;
    var style = S.root.style;
    if (!vv || !isPhone() || !S.open) {
      style.removeProperty('--sp-chat-h');
      style.removeProperty('--sp-chat-bottom');
      return;
    }
    style.setProperty('--sp-chat-h', Math.round(vv.height) + 'px');
    var below = window.innerHeight - vv.height - vv.offsetTop;
    style.setProperty('--sp-chat-bottom', Math.max(0, Math.round(below)) + 'px');
  }

  /* ------------------------------------------- the floating Add to cart
   *
   * See "THE FLOATING ADD TO CART" at the head of this file. The theme's own bar
   * is `[data-sp-sticky]`, it is fixed to the foot of a product page on phones and
   * small tablets, and our round button sat on top of it.
   */

  /* 16px of clear air above the top of the bar's Add to cart button. It is the
     theme's own figure for this bar - it lifts Gorgias's old `#chat-button` by the
     same 16px, on Lorenzo's "maybe lift the bubble but a good amount" of 17
     October 2026 - so the chat is not the one thing on the page that chose its own
     gap. */
  var BAR_GAP = 16;

  /* The bar, found once. `null` means this page has none, and then nothing here
     ever looks at anything again.
     IT IS LOOKED UP AGAIN IF IT GOES. The theme's own script moves the bar to
     `document.body` on some pages and throws it away and builds another when a
     section reloads, so holding one node for ever would quietly measure a bar that
     is no longer in the page. */
  function stickyBar() {
    if (S.bar && S.bar.isConnected) return S.bar;
    S.bar = document.querySelector('[data-sp-sticky]');
    return S.bar;
  }

  /* HOW FAR UP THE FOOT OF THE WIDGET HAS TO GO, measured now, in pixels off the
     bottom of the screen. 0 means there is nothing to get out of the way of.
     THE BUTTON IS WHAT IS MEASURED, not the bar: the bar is transparent with a
     strip of empty air above the button (the theme lets taps through it), so its
     own top is 10px higher than anything the customer can see. If the button is
     not there for any reason the bar itself is measured, which gives slightly MORE
     air and never less.
     The figure needs no safe-area inset added to it and must not have one: it is
     read off where the bar actually is, and on a phone the bar is already sitting
     on top of its own inset. */
  function barLift() {
    var bar = stickyBar();
    if (!bar) return 0;
    if (bar.hidden) return 0;
    var cs = window.getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
    var face = bar.querySelector('[data-sp-sticky-btn]') || bar;
    var r = face.getBoundingClientRect();
    if (!r.height) return 0;
    var up = window.innerHeight - r.top;
    if (up <= 0) return 0;                 /* scrolled out of the way somehow */
    return Math.round(up + BAR_GAP);
  }

  /* The one place the lift is written, and it writes to the widget's own root -
     the same custom-property trick `fitViewport` uses for the phone keyboard.
     `.sp-chat-lifted` is what the stylesheet looks for, so with no bar showing
     there is no class and no property, and every rule falls back to exactly what
     it says today. */
  function paintLift() {
    if (!S.root) return;
    watchBar();
    var up = barLift();
    if (!up) {
      S.root.classList.remove('sp-chat-lifted');
      S.root.style.removeProperty('--sp-chat-lift');
      return;
    }
    S.root.style.setProperty('--sp-chat-lift', up + 'px');
    S.root.classList.add('sp-chat-lifted');
  }

  /* ONE LOOK EVERY 50ms AT MOST. Scrolling fires as fast as the phone can, and
     measuring on every one of those would read the layout dozens of times for an
     answer nobody can see change that often.
     A TIMEOUT AND NOT requestAnimationFrame, for two reasons. It is the theme's
     own pattern - `ring-pdp.js` throttles the bar's own show-and-hide with
     `setTimeout(check, 50)`, so the two now look at the page on the same beat
     rather than one of them waiting on a frame the other does not. And a frame
     never comes at all in a tab nobody is looking at: MEASURED on 30 October
     2026, with the browser running the page in the background, the booked frame
     never ran, so the "a look is already booked" flag stayed on and the lift was
     stuck off for the rest of the page's life. A timeout cannot do that. */
  var LIFT_MS = 50;

  function askLift() {
    if (S.liftAsked) return;
    S.liftAsked = true;
    window.setTimeout(function () {
      S.liftAsked = false;
      paintLift();
    }, LIFT_MS);
  }

  /* The observers follow whichever bar is in the page now. A ResizeObserver
     because the bar GROWS once the type and the price have settled - 50px to 73px,
     measured on V5.13.15 at 390x844 - and a MutationObserver because the theme
     shows and hides it with `hidden` and nudges its `style`. */
  function watchBar() {
    var bar = stickyBar();
    if (!bar || bar === S.barWatched) return;
    S.barWatched = bar;
    if (window.ResizeObserver) {
      if (S.barRo) S.barRo.disconnect();
      S.barRo = new window.ResizeObserver(askLift);
      S.barRo.observe(bar);
    }
    if (window.MutationObserver) {
      if (S.barMo) S.barMo.disconnect();
      S.barMo = new window.MutationObserver(askLift);
      S.barMo.observe(bar, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    }
  }

  /* NOTHING IS BOUND ON A PAGE WITH NO SUCH BAR, and that is the fail-safe: the
     bar is in the product page's own markup from the start, hidden or not, so if
     it is not here at boot it is not coming, and a page that is not a product page
     pays nothing at all - no listener, no observer, no measuring. */
  function watchSticky() {
    if (!stickyBar()) return;
    window.addEventListener('scroll', askLift, { passive: true });
    window.addEventListener('resize', askLift);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', askLift);
    }
    /* The webfont arriving is what makes the bar grow, and a ResizeObserver may
       not be there to notice. */
    try {
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(askLift);
    } catch (e) { /* nothing */ }
    paintLift();
  }

  /* Keep the newest line in view. Lines keep growing for a moment after they
     are added (the font arriving, a picture's box, the message box below), so
     a single scroll lands short - 43px short was measured on 25 Oct 2026. The
     body therefore stays PINNED to the bottom while it settles, until the
     customer scrolls up to read something, when it lets go. */
  function scrollDown() {
    S.stick = true;
    window.requestAnimationFrame(function () {
      D.body.scrollTop = D.body.scrollHeight;
    });
  }

  /* FOLLOW THE NEWEST LINE, BUT NEVER PULL THEM DOWN. The difference from
     scrollDown() above is the whole point and it is one line: this does NOT set
     S.stick. So something the customer did not ask for - the three dots arriving
     while they have scrolled up to read what was said ten minutes ago - keeps the
     view exactly where they put it, and only follows the bottom for somebody who
     was already there. */
  function nudgeDown() {
    if (!S.stick) return;
    window.requestAnimationFrame(function () {
      D.body.scrollTop = D.body.scrollHeight;
    });
  }

  function pinToBottom() {
    D.body.addEventListener('scroll', function () {
      S.stick = D.body.scrollHeight - D.body.scrollTop - D.body.clientHeight < 60;
    }, { passive: true });
    if (!window.ResizeObserver) return;
    var ro = new window.ResizeObserver(function () {
      if (S.stick) D.body.scrollTop = D.body.scrollHeight;
    });
    ro.observe(D.log);
    ro.observe(D.body);
  }

  /* --------------------------------------------------------- what is on screen */

  /* A QUESTION: the first line in bold, the second under it. The second line is
     ITALIC AND MUTED unless `style` says 'plain', when it is drawn in the body
     colour and not italic - which is how Gorgias has some of the second lines in
     Use Personal Materials, Create Something Original and Heirloom Gold. Every
     call that passes no style gets italic, so nothing written before this
     existed changed. */
  function addAsk(bold, second, style) {
    var n = el('div', 'sp-chat-ask');
    n.appendChild(el('strong', null, bold));
    if (second) {
      n.appendChild(style === 'plain'
        ? el('span', 'sp-chat-ask-plain', second)
        : el('em', null, second));
    }
    D.log.appendChild(n);
    scrollDown();
    return n;
  }

  /* One step's two lines, with whichever manner the flow file gives its second
     one. Everything that draws a step goes through here, so the live run and
     a chat drawn again cannot come to disagree about an italic. */
  function addAskStep(step) {
    return addAsk(step.bold, step.italic, step.second_style);
  }

  function addMine(text) {
    var row = el('div', 'sp-chat-mine');
    var box = el('div', 'sp-chat-mine-box');
    box.appendChild(el('span', 'sp-chat-mine-text', text));
    row.appendChild(box);
    D.log.appendChild(row);
    scrollDown();
    return row;
  }

  /* WHAT THEY SENT, ON THEIR OWN SIDE. The pictures, and under them the words if
     they typed any - one bubble for one press, because that is what they sent.
     `text` is left out by everything written before 28 October 2026 and by a
     message that carried no words. */
  function addMineFiles(files, text) {
    var row = el('div', 'sp-chat-mine');
    var side = el('div', 'sp-chat-mine-side');
    var box = el('div', 'sp-chat-sent-files');
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      var cell = el('div', 'sp-chat-sent-file');
      if (f.preview) {
        cell.style.backgroundImage = 'url("' + f.preview + '")';
      } else {
        cell.textContent = f.name;
      }
      cell.title = f.name;
      box.appendChild(cell);
    }
    side.appendChild(box);
    if (trim(text)) {
      var words = el('div', 'sp-chat-mine-box');
      words.appendChild(el('span', 'sp-chat-mine-text', text));
      side.appendChild(words);
    }
    row.appendChild(side);
    D.log.appendChild(row);
    scrollDown();
    return row;
  }

  /* THE LINE THE SERVER WRITES FOR A MESSAGE THAT CARRIED FILES AND NO WORDS, worked
     out here as well. It is a MIRROR of chat_files_said in migration 1775, and it is
     here for one job only: a chat drawn again reads its messages back off the server,
     and a file-only message's `body` is that line - which the customer never typed and
     must never be shown as if they had. So a body that is exactly what the files alone
     would have said is not drawn, and a body that says anything else is their words and
     is.
     IF THE TWO EVER DRIFT the cost is one extra line in a redrawn chat reading "Sent a
     photo", and nothing else: nothing is sent, stored or decided from this. */
  function filesSaid(files) {
    var pics = 0;
    var docs = 0;
    for (var i = 0; i < (files || []).length; i++) {
      if (/^image\//i.test(String((files[i] && files[i].type) || ''))) pics++; else docs++;
    }
    var photos = pics === 1 ? 'a photo' : pics + ' photos';
    var others = docs === 1 ? 'a file' : docs + ' files';
    if (pics === 0 && docs === 0) return 'Sent a file';
    if (docs === 0) return 'Sent ' + photos;
    if (pics === 0) return 'Sent ' + others;
    return 'Sent ' + photos + ' and ' + others;
  }

  /* A BUBBLE FROM US, with the round logo as its avatar on the left - the shape
     Lorenzo drew on 27 October 2026 for the offline message. ONE DRAWING FOR
     EVERYTHING WE SAY, so a person's reply and the chat's own opening bubble look
     like the same side of the same conversation. `name` is the team member's first
     name where there is one; the offline bubble has none, exactly as his picture
     has none. */
  function addTeam(name, body) {
    var row = el('div', 'sp-chat-us');
    if (S.logoUrl) {
      var pic = el('img', 'sp-chat-us-logo');
      pic.src = S.logoUrl;
      pic.alt = '';
      pic.setAttribute('aria-hidden', 'true');
      pic.width = 28;
      pic.height = 28;
      row.appendChild(pic);
    }
    var side = el('div', 'sp-chat-us-side');
    if (name) side.appendChild(el('span', 'sp-chat-us-name', name));
    side.appendChild(el('div', 'sp-chat-us-body', body));
    row.appendChild(side);
    D.log.appendChild(row);
    scrollDown();
    return row;
  }

  /* Us, with nothing above the bubble: the offline sentence, and a question put
     back when a chat is drawn again. */
  function addFromUs(text) {
    return addTeam(null, text);
  }

  function addSystem(text) {
    var n = el('div', 'sp-chat-system', text);
    D.log.appendChild(n);
    scrollDown();
    return n;
  }

  /* ================================= THE LINE THAT SAYS SOMEBODY IS COMING
   *
   * Lorenzo, 30 October 2026: *"Can we show a message to the csutomer after they
   * send the first message to say that someone will be with them in a moment,"*.
   * The words are his, in `F.strings.someone_soon`.
   *
   * IT REPLACES A SENTENCE THAT WAS ALREADY THERE, and that is the one thing
   * about this he has to look at. After the first message of a live chat this
   * said `after_thanks_live` - "Someone from our team will reply here in a few
   * minutes.", approved by him on 25 October - so the slot was not empty. Both
   * sentences are his and choosing between them is his, not ours;
   * `after_thanks_live` is still in the flow file, so putting it back is one
   * word. WHAT WAS GENUINELY MISSING, and is what he probably saw: the line is
   * not a message in the database, so it VANISHED on the next page load, and
   * nothing at all was said after a message that reopened an ended chat.
   *
   * THREE RULES, AND THEY ARE ALL READ OFF WHAT IS ON SCREEN:
   *   * ONCE PER WAITING EPISODE. `saidWaiting` is set here and cleared when the
   *     chat ends, so the first message gets it, the second and third do not, and
   *     a chat that is reopened gets it again.
   *   * ONLY WHEN THE SERVER SAYS WE ARE ONLINE. `onlineNow` is the last answer
   *     `status` gave, and `firstMessage` corrects it to false the moment `start`
   *     comes back without `live`. The offline path has its own words and none of
   *     this touches it: promising a person who is not there is the one thing
   *     that cannot be taken back.
   *   * ONLY WHILE THE CHAT IS WAITING OR LIVE. An ended chat is not waiting for
   *     anybody.
   * It is DRAWN AND NEVER WRITTEN, like the offline sentence and the email
   * question: the chat's newest row stays the customer's, which is what the AI
   * reply drafts, the team notice, the Gorgias ticket and the ERP all read.
   */
  function sayWaiting() {
    if (S.saidWaiting) return;
    if (!S.onlineNow) return;
    if (S.status !== 'waiting' && S.status !== 'live') return;
    S.saidWaiting = true;
    addSystem(F.strings.someone_soon);
  }

  /* ============================== ONE CHAT, AND IT SAYS WHETHER WE ARE ON
   *
   * Lorenzo, 31 October 2026: *"We dont need back to start that clears  chat. At
   * the moment there is only one chat the customer has and its the same chat they
   * should see all the time. when they come back and want to have a chat thesame
   * one opens. if we are not online thery still see the same one but this time it
   * tells them we are not online. They come back later and now we are online still
   * the same chat"*.
   *
   * THE SAME SENTENCE A FRESH OFFLINE SCREEN OPENS WITH, and not a new one:
   * `offlineSentence()` is reused exactly as it is, so the words and the hours in
   * them are the ones he already approved. It is DRAWN AND NEVER WRITTEN, like
   * "Someone will be with you in a moment." above - no api call, nothing in the
   * database, so the chat's newest row is still the customer's.
   *
   * ONE BUBBLE, AND IT COMES AND GOES WITH THE ANSWER:
   *   * WE ARE ON: it is taken away, wherever it is. The header has already said
   *     Online by the time this runs, and a bubble under it saying we are away
   *     would be the screen contradicting itself.
   *   * ALREADY IN THE LOG: it is LEFT WHERE IT IS. `parentNode` is the whole test,
   *     so a log that has been emptied under it (every `D.log.innerHTML = ''`)
   *     simply has no bubble and the next answer draws one - the same rule the
   *     typing dots are kept by, and for the same reason: a protection that
   *     depends on being remembered in nine places is not a protection.
   *   * ONLY A CHAT THAT EXISTS. closed, emailed, waiting or live. NOT `answering`
   *     - that chat is still being asked for an address and has the offline
   *     sentence above it already - and not a fresh screen, whose `status` is null
   *     and whose own bubble is screenReady's.
   *   * NOT UNDER THE EMAIL QUESTION. "Sorry we missed you - leave your email" is
   *     already the server telling them nobody came; saying it again in our own
   *     words under their answer box would be two sentences for one fact.
   *     `liveAskedEmail` AND no address is "the box is asking right now": it is set
   *     by redrawOne SYNCHRONOUSLY, before the `status` answer this is called from
   *     arrives, and `sendLiveEmail` is what puts an address on the row.
   * AND THE DOTS STAY LAST. `showTeamTyping(true)` would BUILD them where there
   * were none, so the node is asked for and only MOVED if a colleague is already
   * typing.
   */
  function sayOffline() {
    if (S.onlineNow) {
      if (S.offlineNote && S.offlineNote.parentNode) {
        S.offlineNote.parentNode.removeChild(S.offlineNote);
      }
      S.offlineNote = null;
      return;
    }
    if (S.status !== 'closed' && S.status !== 'emailed'
        && S.status !== 'waiting' && S.status !== 'live') return;
    if (S.liveAskedEmail && !S.email) return;
    if (S.offlineNote && S.offlineNote.parentNode) return;
    S.offlineNote = addFromUs(offlineSentence());
    var dots = teamTypingNode();
    if (dots) D.log.appendChild(dots);
  }

  /* ========================================= SOMEBODY ON OUR SIDE IS TYPING
   *
   * Lorenzo, 30 October 2026: *"When we are typing the customer should see we are
   * typing"*. Three dots in a bubble with the round logo beside it - the same
   * shape a reply arrives in - and NO WORDS AT ALL.
   *
   * THE FACT COMES FROM THE SERVER AND IS NOT WORKED OUT HERE. `chat_poll`
   * answers `team_typing` (migration 1853): true while the chat is waiting or
   * live and somebody stamped `replying_at` within twelve seconds. The twelve is
   * the database's (`chat_team_typing_seconds()`), so the window can be changed
   * without touching a theme.
   *
   * THERE IS NO NODE KEPT IN A VARIABLE, on purpose. The dots are found in the
   * log by their class every time, so the nine places that empty the log
   * (`D.log.innerHTML = ''`) cannot leave a stale reference behind - a cleared log
   * simply has no dots and the next poll builds them. A protection that depends on
   * being remembered in nine places is not a protection.
   */
  function teamTypingNode() {
    return D.log ? D.log.querySelector('.sp-chat-typing') : null;
  }

  function buildTeamTyping() {
    var row = el('div', 'sp-chat-us sp-chat-typing');
    if (S.logoUrl) {
      var pic = el('img', 'sp-chat-us-logo');
      pic.src = S.logoUrl;
      pic.alt = '';
      pic.setAttribute('aria-hidden', 'true');
      pic.width = 28;
      pic.height = 28;
      row.appendChild(pic);
    }
    var side = el('div', 'sp-chat-us-side');
    var bubble = el('div', 'sp-chat-typing-bubble');
    /* NOTHING TO READ ON SCREEN, so a screen reader is given a sentence rather
       than three empty spans. `aria-live: polite` tells it when the dots arrive
       and goes quiet again when they go; `role: status` is what carries the
       label. */
    bubble.setAttribute('role', 'status');
    bubble.setAttribute('aria-live', 'polite');
    bubble.setAttribute('aria-label', (F.ui && F.ui.typing) || '');
    for (var i = 0; i < 3; i++) bubble.appendChild(el('span', 'sp-chat-typing-dot'));
    side.appendChild(bubble);
    row.appendChild(side);
    return row;
  }

  /* On or off, and when on ALWAYS AT THE BOTTOM: appendChild MOVES a node that is
     already in the log, so a reply that arrived in the same poll is drawn above
     the dots rather than under them, with no bookkeeping. */
  function showTeamTyping(on) {
    var node = teamTypingNode();
    if (!on) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      return;
    }
    if (!node) node = buildTeamTyping();
    D.log.appendChild(node);
    nudgeDown();
  }

  /* ============================== THE CUSTOMER IS TYPING, AS THE TEAM SEES IT
   *
   * Lorenzo, 30 October 2026: *"same when the customer is rttype we should see
   * that too"*.
   *
   * THE WORDS TYPED ARE NEVER SENT OR STORED. Nothing but `typing: true` rides on
   * the poll: shop-chat v15 calls chat_customer_typing with the chat's token and
   * nothing else, that function takes no text parameter, and `chat_typing` has no
   * column to hold any. What is recorded is THAT somebody was typing.
   *
   * AND IT COSTS NO EXTRA REQUEST. This is read by the poll that was going to
   * happen anyway, every three seconds while the panel is open. There is no
   * keystroke endpoint, no debounce timer and nothing scheduled.
   *
   * TRUE ONLY WHEN ALL THREE HOLD:
   *   * a key was pressed within the last four seconds (TYPING_FOR_MS);
   *   * the box IS NOT EMPTY NOW - checked at poll time, not at keypress time, so
   *     somebody who types a word and deletes it stops being "typing";
   *   * and the box is STILL ON THE SCREEN. A textarea that has been taken out of
   *     the page keeps its value, so without `isConnected` an email box that was
   *     replaced three steps ago could keep the dots up for ever.
   * The chat's own status is the fourth gate and it is the poll's: polling runs
   * only for a waiting or live chat (see pollWanted), so an ended chat sends
   * nothing at all.
   */
  function customerTyping() {
    if (!S.typedAt || (Date.now() - S.typedAt) > TYPING_FOR_MS) return false;
    var box = S.typingBox;
    if (!box || !trim(box.value)) return false;
    /* isConnected is everywhere this chat already runs; the fallback asks the
       document the same question for anything older. */
    if (typeof box.isConnected === 'boolean') return box.isConnected;
    return !!(document.body && document.body.contains(box));
  }

  /* An automated reply: Gorgias's own answer to an option, or to Track order or
     Return order. It is on the left like a question but it is not asking
     anything, so it is not bold and its LINE BREAKS ARE KEPT - the return reply
     has four paragraphs and an address on a line of its own, and it is read by
     somebody who may have to post a ring to that address. */
  function addBot(text) {
    var n = el('div', 'sp-chat-bot', text);
    D.log.appendChild(n);
    scrollDown();
    return n;
  }

  /* A call failed. Say so calmly, offer the same thing again, and NEVER throw
     away what the customer typed: `again` is the whole step, re-run. */
  function addTrouble(again) {
    var n = el('div', 'sp-chat-trouble');
    n.appendChild(document.createTextNode(F.ui.error));
    var b = el('button', 'sp-chat-retry', F.ui.retry);
    b.type = 'button';
    b.addEventListener('click', function () {
      if (n.parentNode) n.parentNode.removeChild(n);
      again();
    });
    n.appendChild(document.createElement('br'));
    n.appendChild(b);
    D.log.appendChild(n);
    scrollDown();
    return n;
  }

  /* ------------------------------------------------------------ the composers */

  /* THE BOX GOES WITH THE COMPOSER. `typingBox` is forgotten here rather than
     left pointing at a textarea that has been taken off the screen - a detached
     one keeps its value, and the typing mark reads that value. */
  function clearCompose() {
    D.compose.innerHTML = '';
    S.typingBox = null;
  }

  /* The message box. `onSend` gets the text. The box is NEVER focused here.
     `extras` draws quiet buttons under it - see addQuietRow.
     `says` is WHAT THE EMPTY BOX READS, and it is left out everywhere but the
     email question (27 October 2026): a box that asks for one particular thing
     is named after that thing, the way the phone box and the code box already
     are. Nothing puts the ordinary words back afterwards and nothing needs to -
     the composer is cleared and drawn again at every step, so the box after the
     question is a NEW one and carries `F.ui.placeholder` as it always did. */
  /* `wantFiles` PUTS A PAPERCLIP IN THE BOX (28 October 2026), and it is passed only
     by the three boxes that take a MESSAGE: the first one, the first one of a live
     chat, and the one that stays open while the chat is going. It is deliberately NOT
     passed by the email box, the phone box or the code box: a box that asks for one
     particular thing has no business taking a photograph, and `email_label` exists for
     exactly that reason.
     WHAT THE CUSTOMER CHOSE IS SHOWN ABOVE THE BOX, each one with a cross on it, and
     the send button then works with words, with files, or with both. */
  function composeBox(onSend, extras, says, wantFiles) {
    clearCompose();
    var box = el('div', 'sp-chat-box');
    var ta = el('textarea', 'sp-chat-input');
    ta.rows = 1;
    var asks = says || F.ui.placeholder;
    ta.placeholder = asks;
    ta.setAttribute('aria-label', asks);
    ta.maxLength = MAX_TEXT;
    var btn = el('button', 'sp-chat-send');
    btn.type = 'button';
    btn.setAttribute('aria-label', F.ui.send);
    btn.appendChild(iconSend());
    btn.disabled = true;

    var hint = el('div', 'sp-chat-hint');
    hint.hidden = true;

    /* the files chosen and not yet sent, this box's own list */
    var picked = [];
    var thumbs = null;
    var input = null;
    var clip = null;
    var sending = null;

    function grow() {
      ta.style.height = 'auto';
      ta.style.height = Math.min(TEXTAREA_MAX, ta.scrollHeight) + 'px';
    }

    function ready() {
      btn.disabled = !trim(ta.value) && picked.length === 0;
    }

    /* The small pictures of what is about to be sent. A picture shows itself; a PDF
       shows its name, because there is nothing to show. */
    function drawPicked() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      picked.forEach(function (f, i) {
        var cell = el('div', 'sp-chat-pick');
        if (f.preview) cell.style.backgroundImage = 'url("' + f.preview + '")';
        else cell.appendChild(el('span', 'sp-chat-pick-name', f.name));
        cell.title = f.name;
        var x = el('button', 'sp-chat-pick-x', '×');
        x.type = 'button';
        x.setAttribute('aria-label', F.ui.remove_file + ' ' + f.name);
        x.addEventListener('click', function () {
          if (f.preview) { try { URL.revokeObjectURL(f.preview); } catch (e) { /* nothing */ } }
          picked.splice(i, 1);
          /* TAKING ONE OFF ANSWERS THE LINE. "You can send up to 5 files at a time"
             under an empty row reads like a rule being broken by nothing; removing a
             file is the customer doing the thing the line asked for. */
          hint.hidden = true;
          drawPicked();
          ready();
        });
        cell.appendChild(x);
        thumbs.appendChild(cell);
      });
      thumbs.hidden = picked.length === 0;
      scrollDown();
    }

    function drop() {
      picked.forEach(function (f) {
        if (f.preview) { try { URL.revokeObjectURL(f.preview); } catch (e) { /* nothing */ } }
      });
      picked = [];
      drawPicked();
    }

    /* WHAT THE BOX DOES WHILE THE FILES ARE GOING UP. The words and the pictures stay
       exactly where they are - a failure puts the box back and nothing is lost - and
       the one line says what is happening. */
    function busy(on) {
      ta.disabled = !!on;
      btn.disabled = !!on || (!trim(ta.value) && picked.length === 0);
      if (clip) clip.disabled = !!on;
      if (sending) sending.hidden = !on;
      if (on) hint.hidden = true;
      if (thumbs) {
        var xs = thumbs.querySelectorAll('.sp-chat-pick-x');
        for (var i = 0; i < xs.length; i++) xs[i].disabled = !!on;
      }
      scrollDown();
    }

    function go() {
      var text = cap(ta.value);
      if (!text && picked.length === 0) return;
      hint.hidden = true;
      onSend(text, {
        /* the step may refuse it (a bad email): then the words stay put */
        keep: function (message) {
          hint.textContent = message;
          hint.hidden = false;
          btn.disabled = false;
          scrollDown();
        },
        taken: function () {
          ta.value = '';
          grow();
          drop();
          btn.disabled = true;
        },
        /* the files chosen, for a caller that sends them; a copy, so removing one
           after the send started cannot change what is on its way */
        files: picked.slice(),
        /* the box while the files are going up, and back again if they do not */
        busy: busy
      });
    }

    ta.addEventListener('input', function () {
      ready();
      hint.hidden = true;
      grow();
      /* A KEY WAS PRESSED. The TIME is kept and nothing else - THE WORDS TYPED ARE
         NEVER SENT OR STORED. The poll that was going to happen anyway reads this
         clock (see customerTyping) and sends `typing: true` or does not; no
         request is made here, no timer is started, and `ta.value` never leaves
         this browser until the customer presses Send. */
      S.typedAt = Date.now();
    });

    ta.addEventListener('keydown', function (ev) {
      /* Enter sends and Shift+Enter makes a new line - on a desktop. On a phone
         Enter is the keyboard's own return key and makes a new line. */
      if (ev.key === 'Enter' && !ev.shiftKey && !isPhone()) {
        ev.preventDefault();
        go();
      }
    });

    btn.addEventListener('click', go);

    if (wantFiles) {
      thumbs = el('div', 'sp-chat-picks');
      thumbs.hidden = true;

      /* A PLAIN FILE INPUT AND NOTHING CLEVERER, on purpose: on a phone it is the
         browser's own chooser, which is what offers the photo library and the camera,
         and nothing written here could offer either. */
      input = el('input', 'sp-chat-file-input');
      input.type = 'file';
      input.multiple = true;
      input.accept = 'image/*,application/pdf';

      clip = el('button', 'sp-chat-clip');
      clip.type = 'button';
      clip.setAttribute('aria-label', F.ui.attach);
      clip.title = F.ui.attach;
      clip.appendChild(iconClip());

      sending = el('div', 'sp-chat-sending', F.ui.sending);
      sending.hidden = true;

      input.addEventListener('change', function () {
        var chosen = Array.prototype.slice.call(input.files || []);
        hint.hidden = true;
        /* EVERY REFUSAL IS SAID IN WORDS AND THE REST ARE STILL TAKEN. Somebody who
           picks four photographs and a video should send the four. */
        for (var i = 0; i < chosen.length; i++) {
          var file = chosen[i];
          if (!FILE_OK.test(file.type) && file.type !== 'application/pdf') {
            sayHint(hint, F.ui.wrong_file_kind);
            continue;
          }
          if (file.size > MAX_FILE_BYTES) { sayHint(hint, F.ui.file_too_big); continue; }
          if (picked.length >= MAX_FILES) { sayHint(hint, F.ui.too_many_files); break; }
          var preview = null;
          if (FILE_OK.test(file.type)) {
            try { preview = URL.createObjectURL(file); } catch (e) { preview = null; }
          }
          picked.push({
            file: file, name: file.name, type: file.type, size: file.size, preview: preview
          });
        }
        /* cleared so choosing the same picture twice in a row still fires `change` */
        input.value = '';
        drawPicked();
        ready();
      });

      /* The box is NOT focused by this - Lorenzo's standing rule - so pressing the clip
         opens the chooser and no keyboard. */
      clip.addEventListener('click', function () { input.click(); });

      box.appendChild(clip);
      box.classList.add('sp-chat-box-clip');
    }

    box.appendChild(ta);
    box.appendChild(btn);
    if (thumbs) D.compose.appendChild(thumbs);
    D.compose.appendChild(box);
    if (input) D.compose.appendChild(input);
    if (sending) D.compose.appendChild(sending);
    D.compose.appendChild(hint);
    if (extras) addQuietRow(extras);
    /* THE ONE BOX ON THE SCREEN, for the typing mark. Every composeBox sets it -
       the message box, the email box, the code box - and clearCompose forgets it,
       so it is never a box that has gone. The poll only reads it for a chat that
       is waiting or live, which is the only time it is polling at all. */
    S.typingBox = ta;
    scrollDown();
    return { box: box, input: ta, button: btn, hint: hint, files: picked, busy: busy };
  }

  /* `extras` is for the quiet buttons that sit UNDER the pills rather than among
     them - "Back to my orders" is the only one. They are drawn in their own row
     so a way out of the question is never mistaken for an answer to it. */
  function composeChoices(step, onPick, extras) {
    clearCompose();
    var row = el('div', 'sp-chat-choices');
    (step.choices || []).forEach(function (choice) {
      var b = el('button', 'sp-chat-choice', choice.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        clearCompose();
        onPick(choice);
      });
      row.appendChild(b);
    });
    D.compose.appendChild(row);
    if (extras) addQuietRow(extras);
    scrollDown();
  }

  function addQuietRow(extras) {
    var row = el('div', 'sp-chat-quietrow');
    extras.forEach(function (x) {
      var b = el('button', 'sp-chat-quiet', x.label);
      b.type = 'button';
      /* the composer is NOT cleared here: "Send a new code" has to leave the code
         box exactly where it is. Whatever replaces the composer clears it. */
      b.addEventListener('click', function () { x.go(); });
      row.appendChild(b);
    });
    D.compose.appendChild(row);
    return row;
  }

  /* THE PHONE BOX, with Skip beside it. `onDone` gets the number, or null when
     Skip is pressed. A telephone keypad on a phone and the browser's own phone
     autofill - and IT IS NOT FOCUSED, by Lorenzo's standing rule, so no keyboard
     opens until it is pressed. */
  function composePhone(onDone) {
    clearCompose();
    var row = el('div', 'sp-chat-phonerow');
    var box = el('div', 'sp-chat-box sp-chat-phonebox');
    var input = el('input', 'sp-chat-input sp-chat-phone');
    /* a text box, as the design says, with the telephone keypad and autofill
       asked for by `inputmode` and `autocomplete` rather than by `type` - so
       nothing is refused by a browser's own idea of a phone number */
    input.type = 'text';
    input.setAttribute('inputmode', 'tel');
    input.setAttribute('autocomplete', 'tel');
    input.setAttribute('aria-label', F.ui.phone_label);
    input.placeholder = F.ui.phone_label;
    input.maxLength = PHONE_MAX_CHARS;

    var btn = el('button', 'sp-chat-send');
    btn.type = 'button';
    btn.setAttribute('aria-label', F.ui.send);
    btn.appendChild(iconSend());
    btn.disabled = true;

    var hint = el('div', 'sp-chat-hint');
    hint.hidden = true;

    var skip = el('button', 'sp-chat-choice sp-chat-skip', F.ui.skip);
    skip.type = 'button';

    function go() {
      var value = trim(input.value);
      if (!phoneOk(value)) {
        /* the words stay in the box: a mistyped number is corrected, not retyped */
        sayHint(hint, F.ui.bad_phone);
        return;
      }
      clearCompose();
      onDone(value);
    }

    input.addEventListener('input', function () {
      btn.disabled = !trim(input.value);
      hint.hidden = true;
    });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); if (!btn.disabled) go(); }
    });
    btn.addEventListener('click', go);
    skip.addEventListener('click', function () { clearCompose(); onDone(null); });

    box.appendChild(input);
    box.appendChild(btn);
    row.appendChild(box);
    row.appendChild(skip);
    D.compose.appendChild(row);
    D.compose.appendChild(hint);
    scrollDown();
    return { box: box, input: input, button: btn, hint: hint, skip: skip };
  }

  function composeUpload(step, onSend) {
    clearCompose();
    var max = step.max_files || MAX_FILES;
    S.files = [];

    var wrap = el('div', 'sp-chat-upload');
    var thumbs = el('div', 'sp-chat-thumbs');
    var row = el('div', 'sp-chat-upload-row');
    var hint = el('div', 'sp-chat-hint');
    hint.hidden = true;

    var input = el('input', 'sp-chat-file-input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'image/*,application/pdf';

    var pick = el('button', 'sp-chat-plain', F.ui.choose_files);
    pick.type = 'button';
    var send = el('button', 'sp-chat-plain', F.ui.send_files);
    send.type = 'button';
    send.disabled = true;

    function say(message) {
      hint.textContent = message;
      hint.hidden = false;
    }

    function draw() {
      thumbs.innerHTML = '';
      S.files.forEach(function (f, i) {
        var cell = el('div', 'sp-chat-thumb');
        if (f.preview) cell.style.backgroundImage = 'url("' + f.preview + '")';
        var name = el('div', 'sp-chat-thumb-name', f.name);
        cell.appendChild(name);
        var x = el('button', 'sp-chat-thumb-x', '×');
        x.type = 'button';
        x.setAttribute('aria-label', F.ui.remove_file + ' ' + f.name);
        x.addEventListener('click', function () {
          if (f.preview) { try { URL.revokeObjectURL(f.preview); } catch (e) { /* nothing */ } }
          S.files.splice(i, 1);
          draw();
        });
        cell.appendChild(x);
        thumbs.appendChild(cell);
      });
      pick.textContent = S.files.length ? F.ui.add_more : F.ui.choose_files;
      send.disabled = S.files.length === 0;
      scrollDown();
    }

    input.addEventListener('change', function () {
      var chosen = Array.prototype.slice.call(input.files || []);
      hint.hidden = true;
      for (var i = 0; i < chosen.length; i++) {
        var file = chosen[i];
        if (!FILE_OK.test(file.type) && file.type !== 'application/pdf') {
          say(F.ui.wrong_file_kind);
          continue;
        }
        if (file.size > MAX_FILE_BYTES) { say(F.ui.file_too_big); continue; }
        if (S.files.length >= max) { say(F.ui.too_many_files); break; }
        var preview = null;
        if (FILE_OK.test(file.type)) {
          try { preview = URL.createObjectURL(file); } catch (e) { preview = null; }
        }
        S.files.push({
          file: file, name: file.name, type: file.type, size: file.size, preview: preview
        });
      }
      input.value = '';
      draw();
    });

    pick.addEventListener('click', function () { input.click(); });
    send.addEventListener('click', function () {
      if (!S.files.length) return;
      send.disabled = true;
      pick.disabled = true;
      onSend(S.files.slice(), function undo() {
        send.disabled = false;
        pick.disabled = false;
      });
    });

    row.appendChild(pick);
    row.appendChild(send);
    wrap.appendChild(thumbs);
    wrap.appendChild(row);
    wrap.appendChild(input);
    wrap.appendChild(hint);
    D.compose.appendChild(wrap);
    draw();
  }

  /* The way back to the home screen at the end of an emailed chat, and at the
     foot of a past chat drawn read only. `extras` is the quiet row under it -
     "Back to my orders", for a verified customer reading one of their old chats
     who should not have to type the code again to get back to their orders. */
  function composeBackToStart(extras) {
    clearCompose();
    var row = el('div', 'sp-chat-choices');
    var b = el('button', 'sp-chat-plain', F.ui.back);
    b.type = 'button';
    b.addEventListener('click', function () { reset(); focusPanel(); });
    row.appendChild(b);
    D.compose.appendChild(row);
    if (extras) addQuietRow(extras);
    scrollDown();
  }

  /* -------------------------------------------------------------- the flow */

  function questionText(step) {
    return step.italic ? step.bold + '\n' + step.italic : step.bold;
  }

  /* Does this flow have questions to ask? A flow file entry can exist with no
     steps - the wedding ring flow does, deliberately, until Lorenzo gives his
     questions - and page mode is only on for one that has them. */
  function flowHasSteps(flow) {
    return !!(flow && flow.steps && flow.first && flow.steps[flow.first]);
  }

  function pickFlow(key) {
    var flow = F.flows[key];
    if (!flowHasSteps(flow)) return;
    S.flow = flow;
    S.phase = 'flow';
    S.stepId = null;
    S.email = '';
    S.leadSent = false;
    S.leadEventId = null;
    S.liveSoftAsked = false;
    S.phone = null;
    S.contactDone = false;
    D.log.innerHTML = '';
    atHome(false);
    /* The row that was pressed, echoed as the customer's own pill. A PAGE'S OWN
       FLOW WAS NEVER PRESSED - it is not on the home screen - so nothing is put
       in their mouth. See isPageFlow. */
    if (flow.label && !isPageFlow(flow.key)) addMine(flow.label);
    S.live = false;
    S.liveAskedEmail = false;
    askIfLive();
  }

  /* A flow some page opens by itself, through F.pages. Its label names the chat
     in "Your previous chats" and in the ticket, but it is never drawn as the
     customer's opening pill - not when it starts, not when it is picked up
     again after a reload, and not when it is read back as a past chat - because
     the customer never pressed a row for it. Lorenzo named the wedding-dress
     page's flow "Wedding ring" on 25 October 2026; until then it had no label,
     and that alone had kept the pill away. */
  function isPageFlow(key) {
    var pages = F.pages || {};
    for (var path in pages) {
      if (Object.prototype.hasOwnProperty.call(pages, path) && pages[path] === key) return true;
    }
    return false;
  }

  /* ========================================================== ONE SCREEN
   *
   * Lorenzo, 27 October 2026, with two pictures: "All chats on the website should
   * look like this when opened, If offline should say offline and grey insterad of
   * green and leae a message to inform we are going to be back soon."
   *
   * EVERYTHING BELOW IS THE WHOLE CHAT NOW. The header, the conversation and the
   * box. No topic list, no questions, no orders, no past chats.
   */

  /* The step id the first message of an OFFLINE chat is recorded under. It is a
     step id and not a null one on purpose: `answers` is keyed by step, and the
     question kept beside it is the offline sentence the customer actually read, so
     the Gorgias ticket and the ERP both print what we said above what they said.
     The ERP's and the ticket's rules are unchanged - they read whatever step a
     message carries. */
  var FIRST_STEP = 'first_message';

  /* The flow file's offline block. A flow file written before this existed has
     none, and everything below then reads sensible emptiness rather than
     throwing. */
  function offlineData() {
    return (F && F.offline) || {};
  }

  /* ------------------------------------------------- the hours, said in English
   *
   * Lorenzo chose "From Chat settings" for where the hours in the offline message
   * come from, so NOTHING HERE IS A CONSTANT: `status` answers
   * chat_settings.opening_hours and chat_settings.timezone, and these four
   * functions put the words round them. Change the hours on Chat settings and the
   * sentence changes with them.
   *
   * Every piece of wording is in the flow file, so the sentence is still a
   * one-line edit; only the arithmetic is here.
   */

  /* "Monday, Wednesday and Friday", or "Monday-Friday" for a run of three or
     more, or "every day" for all seven. The setting is ISO weekdays, 1 = Monday,
     and whatever order or repeats it holds, this reads them 1 to 7, once each. A
     run of two is said day by day, because "Monday-Tuesday" reads worse than
     "Monday and Tuesday". */
  function dayWordsFor(days) {
    var W = offlineData();
    var names = W.days || [];
    if (!days || typeof days.length !== 'number' || !names.length) return '';
    var seen = {};
    var list = [];
    for (var i = 0; i < days.length; i++) {
      var n = parseInt(days[i], 10);
      if (!(n >= 1 && n <= 7) || seen[n]) continue;
      seen[n] = true;
      list.push(n);
    }
    if (!list.length) return '';
    list.sort(function (a, b) { return a - b; });
    if (list.length === 7) return String(W.every_day || '');
    var items = [];
    var at = 0;
    while (at < list.length) {
      var end = at;
      while (end + 1 < list.length && list[end + 1] === list[end] + 1) end++;
      if (end - at + 1 >= 3) {
        items.push(names[list[at] - 1] + String(W.day_range) + names[list[end] - 1]);
      } else {
        for (var k = at; k <= end; k++) items.push(names[list[k] - 1]);
      }
      at = end + 1;
    }
    return joinWords(items);
  }

  /* "06:00" -> "6 AM", "17:00" -> "5 PM", "17:30" -> "5:30 PM", "00:00" -> "12 AM",
     "12:00" -> "12 PM". A minute of 00 is not said, because "6 AM" is how a person
     writes six o'clock and "6:00 AM" is how a computer does. */
  function clockWords(value) {
    var W = offlineData();
    var m = /^(\d{1,2}):(\d{2})/.exec(String(value === undefined || value === null ? '' : value));
    if (!m) return '';
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (!(h >= 0 && h <= 24) || !(min >= 0 && min <= 59)) return '';
    var half = (h < 12 || h === 24) ? W.am : W.pm;
    var shown = h % 12;
    if (shown === 0) shown = 12;
    return shown + (min ? ':' + (min < 10 ? '0' + min : String(min)) : '') + ' ' + String(half);
  }

  /* Day names, or two windows of hours, joined the way a person would: "A, B and
     C". Both joiners are in the flow file. */
  function joinWords(items) {
    var W = offlineData();
    if (!items || !items.length) return '';
    if (items.length === 1) return items[0];
    return items.slice(0, items.length - 1).join(String(W.join))
      + String(W.join_last) + items[items.length - 1];
  }

  /* One window of the setting: "Monday-Friday, 6 AM-5 PM". A window missing any of
     its three parts is left out altogether rather than half said. */
  function windowWords(win) {
    var W = offlineData();
    if (!win) return '';
    var days = dayWordsFor(win.days);
    var from = clockWords(win.from);
    var to = clockWords(win.to);
    if (!days || !from || !to) return '';
    return days + String(W.day_time) + from + String(W.time_range) + to;
  }

  /* The city the hours are in, from the IANA name's last part:
     "America/New_York" -> "New York", "Europe/London" -> "London". Said because
     the hours are ours and the customer may be anywhere. */
  function zoneWords(tz) {
    var name = String(tz === undefined || tz === null ? '' : tz).trim();
    if (!name) return '';
    var parts = name.split('/');
    return parts[parts.length - 1].replace(/_/g, ' ');
  }

  /* All of it: "Monday-Friday, 6 AM-5 PM (New York time)". Empty when there is
     nothing true to say, which is what sends the sentence to `no_hours`. */
  function hoursWords(hours) {
    var W = offlineData();
    var wins = hours && hours.opening_hours;
    if (!wins || typeof wins.length !== 'number' || !wins.length) return '';
    var parts = [];
    for (var i = 0; i < wins.length; i++) {
      var one = windowWords(wins[i]);
      if (one) parts.push(one);
    }
    if (!parts.length) return '';
    var said = joinWords(parts);
    var zone = zoneWords(hours && hours.timezone);
    if (zone) said += String(W.zone_suffix || '').replace('{zone}', zone);
    return said;
  }

  /* THE ONE BUBBLE AN OFFLINE CHAT OPENS WITH. When the hours cannot be said -
     an empty setting, or an older shop-chat that answers no hours at all - it is
     the shorter sentence, which still says we will come back. It must never read
     as though we had closed for good. */
  function offlineSentence() {
    var W = offlineData();
    var when = hoursWords(S.hours);
    if (!when) return String(W.no_hours || '');
    return String(W.hours || '').replace('{when}', when);
  }

  /* --------------------------------------------------------- the header's state */

  /* "Online" with a green mark, or "Offline" with a grey one. THE WORD CARRIES THE
     MEANING: nothing here needs a colour to be seen. The green class is the one
     the line inside the conversation used to carry, so the token
     `--sp-chat-online` still has exactly one meaning. */
  function setHeadState(online) {
    if (!D.headState) return;
    D.headState.hidden = false;
    D.stateDot.className = 'sp-chat-state-dot '
      + (online ? 'sp-chat-online-dot' : 'sp-chat-offline-dot');
    D.stateWord.textContent = online ? F.ui.online : F.ui.offline;
  }

  /* -------------------------------------------------------------- the screen */

  /* OPENING THE CHAT. Ask whether a chat of this page's kind would be answered
     live this minute, say so in the header, and - when it would not - say when we
     are back. Then the box.
     NOTHING IS OPENED IN THE DATABASE HERE. `start` goes with the first message,
     so somebody who opens the chat and walks away leaves nothing behind.
     A `status` THAT COULD NOT BE READ IS NOT TAKEN AS ONLINE. The offline path
     ends with an address and a Gorgias ticket either way; promising a person who
     is not there is the one thing that cannot be taken back. */
  function beginScreen() {
    if (S.started) return;
    S.started = true;
    /* A CHAT THIS BROWSER COULD NOT READ IS NOT A CHAT THAT IS GONE, so no box is
       drawn over it - see resumeTrouble(). */
    if (S.resumeFailed) { resumeTrouble(); return; }
    S.phase = 'opening';
    S.flow = F.flows[S.kind] || null;
    atHome(false);
    api('status', { flow: S.kind }).then(function (res) {
      screenReady(!!(res && res.online), res && res.hours);
    }).catch(function () {
      screenReady(false, null);
    });
  }

  /* THE RESUME FAILED, SO THERE IS NOTHING TO TYPE INTO (31 October 2026). A
     network that dropped or an answer that could not be read leaves this browser
     holding a token and knowing nothing about it. Drawing the fresh screen's
     message box there is the bug, not the fallback: the first word typed into it
     calls `start`, which opens a SECOND chat and writes its token over the one the
     customer already has. So the screen says the same thing every other bad moment
     in this chat says - Try again - and the press asks about the SAME token again.
     THE LOG IS EMPTIED FIRST, so another failed try shows one Try again and not a
     pile of them, and `started` goes back to false so resumeSettled can draw this
     again. Nothing re-asks by itself: there is no loop without a press. */
  function resumeTrouble() {
    var failed = S.resumeFailed;
    if (!failed) return;
    S.phase = 'resume_failed';
    D.log.innerHTML = '';
    clearCompose();
    atHome(false);
    addTrouble(function () {
      S.started = false;
      resumeToken(failed.token, failed.adopted, 0);
    });
  }

  function screenReady(online, hours) {
    S.onlineNow = !!online;
    S.hours = hours || null;
    setHeadState(S.onlineNow);
    /* ONLINE IS AN EMPTY MESSAGE AREA, which is what Lorenzo's own picture of an
       online chat shows. There is no greeting and no "We're online now" line: the
       header says it in one word, which is where he drew it. */
    if (!S.onlineNow) addFromUs(offlineSentence());
    firstSendBox();
  }

  /* "THEY COME BACK LATER AND NOW WE ARE ONLINE" (31 October 2026 - see ONE CHAT
     above). Whether anybody is on is a fact about this minute, and until today it
     was read ONCE, when the page loaded: a tab left open all afternoon kept
     whatever the answer was that morning, and so did the header.
     IT IS THE `status` CALL THAT ALREADY EXISTS and no new action - the same one
     beginScreen and redrawOne make, asked again at the two moments the customer
     could be looking afresh. NO TIMER: nothing is scheduled, polling is untouched.
     A FAILED ASK CHANGES NOTHING, header included, and `then` is not run - an
     answer that did not arrive must not become a promise either way. */
  function refreshOnline(then) {
    api('status', { flow: S.kind }).then(function (res) {
      if (res && res.hours) S.hours = res.hours;
      S.onlineNow = !!(res && res.online);
      setHeadState(S.onlineNow);
      sayOffline();
      if (then) then();
    }).catch(function () { /* nothing changes: the last answer still stands */ });
  }

  /* The box before anything has been said. It looks exactly like the box
     afterwards, because to the customer it is the same box - except for what it
     says while it is empty. ONLINE it asks "What can we do for you today?"
     (`first_online`, Lorenzo, 27 October 2026); offline it says what every box
     says, under the offline sentence. NOT FOCUSED. */
  function firstSendBox() {
    S.phase = 'first';
    composeBox(function (text, ctl) {
      /* WITH FILES NOTHING IS DRAWN UNTIL THEY HAVE GONE UP. A message of words alone
         is put on screen the moment it is pressed, because it cannot half-arrive; an
         upload can, so the box keeps the words and the pictures and says it is
         sending, and the bubble is drawn when there is something real to draw. */
      if (ctl.files.length) { firstMessage(text, ctl.files, ctl); return; }
      ctl.taken();
      clearCompose();
      addMine(text);
      firstMessage(text);
    }, null, S.onlineNow ? F.ui.first_online : null, true);
  }

  /* THE FIRST MESSAGE OPENS THE CONVERSATION, and which of the two kinds it is is
     the SERVER'S answer and not ours: `live: true` is asked for only when `status`
     said this kind is answered live, and chat_start_live decides. A browser whose
     answer went stale - the last person switched off - is told `live: false`
     and the chat becomes an offline one, which is the only honest ending.
     A token already in hand means `start` went through and something after it did
     not, so the message is carried on from where it stopped rather than opening a
     second conversation. */
  /* `files` AND `ctl` ARE THE PAPERCLIP'S (28 October 2026) and are left out by a
     message of words alone. The conversation is opened here either way, once, before
     anything is uploaded: a signed upload URL is a path under the chat's own folder, so
     there is no folder to upload into until the chat exists. */
  function firstMessage(text, files, ctl) {
    if (S.token) {
      if (S.live) sendFirstLive(text, files, ctl);
      else offlineFirstMessage(text, files, ctl);
      return;
    }
    var ask = { flow: S.kind, page: location.href, open: openKey() };
    if (S.onlineNow) ask.live = true;
    leadAttach(ask);
    if (ctl) ctl.busy(true);
    api('start', ask).then(function (res) {
      S.token = (res && res.token) || null;
      if (!S.token) {
        if (ctl) ctl.busy(false);
        addTrouble(function () { firstMessage(text, files, ctl); });
        return;
      }
      dropOpenKey();
      S.status = 'answering';
      if (!S.practice) writeToken(S.token);
      if (res.live === true) { S.live = true; sendFirstLive(text, files, ctl); return; }
      /* WE SAID ONLINE AND WE ARE NOT. The header is corrected and the offline
         sentence is said now, under what they typed, so they are told why an
         address is about to be asked for rather than simply being asked. It is
         drawn and never written to the chat, so the newest row stays theirs. */
      if (S.onlineNow) {
        S.onlineNow = false;
        setHeadState(false);
        addFromUs(offlineSentence());
      }
      offlineFirstMessage(text, files, ctl);
    }).catch(function () {
      if (ctl) ctl.busy(false);
      addTrouble(function () { firstMessage(text, files, ctl); });
    });
  }

  /* AN OFFLINE CHAT DOES NOT WAIT FOR A PERSON. The message is recorded as the
     chat's first answer, with the offline sentence as its question, because that
     is what the customer read before they typed. Then the address, which is the
     one thing left: Lorenzo chose "After their first message".
     `answer` writes the customer's own row and nothing after it, and the email
     question below is drawn and never written, so a chat's newest row is always
     the customer's - which is what the AI reply drafts require of a chat. */
  function offlineFirstMessage(text, files, ctl) {
    /* WITH FILES IT IS THE SAME ANSWER, UNDER THE SAME QUESTION. `send_files` writes
       one customer message carrying the pictures and the words if there were any, as
       the answer to this step - so an offline chat with a photograph reads in the ERP
       and on the Gorgias ticket exactly as one without reads today. */
    if (files && files.length) {
      sendWithFiles(ctl, text, files,
        { step_id: FIRST_STEP, question: offlineSentence() },
        function () { askOfflineEmail(null); });
      return;
    }
    api('answer', {
      token: S.token,
      step_id: FIRST_STEP,
      question: offlineSentence(),
      value: text
    }).then(function () {
      askOfflineEmail(null);
    }).catch(function () {
      addTrouble(function () { offlineFirstMessage(text); });
    });
  }

  /* THE SAME APPROVED EMAIL QUESTION every other part of this chat asks, in the
     same two lines. NOT FOCUSED. `hint` is set only when the SERVER refused the
     address, so the line is said under the box they are about to type in again. */
  function askOfflineEmail(hint) {
    S.phase = 'offline_email';
    addAsk(F.strings.email_bold, F.strings.email_italic);
    var ctl = composeBox(function (typed, box) {
      var email = typed.trim();
      if (!EMAIL_RE.test(email) || email.length > 254) {
        box.keep(F.ui.bad_email);
        return;
      }
      box.taken();
      clearCompose();
      addMine(email);
      sendOfflineEmail(email);
    }, null, F.ui.email_label);
    if (hint) sayHint(ctl.hint, hint);
  }

  /* The same `contact` call a question flow made at its end, WITH NO PHONE - an
     offline chat is asked for the address and for nothing else. Then `finish`,
     which is where the chat has always become a Gorgias ticket: nobody is on, so
     chat_finish writes `emailed` with `nobody_online` and the customer is told
     "We'll reply to ...". If somebody switched on in between, `finish` says `live`
     and the chat waits for them instead - that is chat_finish's own decision and
     this file does not second-guess it. */
  function sendOfflineEmail(email) {
    api('contact', { token: S.token, email: email, phone: null }).then(function (res) {
      if (res && res.ok === false) { askOfflineEmail(F.ui.bad_email); return; }
      S.email = email;
      S.contactDone = true;
      finishChat();
    }).catch(function (e) {
      if (e && e.data && e.data.state) { askOfflineEmail(F.ui.bad_email); return; }
      addTrouble(function () { sendOfflineEmail(email); });
    });
  }

  /* ---------------------------------------------------------------- reopening */

  /* Lorenzo chose "Their conversation": closing and reopening shows the chat they
     are having, our replies included - AND SO DOES ONE THAT HAS ENDED. There is
     one chat, it is the same one every time, and nothing on this screen clears it
     (31 October 2026 - see ONE CHAT). Its token is kept, so an ended chat comes
     back here like any other and its own box is drawn under it (see resume() and
     endedCompose()).
     ONE DRAWING FOR EVERY CHAT, including the ones the older screens made: the
     questions come back from the chat's OWN ROW (`answers[step].question` is what
     the customer was shown at the time) and never from the flow file, so a chat
     started by any version of this widget reads the way it was lived. */
  function redrawOne(res) {
    S.started = true;
    S.flow = F.flows[String((res && (res.flow_key || res.flow)) || '')]
      || F.flows[S.kind] || null;
    S.email = (res && res.email) || '';
    S.phone = (res && res.phone) || null;
    S.contactDone = !!S.email;
    S.status = res && res.status;
    S.live = isLiveConvo(res);
    S.liveAskedEmail = false;
    /* THE LINE IS NOT A MESSAGE, so it does not come back with the conversation
       and this screen has not said it yet. Whether it is owed is worked out below
       from what the server just handed over, not from a flag kept across pages. */
    S.saidWaiting = false;
    D.log.innerHTML = '';
    clearCompose();
    atHome(false);
    /* WHAT THIS BROWSER HAS ALREADY BEEN SHOWN OF THIS CHAT, read once, now that
       the token is in hand. A different chat's figures read as nothing. */
    S.lastTeamId = 0;
    S.lastTeam = null;
    readSeen();

    /* The header has to say whether anybody is there NOW, which is a fact about
       this minute and not about the conversation. The hours come with it, so an
       offline chat picked up again can still say when we are back. */
    api('status', { flow: S.kind }).then(function (st) {
      if (st && st.hours) S.hours = st.hours;
      setHeadState(!!(st && st.online));
      S.onlineNow = !!(st && st.online);

      /* "SOMEONE WILL BE WITH YOU IN A MOMENT." IS PUT BACK ON THE NEXT PAGE, and
         this is the half of Lorenzo's 30 October ask that was genuinely missing:
         the line is drawn and never saved, so it vanished the moment the customer
         went to another page while still waiting for somebody.
         WORKED OUT FROM WHAT IS ON SCREEN, NOT FROM A STORED FLAG, which is what
         he should be able to rely on:
           * `S.status === 'waiting'` - still waiting for a person;
           * `S.lastTeamId === 0` - drawConversation below has run by the time this
             fires (it is synchronous and a promise never is), and it sets that id
             from every team message it draws. Zero means NOBODY HAS REPLIED YET.
             Once somebody has, the line is a promise that has already been kept
             and is not said again;
           * NOT when the server is asking for an address. `ask_email` means the
             sweep has already told them "Sorry we missed you" - saying somebody is
             coming in a moment under that would contradict it;
           * and `sayWaiting` itself asks whether we are online THIS minute, which
             is the answer that has just arrived above. */
      if (S.status === 'waiting' && S.lastTeamId === 0
          && !(res && res.ask_email === true)) {
        sayWaiting();
      }

      /* "IF WE ARE NOT ONLINE THEY STILL SEE THE SAME ONE BUT THIS TIME IT TELLS
         THEM WE ARE NOT ONLINE" (31 October 2026 - see ONE CHAT). drawConversation
         below is synchronous and a promise never is, so by now the whole chat is on
         screen and the bubble lands at the foot of it, which is where the newest
         thing said belongs. A `status` THAT FAILED DRAWS NOTHING: the catch below
         is unchanged, and an answer that did not arrive must not say we are away
         any more than it may promise somebody is coming. */
      sayOffline();
    }).catch(function () { setHeadState(false); });

    drawConversation(res);

    /* A REPLY THAT LANDED BETWEEN TWO PAGE LOADS (29 October 2026). Until now this
       was the hole: the conversation was drawn into the hidden panel and the
       customer was told NOTHING - no card, and not even the dot, which only
       `takePoll` ever set. So a colleague answering while the customer carried on
       browsing was invisible until they happened to open the chat again.
       THE DOT AND THE CARD ARE ASKED DIFFERENT QUESTIONS, and getting that wrong
       was caught in the preview on 30 October 2026. The dot asks only whether this
       reply has been SEEN - opened - so crossing the card off leaves the dot on the
       button, on the next page as well as this one, which is the rule Lorenzo's
       suggestion rests on. The card asks the narrower question and `showCard` is
       its one judge: it refuses a reply already seen AND one already crossed off.
       Ask the card's question of the dot and the cross silently marks the message
       read, which it must never do. */
    if (!S.open && S.lastTeamId > S.seen) {
      S.unread = true;
      D.dot.hidden = false;
      showCard(S.lastTeam);
    }

    if (S.status === 'answering') {
      /* Started live and never typed: the first message is still the handover. */
      if (S.live) { S.phase = 'live_greeting'; composeFirstLive(); return; }
      /* An offline chat part way through. It has said something and has no
         address, so the address is what is still being asked for. */
      if (saidSomething(res)) { askOfflineEmail(null); return; }
      /* Nothing said at all - `start` went through and the message after it did
         not. The first message is still the first message. */
      firstSendBox();
      return;
    }

    S.phase = 'live';
    /* ENDED, AND STILL THEIRS (30 October 2026). The ending line is already drawn
       above - it is a system message like any other - and under it goes the same
       message box, without the paperclip. Their next message reopens the chat.
       THIS IS ASKED BEFORE `ask_email`, and that order is the decision: a chat
       that was asked for an address and then closed has `ask_email` true for ever,
       and an email box on an ended chat would be a question whose answer
       chat_contact may refuse. The message box is the honest thing to show, and
       the address is asked again by the poll the moment their message has reopened
       the chat. */
    if (S.status === 'emailed' || S.status === 'closed') {
      endedCompose();
    } else if (res && res.ask_email === true && !S.email) {
      S.liveAskedEmail = true;
      askLiveEmail(null);
    } else if (S.status === 'waiting' || S.status === 'live') {
      liveCompose();
    } else {
      /* Not reachable for any status the server answers today - `answering` is
         handled above and the other four are all named - so this is the honest
         fallback for a status this file has not met. It is the ENDED box, because
         a status nobody here recognises is still the customer's one chat, and the
         box is the only thing on this screen that cannot throw it away. */
      endedCompose();
    }
    restartPoll();

    /* AND WHAT THEY WERE TYPING WHEN THE OTHER TAB STARTED THE CHAT IS PUT BACK
       (31 October 2026). This runs for nothing in the ordinary case: only the
       `storage` listener ever fills `carryTyped`, and it is emptied here.
       ONLY INTO THE MESSAGE BOX. `S.box` is set by liveCompose and endedCompose
       just above and is on the screen; a box that is asking for an ADDRESS leaves
       a detached one behind, so a message typed for a person can never land in
       the email question. The value is moved across and the send button worked out
       from it - recompose's rule, and NOTHING IS FOCUSED. */
    if (S.carryTyped) {
      var carried = S.carryTyped;
      S.carryTyped = '';
      var into = (S.box && S.box.input) || null;
      if (into && into.isConnected !== false && !into.value) {
        into.value = carried;
        if (S.box.button) S.box.button.disabled = !trim(carried);
      }
    }
  }

  /* Has this chat anything in it at all? A message, or an answer on the row. */
  function saidSomething(res) {
    if (res && res.messages && res.messages.length) return true;
    var answers = res && res.answers;
    if (!answers) return false;
    for (var k in answers) {
      if (Object.prototype.hasOwnProperty.call(answers, k)) return true;
    }
    return false;
  }

  /* THE CONVERSATION, IN THE ORDER IT WAS WRITTEN. Each of the customer's own
     messages may carry a step id, and the row keeps the question that step was
     asked with - so that question is drawn above it, once, as a bubble from us.
     A LIVE CHAT GETS NO QUESTIONS PUT BACK, because it was never asked any: the
     question kept beside its first message is the database's own internal wording
     for "the first thing they said", and drawing that to a customer would be
     putting words in our mouth that nobody ever read. */
  function drawConversation(res) {
    var withQuestions = !isLiveConvo(res);
    var msgs = (res && res.messages) || [];
    var answers = (res && res.answers) || {};
    var said = {};
    for (var i = 0; i < msgs.length; i++) {
      var m = msgs[i];
      if (m.id && m.id > S.lastId) S.lastId = m.id;
      if (m.sender === 'customer') {
        var step = m.step_id ? String(m.step_id) : '';
        var ask = (withQuestions && step && answers[step]) ? trim(answers[step].question) : '';
        if (ask && !said[step]) { said[step] = true; addFromUs(ask); }
        if (m.attachments && m.attachments.length) {
          /* THE PICTURES THEMSELVES ARE NOT DRAWN AGAIN, and that is deliberate: the
             bucket is private, so showing them would mean the chat asking the server to
             sign a link for every picture every time it is reopened. The names are
             drawn, which is what this has always done.
             THE WORDS COME BACK ONLY IF THEY ARE THEIRS. A message that carried files
             and no words has a body the SERVER wrote - "Sent a photo" - and drawing
             that to the customer would be putting a sentence they never typed in their
             own bubble. See filesSaid. */
          addMineFiles(m.attachments.map(function (a) {
            return { name: a.name, type: a.type, preview: null };
          }), trim(m.body) === filesSaid(m.attachments) ? '' : m.body);
        } else {
          addMine(m.body);
        }
      } else if (m.sender === 'team') {
        addTeam(m.name, m.body);
        /* WHICH REPLY IS THE NEWEST, kept as the conversation is drawn rather than
           worked out again afterwards, so the card and "everything drawn is seen"
           are both counting the same thing. */
        if (whole(m.id) > S.lastTeamId) { S.lastTeamId = whole(m.id); S.lastTeam = m; }
      } else {
        addSystem(m.body);
      }
    }
  }

  /* ============================================================= LIVE MODE
   *
   * Lorenzo, 26 October 2026: the "greeting instead of the questions" while
   * somebody is online, a line in the chat saying so, and "We dont want to ask
   * any additional details from them".
   *
   * THE SERVER DECIDES, IN TWO PLACES AND BOTH OF THEM ITS OWN:
   *   `status {flow}`  would a chat on this flow be answered live this minute;
   *   `start {live}`   asks for it, and the reply says whether it was given.
   * The browser only ever ASKS. A `status` answer that has gone stale by the
   * time `start` lands - the last person switched off - comes back
   * `live: false` and the questions are asked, exactly as they are today.
   */

  /* The flow file's live-mode block. A flow file written before live mode
     existed has none, and everything below then reads sensible emptiness rather
     than throwing. */
  function liveData() {
    return (F && F.live) || {};
  }

  /* The greeting for one flow, with the flow file's `default` behind it. A flow
     with no greeting of its own is not a flow without a greeting. */
  function greetingFor(key) {
    var all = liveData().greetings || {};
    return all[String(key || '')] || all['default'] || '';
  }

  /* Is this conversation, as the SERVER handed it back, a live one?
       - `resume` says so outright (`live_started`, migration 1747);
       - `history_view` hands back the same shape built from the stored chat and
         does NOT carry that key, so the fact there is the answer the first live
         message left behind: a chat with a `live_first` answer was a live chat
         and was never asked a question.
     Either is enough, and neither is a guess about what the customer saw. */
  function isLiveConvo(res) {
    if (!res) return false;
    if (res.live_started === true) return true;
    return !!(res.answers && res.answers.live_first);
  }

  /* IS THIS FLOW ANSWERED LIVE THIS MINUTE? Asked the moment the chat opens on a
     flow - the page's own flow in page mode, or the row that was pressed -
     because what the customer sees first is the answer to it. A `status` that
     could not be read is NOT taken as live: the questions are the safe answer,
     because they end with an email address either way, and promising a person
     who is not there is the one thing that cannot be taken back. */
  function askIfLive() {
    api('status', { flow: S.flow.key }).then(function (res) {
      startChat(!!(res && res.online));
    }).catch(function () {
      startChat(false);
    });
  }

  /* THE CONVERSATION IS OPENED AT ONCE AND WITH NO EMAIL. The `email` field is
     left off the request altogether rather than sent empty, as the contract says
     ("`start` accepts no email for a question flow"). Every answer is still
     saved as it is given, so a chat stopped partway shows in the ERP with its
     answers and no contact details - which is what Lorenzo accepted when he was
     asked about this ("Yes, email at the end").
     `wantLive` adds `live: true` and NOTHING ELSE to the request. An ordinary
     start carries exactly the keys it has always carried. */
  function startChat(wantLive) {
    var ask = { flow: S.flow.key, page: location.href, open: openKey() };
    if (wantLive) ask.live = true;
    leadAttach(ask);
    api('start', ask).then(function (res) {
      S.token = res.token;
      if (S.token) dropOpenKey();
      S.status = 'answering';
      if (!S.practice && S.token) writeToken(S.token);
      /* this browser keeps EVERY chat it started, not only the current one */
      if (S.token) pushHistory(S.token, S.flow.key);
      /* THE SERVER'S ANSWER AND NOT THE BROWSER'S WISH. Only `live: true` makes
         this a live chat; anything else is the questions. */
      if (res && res.live === true) { enterLive(); return; }
      S.phase = 'flow';
      askStep(S.flow.first);
    }).catch(function () {
      addTrouble(function () { startChat(wantLive); });
    });
  }

  /* "We're online now": a line ABOUT the conversation, drawn like every other
     system line, with one small round mark before the words. THERE IS NO GREEN
     IN THE CHAT'S OWN COLOURS - gold, cream, grey, ink and muted is the whole
     set - and #C3A976 is the only gold anywhere, so the mark is that gold rather
     than a green invented for this one line. (The mark became green on his word
     of 27 October; the comment above is left as it was written.)

     NOT REACHED SINCE 27 OCTOBER 2026. His picture of an online chat has an empty
     message area, so the state is one word in the header instead - see
     setHeadState - and this line is not drawn. The words are still in the flow
     file, so bringing the line back is one call. */
  function addOnline() {
    var n = el('div', 'sp-chat-system sp-chat-online');
    /* the mark and the words are ONE flex child, so the hairlines on either side
       sit away from them and the mark sits close against the words */
    var words = el('span', 'sp-chat-online-words');
    words.appendChild(el('span', 'sp-chat-online-dot'));
    words.appendChild(el('span', null, liveData().online || ''));
    n.appendChild(words);
    D.log.appendChild(n);
    scrollDown();
    return n;
  }

  /* NOT REACHED SINCE 27 OCTOBER 2026: the one screen's `firstMessage` opens the
     conversation and hands the first message straight to sendFirstLive, so there
     is no moment at which a greeting would be drawn. Kept with its wording.
     The live chat as the customer meets it: we are online, a greeting, and the
     message box. NO QUESTION IS ASKED AND NO BOX IS FOCUSED. */
  function enterLive() {
    S.live = true;
    S.phase = 'live_greeting';
    addOnline();
    addAsk(greetingFor(S.flow.key), null);
    composeFirstLive();
  }

  /* The box that takes the FIRST message of a live chat. Written once, because a
     chat picked up again on the next page before anything was typed needs the
     same box doing the same thing - and saying the same thing while it is empty,
     `first_online`, because a chat started live was started while we were. */
  function composeFirstLive() {
    composeBox(function (text, ctl) {
      if (ctl.files.length) { sendFirstLive(text, ctl.files, ctl); return; }
      ctl.taken();
      clearCompose();
      addMine(text);
      sendFirstLive(text);
    }, null, F.ui.first_online, true);
  }

  /* THE FIRST MESSAGE IS THE HANDOVER. One call: the chat goes to `waiting`, it
     appears on the ERP's Live tab and in its number, and the one internal email
     goes to the office - all of that in the database, in one statement.
     `question` is the greeting they read, sent for the same reason `answer`
     sends a question: the server keeps the customer's words and not ours.
     A failure keeps the words: Try again sends exactly the same message. */
  /* NO `question` IS SENT SINCE 27 OCTOBER 2026, and that is deliberate. It used
     to carry the greeting, because the greeting was on the screen above the box.
     Lorenzo's picture of an online chat has an EMPTY message area, so there is no
     greeting any more - and sending one as "the question they were asked" would
     put a sentence nobody read into the ERP and onto the Gorgias ticket. With no
     question, chat_live_first_message writes its own "The first thing they said",
     which is true and is read only by us. */
  /* `files` AND `ctl` ARE THE PAPERCLIP'S. With files the handover goes through
     `send_files` instead of `live_message`, and the database calls
     chat_live_first_message itself - so the chat still goes to `waiting`, the waiting
     clock still starts and the office still gets its one email, all in one statement.
     Nothing about the handover is decided twice. */
  function sendFirstLive(text, files, ctl) {
    if (files && files.length) {
      sendWithFiles(ctl, text, files, {}, function () {
        S.status = 'waiting';
        S.phase = 'live';
        /* 30 October 2026: this said `after_thanks_live` - see sayWaiting(). */
        sayWaiting();
        leadFirstLive();
        restartPoll();
      });
      return;
    }
    api('live_message', {
      token: S.token,
      text: text
    }).then(function (res) {
      /* A NAMED REFUSAL HERE WOULD MEAN THE SERVER DOES NOT THINK THIS IS A LIVE
         CHAT, which cannot happen on the path above - `start` has just said it
         is. It is treated as a bad moment rather than silently turning into a
         question flow, because switching the chat under the customer after they
         have typed is worse than asking them to press Try again. */
      if (res && res.ok === false) { addTrouble(function () { sendFirstLive(text); }); return; }
      S.status = 'waiting';
      S.phase = 'live';
      /* THE FIRST MESSAGE, AND THE LINE LORENZO ASKED FOR ON 30 OCTOBER 2026.
         This said `after_thanks_live` until then, which is the one thing about
         this change he has to choose - see sayWaiting(). */
      sayWaiting();
      leadFirstLive();
      restartPoll();
    }).catch(function () {
      addTrouble(function () { sendFirstLive(text); });
    });
  }

  /* THE ONE TIME A LIVE CHAT ASKS FOR ANYTHING. Nobody answered within the
     no-answer minutes, so the server has written "Sorry we missed you - leave
     your email and we'll reply there." as a system line and says so with
     `ask_email`. The approved email question is drawn under it, so the box
     carries the same two lines every other email question in this chat carries
     and a reader is told what to type. NOT FOCUSED. */
  function askLiveEmail(hint) {
    addAsk(F.strings.email_bold, F.strings.email_italic);
    var ctl = composeBox(function (text, box) {
      var email = text.trim();
      if (!EMAIL_RE.test(email) || email.length > 254) {
        box.keep(F.ui.bad_email);
        return;
      }
      box.taken();
      clearCompose();
      addMine(email);
      sendLiveEmail(email);
    }, null, F.ui.email_label);
    if (hint) sayHint(ctl.hint, hint);
  }

  /* The same `contact` call a question flow makes at its end, WITH NO PHONE:
     "We dont want to ask any additional details from them", so a live chat is
     asked for the address and for nothing else. The message box comes back
     afterwards, because a colleague can still answer and the customer can still
     type - and the minute check then moves the chat to email with the words it
     has always used. */
  function sendLiveEmail(email) {
    api('contact', { token: S.token, email: email, phone: null }).then(function (res) {
      if (res && res.ok === false) { askLiveEmail(F.ui.bad_email); return; }
      S.email = email;
      S.contactDone = true;
      addSystem(fill(F.strings.after_thanks_email, email));
      liveCompose();
      restartPoll();
    }).catch(function (e) {
      if (e && e.data && e.data.state) { askLiveEmail(F.ui.bad_email); return; }
      addTrouble(function () { sendLiveEmail(email); });
    });
  }

  /* A LIVE CHAT'S WHOLE CONVERSATION, in the order it was written. There are no
     questions to put back: the greeting is drawn by the caller and everything
     after it is simply what was said. The customer's own first message carries a
     step id (`live_first`) so the ERP and the Gorgias ticket can print the
     greeting above it; here it is one more line of theirs. */
  function drawLiveLines(msgs) {
    for (var i = 0; i < (msgs || []).length; i++) {
      var m = msgs[i];
      if (m.id && m.id > S.lastId) S.lastId = m.id;
      if (m.sender === 'team') addTeam(m.name, m.body);
      else if (m.sender === 'customer' && m.attachments && m.attachments.length) {
        /* the same rule drawConversation keeps: the names, and their words only if the
           words are theirs */
        addMineFiles(m.attachments.map(function (a) {
          return { name: a.name, type: a.type, preview: null };
        }), trim(m.body) === filesSaid(m.attachments) ? '' : m.body);
      } else if (m.sender === 'customer') addMine(m.body);
      else addSystem(m.body);
    }
  }

  /* A LIVE CHAT CARRIED ONTO THE NEXT PAGE. Nothing is walked, because there is
     nothing to walk, and no email question is put back unless the server is
     still asking for one. */
  function redrawLive(res) {
    var flow = F.flows[res.flow_key || res.flow] || F.flows[F.home.flows[0]];
    S.flow = flow;
    S.live = true;
    S.email = res.email || '';
    S.phone = (res && res.phone) || null;
    S.contactDone = !!S.email;
    S.status = res.status;
    S.liveAskedEmail = false;
    D.log.innerHTML = '';
    atHome(false);
    if (flow.label && !isPageFlow(flow.key)) addMine(flow.label);
    /* "We're online now" IS NOT REPEATED HERE. It says something about this
       minute, and nothing on this page has asked whether it is still true. */
    addAsk(greetingFor(flow.key), null);
    drawLiveLines(res.messages || []);

    if (res.status === 'answering') {
      /* Started live and never typed. The first message is still the handover. */
      S.phase = 'live_greeting';
      composeFirstLive();
      return;
    }

    S.phase = 'live';
    if (res.ask_email === true && !S.email) {
      S.liveAskedEmail = true;
      askLiveEmail(null);
    } else {
      liveCompose();
    }
    restartPoll();
  }

  /* IS IT TIME FOR THE EMAIL AND THE PHONE? They come after the flow's own
     questions: immediately BEFORE the thank-you where the flow has one
     (`thanks_step`), and where it has none - Use Personal Materials - when the
     questions run out. Heirloom Gold opens with a message of its own, which is
     why this asks for the named thank-you step and not merely "a message". */
  function contactDueAt(stepId) {
    if (S.contactDone) return false;
    if (!S.flow || S.flow.kind === 'orders') return false;
    if (!stepId || !S.flow.steps[stepId]) return true;      /* nothing left to ask */
    return !!S.flow.thanks_step && stepId === S.flow.thanks_step;
  }

  function askStep(stepId) {
    if (contactDueAt(stepId)) {
      askContact(function () { askStep(stepId); });
      return;
    }
    var step = S.flow.steps[stepId];
    if (!step) { finishChat(); return; }
    S.stepId = stepId;
    addAskStep(step);

    if (step.kind === 'text') {
      composeBox(function (text, ctl) {
        ctl.taken();
        clearCompose();
        addMine(text);
        saveAnswer(step, text, function () { askStep(step.next); });
      });
      return;
    }

    if (step.kind === 'choices') {
      composeChoices(step, function (choice) {
        addMine(choice.label);
        saveAnswer(step, choice.label, function () { askStep(choice.next); });
      });
      return;
    }

    if (step.kind === 'upload') {
      composeUpload(step, function (files, undo) {
        sendFiles(step, files, undo);
      });
      return;
    }

    /* 'message': the bot has said it; nothing is asked */
    clearCompose();
    if (step.next) askStep(step.next); else finishChat();
  }

  /* ------------------------------------------------- the email, then the phone
   *
   * Lorenzo, 25 October 2026: "can we collect the email of the customer as the
   * last step and after the email ask them for a number too", and the phone
   * OPTIONAL. Both words are approved and both live in the flow file's
   * `strings`.
   *
   * They go to the server TOGETHER, in one `contact {token, email, phone|null}`
   * call, so there is one moment at which a chat gains its contact details and
   * not two. That is also why an email on a row is enough to know, on another
   * page, that both have already been asked.
   *
   * `done` is what happens next: the thank-you, or `finish` where the flow has
   * no thank-you.
   */
  function askContact(done) {
    S.phase = 'contact';
    askContactEmail(done, null);
  }

  /* The same approved email question, now at the end. `hint` is set only when
     the SERVER has refused the address, so the line is said under the box the
     customer is about to type in again. */
  function askContactEmail(done, hint) {
    addAsk(F.strings.email_bold, F.strings.email_italic);
    var ctl = composeBox(function (text, box) {
      var email = text.trim();
      if (!EMAIL_RE.test(email) || email.length > 254) {
        box.keep(F.ui.bad_email);
        return;
      }
      box.taken();
      clearCompose();
      addMine(email);
      S.email = email;
      askContactPhone(email, done, null);
    });
    if (hint) sayHint(ctl.hint, hint);
  }

  /* THE PHONE IS OPTIONAL, and Skip sits beside the box - the same word the
     photo question's Skip carries. A number that is not a number gets the quiet
     hint and the question is asked again, with what they typed still in the box
     so it can be corrected rather than retyped. */
  function askContactPhone(email, done, hint) {
    addAsk(F.strings.phone_bold, F.strings.phone_italic);
    var ctl = composePhone(function (phone) {
      /* Skip is echoed as the customer's own pill, exactly as pressing Skip at
         the photo question is. */
      addMine(phone === null ? F.ui.skip : phone);
      sendContact(email, phone, done);
    });
    if (hint) sayHint(ctl.hint, hint);
  }

  function sayHint(node, message) {
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
    scrollDown();
  }

  /* Digits with `+`, spaces, dashes, dots or brackets, 7 to 20 digits. */
  function phoneOk(value) {
    var v = trim(value);
    if (!v || v.length > PHONE_MAX_CHARS) return false;
    if (!PHONE_CHARS.test(v)) return false;
    var digits = v.replace(/\D/g, '').length;
    return digits >= PHONE_MIN_DIGITS && digits <= PHONE_MAX_DIGITS;
  }

  /* One call records both. A REFUSAL IS AN ANSWER, NOT A FAULT: the server says
     400 with `{ok:false, state:'bad_email'|'bad_phone'}`, which arrives on
     `e.data` exactly as a wrong 6-digit code does, and the right thing is the
     question again with its own quiet line - never "Something went wrong".
     A 200 carrying `ok:false` is read the same way, so practice mode (which
     resolves everything) exercises the same path the real server takes. */
  /* ===================================== LEAD SOURCE (3 November 2026)
   *
   * OMS "Handover - Lead source tracking plan - 2026-11-03.md", layer 1. Three things,
   * and every one of them reads snippets/sp-landing.liquid (window.SPLanding) and does
   * nothing at all when that snippet is not on the page:
   *   leadAttach  puts `landing` (where the visit came from: first and last touch) and
   *               `lead` (one event id, and the Meta pixel's fbp and fbc cookies) on the
   *               `start` request. The server keeps them from the migration that adds the
   *               columns and ignores them before it, so this can go live first.
   *   leadPush    the sp_custom_request push Tag Manager reads (GA4 key event
   *               custom_request, Meta Lead). The SAME event id goes in the push and to
   *               the server, so a Lead the ERP sends server-side is counted once.
   *   leadEventId one id per chat, made when the chat starts and kept on S.
   * The practice mode never pushes: a preview is not a lead. */
  function leadEventId() {
    if (!S.leadEventId) {
      var L = window.SPLanding;
      S.leadEventId = (L && L.eventId) ? L.eventId('custom_request') : ('custom_request_' + Date.now());
    }
    return S.leadEventId;
  }

  function leadAttach(body) {
    try {
      var L = window.SPLanding;
      var meta = (L && L.meta) ? L.meta() : {};
      body.lead = { event_id: leadEventId(), fbp: meta.fbp || '', fbc: meta.fbc || '' };
      if (L && L.read) body.landing = L.read();
    } catch (e) { /* nothing depends on it */ }
    return body;
  }

  function leadPush(method, flow, email, phone) {
    try {
      if (S.practice) return;
      var L = window.SPLanding;
      var meta = (L && L.meta) ? L.meta() : {};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'sp_custom_request',
        custom_request: { method: method, flow: flow || '', sku: '', handle: '', page: location.pathname, event_id: leadEventId() },
        user_data: { email: String(email || '').trim().toLowerCase(), phone: String(phone || '').replace(/[^\d+]/g, '') },
        lead: { fbp: meta.fbp || '', fbc: meta.fbc || '' }
      });
    } catch (e) { /* nothing depends on it */ }
  }

  /* THE EMAIL, ASKED ONCE, STRAIGHT AFTER THE FIRST LIVE MESSAGE (3 November 2026).
     Eight website leads a week chatted and left with no address, so they existed only in
     the chat log. The approved email question is drawn (the same two lines every other
     email question in this chat carries) and the box under it takes ANYTHING: an address
     is sent as a message, which the server already reads as the chat's address
     (chat_take_typed_email, 1766), and anything else is simply their next message. So
     nobody is blocked, nothing new is asked of the server, and the `ask_email` the sweep
     sends after the no-answer minutes still works exactly as before. Asked once per chat
     on this page; a chat carried onto the next page is not asked again. */
  function askLiveEmailSoft() {
    if (S.email || S.liveSoftAsked || S.liveAskedEmail) { liveCompose(); return; }
    S.liveSoftAsked = true;
    addAsk(F.strings.email_bold, F.strings.email_italic);
    S.box = composeBox(function (text, ctl) {
      if (ctl.files.length) {
        sendWithFiles(ctl, text, ctl.files, {}, function () { liveCompose(); });
        return;
      }
      ctl.taken();
      var typed = trim(text);
      liveCompose();
      if (EMAIL_RE.test(typed) && typed.length <= 254) {
        S.email = typed;
        S.contactDone = true;
        sendLive(typed, ctl);
        addSystem(fill(F.strings.after_thanks_email, typed));
        return;
      }
      sendLive(typed, ctl);
    }, null, F.ui.email_label, true);
  }

  /* The first live message is in: the lead is counted (method live_chat, whatever the
     flow) and the email is asked. Called from both of sendFirstLive's paths. */
  function leadFirstLive() {
    if (!S.leadSent) {
      S.leadSent = true;
      leadPush('live_chat', S.flow && S.flow.key, S.email, S.phone);
    }
    askLiveEmailSoft();
  }

  function sendContact(email, phone, done) {
    api('contact', { token: S.token, email: email, phone: phone }).then(function (res) {
      if (res && res.ok === false) { contactRefused(res.state, email, done); return; }
      S.email = email;
      S.phone = phone || null;
      S.contactDone = true;
      /* Custom request lead for analytics: once per chat, custom flows only, only after
         the server accepted the contact details. Read by GTM as sp_custom_request. */
      try {
        var LEAD_FLOWS = { customize_a_ring: 1, use_personal_materials: 1, create_something_original: 1, heirloom_gold: 1, wedding_ring: 1 };
        var leadFlow = S.flow && S.flow.key;
        if (leadFlow && LEAD_FLOWS[leadFlow] && !S.leadSent) {
          S.leadSent = true;
          leadPush('chat', leadFlow, email, phone);
        }
      } catch (e) {}
      done();
    }).catch(function (e) {
      var state = e && e.data && e.data.state;
      if (state) { contactRefused(state, email, done); return; }
      addTrouble(function () { sendContact(email, phone, done); });
    });
  }

  function contactRefused(state, email, done) {
    if (state === 'bad_phone') { askContactPhone(email, done, F.ui.bad_phone); return; }
    /* `bad_email`, and anything else named: the address is what has to change,
       and the phone is asked again after it because one call records both. */
    askContactEmail(done, F.ui.bad_email);
  }

  /* The email and the phone of a chat being DRAWN AGAIN - carried onto the next
     page, or opened out of "Your previous chats". Each is drawn only when it is
     there: a `phone` that is null may be a Skip or may be a server that does not
     send the field, and the two cannot be told apart, so nothing is claimed. */
  function drawContactAnswers(res) {
    var email = trim(res && res.email);
    if (!email) return false;
    addAsk(F.strings.email_bold, F.strings.email_italic);
    addMine(email);
    var phone = trim(res && res.phone);
    if (phone) {
      addAsk(F.strings.phone_bold, F.strings.phone_italic);
      addMine(phone);
    }
    return true;
  }

  /* Every answer is saved as it is given, so an unfinished chat still shows how
     far it got. */
  function saveAnswer(step, value, done) {
    api('answer', {
      token: S.token,
      step_id: step.id,
      question: questionText(step),
      value: value
    }).then(function () {
      done();
    }).catch(function () {
      addTrouble(function () { saveAnswer(step, value, done); });
    });
  }

  function sendFiles(step, files, undo) {
    var list = files.map(function (f) {
      return { name: f.name, type: f.type, size: f.size };
    });
    api('upload_urls', { token: S.token, step_id: step.id, files: list })
      .then(function (res) {
        var uploads = res.uploads || [];
        var puts = files.map(function (f, i) {
          var up = uploads[i];
          if (!up || !up.signed_url) return Promise.resolve();   /* practice mode */
          return fetch(up.signed_url, {
            method: 'PUT',
            credentials: 'omit',
            headers: { 'Content-Type': f.type || 'application/octet-stream' },
            body: f.file
          }).then(function (r) {
            if (!r.ok) throw new Error('upload ' + r.status);
          });
        });
        return Promise.all(puts).then(function () {
          return api('uploaded', {
            token: S.token,
            step_id: step.id,
            question: questionText(step),
            files: files.map(function (f, i) {
              return {
                path: (uploads[i] && uploads[i].path) || null,
                name: f.name, type: f.type, size: f.size
              };
            })
          });
        });
      })
      .then(function () {
        clearCompose();
        addMineFiles(files);
        S.files = [];
        askStep(step.next);
      })
      .catch(function () {
        /* the chosen files are still on screen and still chosen */
        if (undo) undo();
        addTrouble(function () { sendFiles(step, files, undo); });
      });
  }

  function finishChat() {
    api('finish', { token: S.token }).then(function (res) {
      if (res.mode === 'live') {
        S.phase = 'live';
        S.status = S.status === 'live' ? 'live' : 'waiting';
        /* SOMEBODY SWITCHED ON WHILE THEY WERE ANSWERING. The chat is waiting for
           a person now, so this is the moment the line is true. It said
           `after_thanks_live` until 30 October 2026 - see sayWaiting(). */
        sayWaiting();
        liveCompose();
        restartPoll();
      } else {
        /* SENT TO EMAIL IS ALSO AN ENDED CHAT, AND IT STAYS TOO (30 October 2026).
           The same change as endChat()'s and for the same reason: this used to
           drop the token and put a "Back to the start" button where the box was,
           so a customer who had just left their address watched the conversation
           disappear. They can carry on typing here, and 1829 reopens the chat when
           they do - which is also how the part they say next reaches the same
           Gorgias ticket. */
        S.phase = 'over';
        S.status = 'emailed';
        addSystem(fill(F.strings.after_thanks_email, S.email));
        /* The same two as endChat()'s: no dots on an ended chat, and the line is
           owed again if their next message reopens it. */
        showTeamTyping(false);
        S.saidWaiting = false;
        endedCompose();
        stopPoll();
      }
    }).catch(function () {
      addTrouble(finishChat);
    });
  }

  /* The message box stays open while the chat is waiting or live. */
  function liveCompose() {
    S.box = composeBox(function (text, ctl) {
      if (ctl.files.length) {
        sendWithFiles(ctl, text, ctl.files, {}, function () { liveCompose(); });
        return;
      }
      ctl.taken();
      sendLive(text, ctl);
    }, null, null, true);
  }

  /* THE BOX UNDER A CHAT THAT HAS ENDED (30 October 2026, migration 1829).
     Lorenzo: *"The customers need to see their chats and start replying to
     previous chats and when they do the chat should re open"*, and, asked whether
     the customer gets a button for it: *"us. for the customer there is no button
     they just send a new message and it re opens"*. So it is the SAME box, in the
     same place, with the same words in it - there is nothing new to learn and
     nothing new to press.

     THE PAPERCLIP IS THE ONE DIFFERENCE, and it is off. `upload_urls` and
     chat_customer_files both refuse a chat that is not answering, waiting or live,
     so a photograph cannot reopen a chat - the clip would be a button that says
     we could not send it. One typed word brings it back: `sendLive` sees the chat
     reopen and builds the open box. Deciding it the other way round - letting a
     photo reopen a chat - would have meant two doors into reopening instead of
     one, and nothing is lost by the customer typing a word first.

     THERE IS NOTHING UNDER THE BOX ANY MORE (31 October 2026). It carried "Back to
     the start", which forgot this chat on this browser and drew a fresh screen.
     Lorenzo: *"We dont need back to start that clears  chat. At the moment there is
     only one chat the customer has and its the same chat they should see all the
     time."* So the rule is now one line long: THERE IS ONE CHAT AND NOTHING ON THIS
     SCREEN CLEARS IT. An ended chat is the same chat - it opens again on the next
     page, and the next message reopens it - so a control that threw it away was
     offering the customer the one thing they cannot undo.
     The chat is untouched in the database and on the ERP's Ended tab, exactly as
     before; what has gone is a button, not a chat. */
  function endedCompose() {
    S.box = composeBox(function (text, ctl) {
      ctl.taken();
      sendLive(text, ctl);
    }, null, null, false);
  }

  /* Build the box again, keeping whatever is in it. Used only when a chat
     reopens, which is the one moment the box has to change shape under somebody
     who may be typing. NOTHING IS FOCUSED: the value is moved across and the send
     button's state is worked out from it, which is all `input` would have done. */
  function recompose(make) {
    var had = (S.box && S.box.input) ? S.box.input.value : '';
    make();
    if (had && S.box && S.box.input) {
      S.box.input.value = had;
      if (S.box.button) S.box.button.disabled = !trim(had);
    }
  }

  /* ------------------------------------------------- a message with files on it
   *
   * Lorenzo, 28 October 2026: "We need the cuystomer to be able to upload a
   * file/photo".
   *
   * THREE CALLS FOR ONE PRESS, and they have to be in this order:
   *   1. `upload_urls` - the server signs one URL per file, each a path under this
   *      chat's own folder in the private chat-uploads bucket. It is the server that
   *      names the path; nothing here composes one.
   *   2. a PUT straight to each signed URL. The file goes to Storage and not through
   *      the edge function, so a 15 MB photograph never passes through it.
   *   3. `send_files` - ONE customer message carrying the paths, with the words if
   *      there were any. The database checks every path is in this chat's folder, is
   *      really in the bucket, and is of a type and size the bucket allows, and only
   *      then writes the message.
   * In PRACTICE MODE step 1 answers with no `signed_url`, so step 2 is skipped and the
   * file never leaves the browser - the same way the old question step practised.
   *
   * NOTHING IS DRAWN UNTIL IT IS DONE. The box keeps the words and the pictures while
   * this runs and says it is sending; a failure puts the box back exactly as it was,
   * with a line saying what was wrong when the server named one, and Try again sends
   * the very same message. A half-sent photograph is the one thing that must not look
   * like a sent one.
   */
  function sendWithFiles(ctl, text, files, opts, after) {
    if (!ctl || !files || !files.length) return;
    ctl.busy(true);
    var asked = files.map(function (f) {
      return { name: f.name, type: f.type, size: f.size };
    });
    api('upload_urls', { token: S.token, files: asked }).then(function (res) {
      var ups = (res && res.uploads) || [];
      return Promise.all(files.map(function (f, i) {
        var up = ups[i];
        if (!up || !up.signed_url) return Promise.resolve();   /* practice mode */
        return fetch(up.signed_url, {
          method: 'PUT',
          credentials: 'omit',
          headers: { 'Content-Type': f.type || 'application/octet-stream' },
          body: f.file
        }).then(function (r) {
          if (!r.ok) throw new Error('upload ' + r.status);
        });
      })).then(function () {
        return api('send_files', {
          token: S.token,
          text: text || '',
          files: files.map(function (f, i) {
            return {
              path: (ups[i] && ups[i].path) || null,
              name: f.name, type: f.type, size: f.size
            };
          }),
          step_id: (opts && opts.step_id) || null,
          question: (opts && opts.question) || null
        });
      });
    }).then(function (res) {
      if (res && res.id) S.lastId = Math.max(S.lastId, res.id);
      if (res && res.status) S.status = res.status;
      clearCompose();
      /* THEIR OWN BUBBLE IS WHAT THEY CHOSE, with the pictures they are looking at
         rather than ones fetched back from the bucket. The object URLs are NOT
         revoked: the bubble is still showing them. */
      addMineFiles(files, text);
      if (after) after(res);
    }).catch(function (e) {
      ctl.busy(false);
      var said = e && e.data && e.data.state;
      /* A REFUSAL THE SERVER NAMED IS SAID IN WORDS, under the box, with the files
         still chosen - so "that one is too big" is a file to remove and not a chat to
         start again. Anything it did not name is a bad moment and gets Try again. */
      if (said === 'chat_full') { sayHint(ctl.hint, F.ui.chat_full); return; }
      if (said === 'too_many_files') { sayHint(ctl.hint, F.ui.too_many_files); return; }
      if (said === 'bad_type') { sayHint(ctl.hint, F.ui.wrong_file_kind); return; }
      if (said === 'too_big') { sayHint(ctl.hint, F.ui.file_too_big); return; }
      addTrouble(function () { sendWithFiles(ctl, text, files, opts, after); });
    });
  }

  function sendLive(text, ctl) {
    var row = addMine(text);
    api('send', { token: S.token, text: text }).then(function (res) {
      if (res && res.id) S.lastId = Math.max(S.lastId, res.id);
      /* 1829: THEIR MESSAGE REOPENED THE CHAT, and the server says so rather than
         this file comparing statuses and guessing. `status` and `reopened` are new
         keys on the reply; an older deployed shop-chat sends neither, and then
         nothing below runs and the chat behaves exactly as it does today.
         Polling only runs for a waiting or live chat (see pollWanted), so this is
         what starts it again - without it the reply to the message that reopened
         the chat would never be fetched. */
      if (res && res.reopened === true && res.status) {
        S.status = res.status;
        recompose(liveCompose);
        restartPoll();
        /* AND THEY ARE TOLD SOMEBODY IS COMING, which is the half of Lorenzo's
           30 October ask that nothing said at all before: a message that reopened
           an ended chat used to get the box back and not one word. `saidWaiting`
           was put back to false when the chat ended, so this is once for this
           episode. recompose comes FIRST so the line is drawn under the
           conversation and not under a box that is about to be rebuilt.
           BUT IT IS ASKED AGAIN FIRST (31 October 2026). Whether anybody is on was
           last read when the page loaded, and this message may be hours later: a
           stale yes is "Someone will be with you in a moment." said into an empty
           room, which is the one thing that cannot be taken back. So the answer is
           refreshed and the line is drawn from THAT - and if the ask fails,
           nothing is said and `saidWaiting` is still false, so the next message is
           owed it. The same answer puts the offline bubble up instead, under their
           own message, because that is now the newest thing said. */
        refreshOnline(sayWaiting);
      }
    }).catch(function () {
      /* the words are not lost: Try again sends exactly the same text */
      if (row && row.parentNode) row.parentNode.removeChild(row);
      addTrouble(function () { sendLive(text, ctl); });
    });
  }

  /* --------------------------------------------------------------- polling */

  function stopPoll() {
    if (S.pollTimer) { window.clearTimeout(S.pollTimer); S.pollTimer = null; }
  }

  function pollWanted() {
    return !!S.token && (S.status === 'waiting' || S.status === 'live');
  }

  function restartPoll() {
    stopPoll();
    if (!pollWanted()) return;
    S.pollTimer = window.setTimeout(tick, S.open ? POLL_OPEN_MS : POLL_SHUT_MS);
  }

  function tick() {
    S.pollTimer = null;
    if (!pollWanted()) return;
    /* THE CUSTOMER'S TYPING RIDES ON THIS REQUEST AND MAKES NO OTHER (30 October
       2026, shop-chat v15). `typing: true` is the whole of it; THE WORDS TYPED ARE
       NEVER SENT OR STORED. The key is left OFF the request altogether rather than
       sent false, so a poll from somebody who is not typing is byte for byte the
       poll this has always sent - which is also what an older deployed shop-chat
       sees, and it reads `token` and `after` and ignores anything else. */
    var ask = { token: S.token, after: S.lastId };
    if (customerTyping()) ask.typing = true;
    api('poll', ask)
      .then(function (res) { takePoll(res); })
      .catch(function () { /* a missed poll is not worth a line on screen */ })
      .then(function () { restartPoll(); });
  }

  function takePoll(res) {
    if (!res) return;
    var msgs = res.messages || [];
    /* THE NEWEST ONE, AND ONE CARD. Two replies can land in the same poll - a
       colleague typing twice, or the first poll after the tab was asleep - and
       the card is the newest of them, not the first and not one each. The count
       on the browser tab does count every one of them, because that is what it
       is for. */
    var newest = null;
    for (var i = 0; i < msgs.length; i++) {
      var m = msgs[i];
      if (m.id && m.id > S.lastId) S.lastId = m.id;
      if (m.sender === 'team') {
        /* THE DOTS GO THE MOMENT THE REPLY IS DRAWN, before the bubble rather than
           after it, so the dots are never left sitting under the sentence they
           were waiting for. If the same person has started typing again, the
           `team_typing` below puts them back at the bottom in the same poll. */
        showTeamTyping(false);
        addTeam(m.name, m.body);
        S.lastTeamId = Math.max(S.lastTeamId, whole(m.id));
        if (!S.open) {
          S.unread = true;
          D.dot.hidden = false;
          newest = m;
          bumpTitle();
        }
      } else if (m.sender === 'system') {
        addSystem(m.body);
      } else if (m.sender === 'bot') {
        addSystem(m.body);
      }
    }
    if (res.status) {
      var was = S.status;
      S.status = res.status;
      if (S.status === 'emailed' && was !== 'emailed') {
        /* the function has already sent the system message that says so; if it
           did not, say the line ourselves rather than leave the chat silent */
        if (!hasSystemFrom(msgs)) addSystem(fill(F.strings.no_answer, S.email));
        endChat();
      } else if (S.status === 'closed' && was !== 'closed') {
        if (!hasSystemFrom(msgs)) addSystem(F.strings.chat_ended);
        endChat();
      }
    }

    /* LIVE MODE, AND THE ONE TIME A LIVE CHAT IS ASKED FOR ANYTHING. `ask_email`
       is the FACT that the server is waiting for an address (migration 1747),
       read off the row rather than matched against the words of the system line
       above - which would break the day anybody reworded them. Shown once, and
       only while the chat is still open: a chat that has just gone to email in
       this same poll is already over. */
    if (res.ask_email === true && !S.liveAskedEmail && !S.email
        && (S.status === 'waiting' || S.status === 'live')) {
      S.liveAskedEmail = true;
      askLiveEmail(null);
    }

    /* SOMEBODY ON OUR SIDE IS TYPING (30 October 2026, migration 1853). The
       server's own fact, read off the row rather than guessed from the messages,
       and ASKED LAST so a reply and an ending that landed in this same poll have
       already been drawn - the dots then sit under them or, when the chat has
       ended, are taken away by endChat() above.
       ONLY WHILE THE PANEL IS OPEN. Nobody is looking at a shut panel, and a
       reply that lands while it is shut has the card and the dot for that. The
       next poll after it is opened puts the dots up, which is within three
       seconds.
       AN OLDER shop-chat SENDS NO SUCH KEY, and then this is false and the dots
       never appear - so the widget is safe on a theme while v13 is still live. */
    showTeamTyping(res.team_typing === true && S.open
                   && (S.status === 'waiting' || S.status === 'live'));

    /* LAST, so a reply that arrived in the same poll as the chat being closed has
       already had its line drawn and its ending said before the card goes up. */
    if (newest) showCard(newest);
  }

  function hasSystemFrom(msgs) {
    for (var i = 0; i < msgs.length; i++) if (msgs[i].sender === 'system') return true;
    return false;
  }

  /* THE CHAT ENDED WHILE THE CUSTOMER WAS LOOKING AT IT - and it STAYS, 30 October
     2026. Lorenzo: *"once the chat ends its not appear on the customer side too.
     If I have a chat as a customer, it should stay there but I dont see it
     anymore."* Until now this threw the conversation away: the token was dropped
     and the screen became a fresh chat, so the ending line they had just read
     vanished with everything above it.
     WHAT IS LEFT BEHIND ON PURPOSE: the conversation on screen with its ending
     line, and the message box under it. Polling stops, because there is nothing to
     poll until they write - and `sendLive` restarts it when their message reopens
     the chat. The token is KEPT, which is what brings the same chat back on the
     next page. */
  function endChat() {
    S.phase = 'over';
    stopPoll();
    /* THE DOTS GO WITH THE CHAT. Nobody is typing a reply to a chat that has
       ended, and polling has just stopped, so nothing would ever take them away
       again. */
    showTeamTyping(false);
    /* AND "someone will be with you in a moment" IS OWED AGAIN IF THEY COME BACK.
       Their next message reopens the chat (1829), and that is a new waiting
       episode, which is what Lorenzo asked for: once after the first message, and
       once after the message that reopens it. */
    S.saidWaiting = false;
    recompose(endedCompose);
  }

  /* --------------------------------------------------- carrying it across pages */

  /* The token is kept so the same conversation is still there on the next page -
     AND AN ENDED CHAT IS BROUGHT BACK TOO, since 30 October 2026. Lorenzo: *"If I
     have a chat as a customer, it should stay there but I dont see it anymore.
     chat 365 was test yesterday."* Chat 365 is exactly this: Waqas closed it, the
     next page load dropped the token here, and it was gone off his screen with no
     way back. It now draws like any other chat, with its ending line and the
     message box under it, and his next message reopens it.

     IT ALSO PICKS UP A CHAT WHOSE TOKEN WAS ALREADY THROWN AWAY by the version of
     this file that did that - which is every customer who had a chat end before
     today, Lorenzo included. The token is still in `sp-chat-history`, so with no
     current token the NEWEST chat on that list is adopted, if the server still has
     it. Nothing is invented: the server is asked, and a token it does not know
     comes off the list. */
  function resume() {
    var token = readToken();
    if (token) { resumeToken(token, false, 0); return; }
    token = newestChatToken();
    if (!token) return;
    resumeToken(token, true, 0);
  }

  /* The newest chat this browser started, off its own list. */
  function newestChatToken() {
    var list = readHistory();
    return (list[0] && list[0].token) || null;
  }

  /* `adopted` says the token came off the history list rather than out of
     `sp-chat-token`: it is only written as the current chat once the server has
     answered for it. `tries` bounds walking down the list when the newest chats
     have been deleted - a handful of deleted test chats at the top is realistic,
     a loop down twenty of them is not. */
  function resumeToken(token, adopted, tries) {
    S.token = token;
    /* A PAGE-MODE PAGE WAITS FOR THIS before starting its own flow, so a chat
       the customer already has going is not thrown away by opening the
       launcher. */
    S.resuming = true;
    /* This try is the one that counts: whatever the last one knew is stale. */
    S.resumeFailed = null;
    api('resume', { token: token }).then(function (res) {
      if (!res || !res.status) {
        /* AN ANSWER WE CANNOT READ, AND THE TOKEN STAYS (31 October 2026). This
           used to drop it when it was the current one, and that was the bug: an
           answer that could not be read says NOTHING about whether the chat
           exists - half a reply through a bad connection reads the same as a
           deleted chat - and with the token gone the next message opens a second
           one. ONLY `unknown_chat` MAY REMOVE A TOKEN now, because that is the
           server saying the chat is not there (see the catch below).
           There is nothing to draw a box over, so the screen says Try again. */
        S.token = null;
        S.resumeFailed = { token: token, adopted: adopted };
        resumeSettled();
        return;
      }
      /* The adopted chat IS their chat now, so the next page finds it without
         going through the list again. */
      if (adopted) writeToken(token);
      /* THE CHAT THEY ARE HAVING IS PICKED UP ON EVERY PAGE, whatever kind it is.
         Until 27 October 2026 a page that named its own kind refused to pick up a
         chat of another one - Lorenzo, 25 October, on the wedding-dress page: "I
         see my chat history of customize this ring under the wedding ring chat".
         That was about the LIST of past chats showing the wrong flow's name on
         that page, and the list is gone; what is left is one conversation at a
         time, and refusing to draw it on one page would leave the customer with a
         chat they cannot reach and no list to find it on. The kind only decides
         what a NEW chat is. */
      redraw(res);
      resumeSettled();
    }).catch(function (e) {
      if (e && e.data && e.data.state === 'unknown_chat') {
        /* the server says that chat is gone, so it comes off the list too */
        forgetOne(token);
        renderHistory();
        S.token = null;
        /* ADOPTED AND GONE: try the next one down. forgetOne has already taken
           this token off the list, so "the newest" is now the one after it. */
        if (adopted && tries < 2) {
          var next = newestChatToken();
          if (next) { resumeToken(next, true, tries + 1); return; }
        }
        resumeSettled();
        return;
      }
      /* A BAD MOMENT, NOT A MISSING CHAT: the token is left exactly where it is,
         the next page can try again - and so can this one, because the screen
         offers Try again instead of a box that would start a second chat. */
      S.token = null;
      S.resumeFailed = { token: token, adopted: adopted };
      resumeSettled();
    });
  }

  /* `resume` has answered, one way or the other. If it brought nothing back and
     the panel is already open, this is the moment the fresh screen is drawn - it
     was held back while the answer was in flight. */
  function resumeSettled() {
    S.resuming = false;
    if (S.open && !S.started) beginScreen();
    /* Opened while `resume` was still asking, and nothing came back: that WAS an
       open, held back like the screen was. reportOpen does nothing if a chat did
       come back (S.token) or the open was already sent. */
    if (S.open) reportOpen();
  }

  /* A CONVERSATION DRAWN AGAIN, on the next page or after the panel was closed.
     ONE DRAWING FOR EVERY KIND OF CHAT since 27 October 2026 - see redrawOne. */
  function redraw(res) {
    redrawOne(res);
  }

  /* NOT REACHED SINCE 27 OCTOBER 2026, kept because it is the record of how a
     question flow was drawn again and because Lorenzo may ask for the flows back.
     redrawOne does this job for every chat now, including the ones these screens
     made.
     Redraw a conversation on the next page. The database keeps the customer's
     ANSWERS as messages (each carrying its step id) and never the questions,
     so the questions are put back from the flow file: walk the flow from its
     first step, and under each question draw the answer that step got. Then the
     lines that belong to no step - the team's replies, the system's lines and
     anything the customer typed while live - follow in the order they were
     written. (resume answers `flow_key`; `flow` is read too, in case.) */
  function redrawByFlow(res) {
    /* An orders chat is not a list of questions, so it is drawn by its own
       function - see redrawOrders. */
    if ((res.flow_key || res.flow) === F.home.orders) { redrawOrders(res); return; }
    /* A LIVE CHAT IS NOT A LIST OF QUESTIONS EITHER. It is a greeting and then
       messages, and walking the flow would put questions on screen that this
       customer was never asked. */
    if (isLiveConvo(res)) { redrawLive(res); return; }
    var flow = F.flows[res.flow_key || res.flow] || F.flows[F.home.flows[0]];
    S.flow = flow;
    S.email = res.email || '';
    S.phone = (res && res.phone) || null;
    /* AN EMAIL ON THE ROW MEANS `contact` WENT THROUGH, because one call records
       the email and the phone together. So neither is asked a second time. */
    S.contactDone = !!S.email;
    S.status = res.status;
    D.log.innerHTML = '';
    atHome(false);
    if (flow.label && !isPageFlow(flow.key)) addMine(flow.label);

    var walked = drawFlowAnswers(flow, res.messages || [], res.answers || {});

    if (res.status === 'answering') {
      S.phase = 'flow';
      if (walked.waitingOn) { askAgain(walked.waitingOn); return; }
      /* Every question answered. What is left is the email and the phone, and
         then the thank-you - or, when they are already recorded, the thank-you
         and the `finish` that never landed. */
      drawContactAnswers(res);
      askStep(walked.atThanks ? walked.atThanks.id : null);
      return;
    }

    /* waiting or live: the contact details, the thank-you, the line that
       followed it, then the rest */
    drawContactAnswers(res);
    if (walked.atThanks) addAskStep(walked.atThanks);
    addSystem(F.strings.after_thanks_live);
    drawLoose(walked.loose);
    S.phase = 'live';
    liveCompose();
    restartPoll();
  }

  /* THE WALK ITSELF, shared by the chat carried onto the next page and by a past
     chat drawn read only, so the two cannot come to draw a conversation
     differently. It answers the step that has no answer yet, if there is one,
     and the messages that belong to no step.

     IT STOPS AT THE THANK-YOU AND DOES NOT DRAW IT, handing it back as
     `atThanks`, because the email and the phone go between the last question and
     the thank-you. The caller draws them and then the thank-you, so a chat drawn
     again reads in the order the customer lived through. */
  function drawFlowAnswers(flow, msgs, answers) {
    var byStep = {};
    var loose = [];
    for (var i = 0; i < msgs.length; i++) {
      var m = msgs[i];
      if (m.id && m.id > S.lastId) S.lastId = m.id;
      if (m.sender === 'customer' && m.step_id && !byStep[m.step_id]) byStep[m.step_id] = m;
      else loose.push(m);
    }

    var id = flow.first;
    var waitingOn = null;
    var atThanks = null;
    var guard = 0;
    while (id && guard++ < 50) {
      var s = flow.steps[id];
      if (!s) break;
      if (flow.thanks_step && id === flow.thanks_step) { atThanks = s; break; }
      addAskStep(s);
      if (s.kind === 'message') { id = s.next; continue; }
      var got = byStep[id];
      /* no messages came back at all: fall back to the answers on the row */
      var value = got ? got.body : (answers[id] && answers[id].value);
      if (!got && (value === undefined || value === null)) { waitingOn = s; break; }
      if (got && got.attachments && got.attachments.length) {
        addMineFiles(got.attachments.map(function (a) { return { name: a.name, preview: null }; }));
      } else if (s.kind === 'upload') {
        addMineFiles([{ name: String(value), preview: null }]);
      } else {
        addMine(String(value));
      }
      id = s.kind === 'choices' ? pickedNext(s, String(value)) : s.next;
    }
    return { waitingOn: waitingOn, loose: loose, atThanks: atThanks };
  }

  /* The lines that belong to no step: the team's replies, the system's own lines
     and anything the customer typed once the chat was live, in the order they
     were written. */
  function drawLoose(loose) {
    for (var j = 0; j < (loose || []).length; j++) {
      var n = loose[j];
      if (n.sender === 'team') addTeam(n.name, n.body);
      else if (n.sender === 'customer') addMine(n.body);
      else addSystem(n.body);
    }
  }

  /* The redraw above has usually drawn this question already (the bot's own
     message carries its step id), so only the composer is put back. If it has
     not, the question is drawn first rather than leaving a box with nothing
     above it. */
  function askAgain(step) {
    S.stepId = step.id;
    var last = D.log.querySelector('.sp-chat-ask:last-child');
    var shown = last && last.firstChild && last.firstChild.textContent === step.bold;
    if (!shown) addAskStep(step);
    if (step.kind === 'text') {
      composeBox(function (text, ctl) {
        ctl.taken();
        clearCompose();
        addMine(text);
        saveAnswer(step, text, function () { askStep(step.next); });
      });
    } else if (step.kind === 'choices') {
      composeChoices(step, function (choice) {
        addMine(choice.label);
        saveAnswer(step, choice.label, function () { askStep(choice.next); });
      });
    } else if (step.kind === 'upload') {
      composeUpload(step, function (files, undo) { sendFiles(step, files, undo); });
    } else {
      askStep(step.next);
    }
  }

  function pickedNext(step, value) {
    var choices = step.choices || [];
    for (var i = 0; i < choices.length; i++) {
      if (choices[i].label === value) return choices[i].next;
    }
    return step.next;
  }

  /* ========================================================= ORDER MANAGEMENT
   *
   * Lorenzo, 25 October 2026: "can we also add the order management? Linked with
   * the ERP instead of the Shopify?" ... "We need their email and then give them
   * the list of the orders we have fo them".
   *
   * It is NOT a list of questions like the Gorgias flows, so it does not use
   * `steps` at all. It goes: the same email question the flows ask -> a 6-digit
   * code to that email -> the customer's orders as cards -> one order -> Track,
   * Return (only when it can be returned) or Report issue -> Gorgias's own reply
   * -> either "Was this helpful?" or the message box to a person.
   *
   * WHY THE CODE EXISTS. Anybody can type anybody's email - a partner looking
   * for a surprise engagement ring, for instance - so the email alone is not
   * allowed to show what somebody ordered. The server also never says whether an
   * email is a customer: the line after the email is "IF we have orders under
   * that email".
   *
   * The words of every reply are Gorgias's and live in `sp-chat-flows.js`. The
   * action names here are the contract's, fixed with the server: `orders_start`,
   * `orders_resend`, `orders_verify`, `orders_list`, `order_choose`,
   * `orders_done`, and then the same `answer` and `finish` the flows use, with
   * the step ids `order_action`, `issue`, `helpful` and `details`.
   */

  var CODE_RE = /^\d{6}$/;

  /* The question that belongs above each of the four answers an order chat
     records. Used when the chat is drawn again on another page, so no answer is
     ever left sitting under nothing. */
  var ORDER_STEP_ASK = {
    order_action: 'order_actions_bold',
    issue: 'issue_bold',
    helpful: 'helpful_bold',
    details: 'more_help'
  };

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];

  /* '2026-10-12', or a whole ISO stamp, becomes '12 October 2026'.
     THE DATE IS READ AS THE DAY THE SERVER SENT and is never turned into a local
     time: a ship-by is a date, and a browser some hours west of us must not show
     the day before it. */
  function dayWords(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso === null || iso === undefined ? '' : iso));
    if (!m) return '';
    return String(Number(m[3])) + ' ' + (MONTHS[Number(m[2]) - 1] || m[2]) + ' ' + m[1];
  }

  function ordersFlow() { return F.flows[F.home.orders]; }

  /* The ERP stores a channel in lower case ('shopify', 'etsy', 'direct'); a
     customer reads the shop's own name. Anything unknown is shown as it came. */
  var CHANNEL_WORDS = { shopify: 'Shopify', etsy: 'Etsy', direct: 'Direct' };
  function channelWords(c) {
    var k = String(c || '').toLowerCase();
    return CHANNEL_WORDS[k] || String(c || '');
  }

  function pickOrders() {
    var flow = ordersFlow();
    if (!flow) return;
    S.flow = flow;
    S.phase = 'orders';
    S.stepId = null;
    S.orders = null;
    S.order = null;
    S.verified = false;
    S.history = null;
    D.log.innerHTML = '';
    atHome(false);
    addMine(flow.label);
    askOrdersEmail();
  }

  /* THE SAME EMAIL QUESTION THE FLOWS ASK, word for word, because it is the same
     question - and because the email is what the code is sent to. */
  function askOrdersEmail() {
    addAsk(F.strings.email_bold, F.strings.email_italic);
    composeBox(function (text, ctl) {
      var email = text.trim();
      if (!EMAIL_RE.test(email) || email.length > 254) {
        ctl.keep(F.ui.bad_email);
        return;
      }
      ctl.taken();
      clearCompose();
      addMine(email);
      ordersStart(email);
    });
  }

  function ordersStart(email) {
    api('orders_start', { email: email, page: location.href, open: openKey() }).then(function (res) {
      S.email = email;
      S.token = res.token;
      if (S.token) dropOpenKey();
      S.status = 'answering';
      if (!S.practice && S.token) writeToken(S.token);
      if (S.token) pushHistory(S.token, F.home.orders);
      /* Always the same line, whether or not a code went out. */
      addSystem(F.strings.orders_code_sent);
      askCode();
    }).catch(function () {
      addTrouble(function () { ordersStart(email); });
    });
  }

  function askCode() {
    addAsk(F.strings.code_bold, null);
    composeCode();
  }

  /* The code box. A NUMERIC keyboard on a phone and the one-time-code hint, so
     iOS and Android offer the code straight out of the email - and it is NOT
     FOCUSED, by Lorenzo's standing rule, so no keyboard opens until it is
     pressed. "Send a new code" sits quietly under it. */
  function composeCode() {
    clearCompose();
    var box = el('div', 'sp-chat-box sp-chat-codebox');
    var input = el('input', 'sp-chat-input sp-chat-code');
    input.type = 'text';
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'one-time-code');
    /* pattern keeps older iOS on the number pad; inputmode is what modern
       browsers read */
    input.setAttribute('pattern', '[0-9]*');
    input.setAttribute('aria-label', F.ui.code_label);
    input.placeholder = F.ui.code_label;
    input.maxLength = 6;

    var btn = el('button', 'sp-chat-send');
    btn.type = 'button';
    btn.setAttribute('aria-label', F.ui.send);
    btn.appendChild(iconSend());
    btn.disabled = true;

    var hint = el('div', 'sp-chat-hint');
    hint.hidden = true;

    function go() {
      var code = input.value.replace(/\D/g, '').slice(0, 6);
      if (!CODE_RE.test(code)) {
        hint.textContent = F.ui.code_wrong_shape;
        hint.hidden = false;
        scrollDown();
        return;
      }
      clearCompose();
      addMine(code);
      verifyCode(code);
    }

    input.addEventListener('input', function () {
      var only = input.value.replace(/\D/g, '').slice(0, 6);
      if (only !== input.value) input.value = only;
      btn.disabled = !CODE_RE.test(only);
      hint.hidden = true;
    });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); if (!btn.disabled) go(); }
    });
    btn.addEventListener('click', go);

    box.appendChild(input);
    box.appendChild(btn);
    D.compose.appendChild(box);
    D.compose.appendChild(hint);
    addQuietRow([{ label: F.ui.new_code, go: resendCode }]);
    scrollDown();
  }

  /* A new code. The answer is always ok, so the same line is said again - it
     cannot say whether a code actually went out. The box stays where it is. */
  function resendCode() {
    api('orders_resend', { token: S.token }).then(function () {
      addSystem(F.strings.orders_code_sent);
    }).catch(function () {
      addTrouble(resendCode);
    });
  }

  function verifyCode(code) {
    api('orders_verify', { token: S.token, code: code }).then(codeAnswer).catch(function (e) {
      /* the real server refuses a wrong, expired or stopped code with a 400 that
         carries the state - that is an answer to show, not a fault */
      if (e && e.data && e.data.state) { codeAnswer(e.data); return; }
      addTrouble(function () { verifyCode(code); });
    });
  }

  function codeAnswer(res) {
    if (res && res.ok) {
      S.verified = true;
      S.orders = res.orders || [];
      /* THE PAST CHATS COME BACK WITH THE ORDERS, in the one answer, so nothing
         else has to be asked for. This is the half that works on a phone the
         customer has never chatted from. */
      S.history = res.history || [];
      showOrders();
      return;
    }
    var state = (res && res.state) || 'bad_code';
    if (state === 'expired') { addSystem(F.strings.code_expired); overAndStartAgain(); return; }
    if (state === 'locked') { addSystem(F.strings.code_locked); overAndStartAgain(); return; }
    /* A wrong code can be tried again, so the question comes back with an
       empty box rather than the customer having to find it. */
    addSystem(F.strings.code_bad);
    askCode();
  }

  /* There is nothing more to do in this chat: an expired or stopped code, no
     orders under the email, or a chat that answered itself. The token is dropped
     so the next page does not try to bring it back. */
  function overAndStartAgain() {
    S.phase = 'over';
    stopPoll();
    dropToken();
    S.token = null;
    composeBackToStart();
  }

  /* THE ORDERS, as tappable cards. Also what "Back to my orders" draws, from the
     list the server already sent, so moving between orders asks nothing again. */
  function showOrders() {
    clearCompose();
    S.order = null;
    var orders = S.orders || [];
    var past = S.history || [];
    /* THE PAST CHATS GO ABOVE THE ORDER CARDS, as the design says. They are
       drawn from what verify sent, so moving between orders asks nothing again. */
    if (past.length) {
      var block = historyList(past, openServerPast);
      block.className = 'sp-chat-history sp-chat-history-inlog';
      D.log.appendChild(block);
    }
    if (!orders.length) {
      addSystem(F.strings.orders_none);
      /* WITH NO ORDERS BUT SOME PAST CHATS THE CHAT IS NOT OVER, and the token
         is kept: history_view needs it to open one. With neither there is
         nothing to read, so it ends as it did before. */
      if (!past.length) { overAndStartAgain(); return; }
      composeBackToStart();
      scrollDown();
      return;
    }
    var wrap = el('div', 'sp-chat-orders');
    orders.forEach(function (order) { wrap.appendChild(orderCard(order)); });
    D.log.appendChild(wrap);
    scrollDown();
  }

  /* Opening one of the verified customer's past chats, on any device. The id is
     the server's own and the server refuses any conversation that is not this
     customer's - that is the whole protection and it is not in this file. */
  function openServerPast(item) {
    if (!item || item.id === undefined || item.id === null) return;
    clearCompose();
    addMine(historyLabel(item.flow_key));
    api('history_view', { token: S.token, conversation_id: item.id })
      .then(function (res) {
        drawPast(res, (res && res.flow_key) || item.flow_key, true);
      })
      .catch(function () {
        addTrouble(function () { openServerPast(item); });
      });
  }

  /* `resume` does not answer the past chats - it answers one conversation - so a
     chat picked up on another page asks for them once, by its own action. A
     failure is not worth a line on screen: the orders are what the customer came
     for, and the list is drawn only if it arrives. */
  function relistHistory(done) {
    api('history_list', { token: S.token }).then(function (r) {
      S.history = (r && r.history) || [];
    }).catch(function () {
      S.history = [];
    }).then(done);
  }

  /* One card: the whole thing is the button, except the tracking link, which is a
     link and so cannot sit inside a button. */
  function orderCard(order) {
    var card = el('div', 'sp-chat-order');
    var b = el('button', 'sp-chat-order-main');
    b.type = 'button';
    b.setAttribute('aria-label', F.ui.orders_open + ' ' + (order.ref || ''));
    orderFacts(order, b);
    b.addEventListener('click', function () { chooseOrder(order); });
    card.appendChild(b);
    var track = trackingLine(order);
    if (track) card.appendChild(track);
    return card;
  }

  /* The facts of an order, in the order the README gives them: the reference the
     CUSTOMER knows and its channel, when it was ordered, the rings, where it is,
     and when it has to ship. */
  function orderFacts(order, into) {
    var top = el('div', 'sp-chat-order-top');
    top.appendChild(el('span', 'sp-chat-order-ref', order.ref || ''));
    if (order.channel) top.appendChild(el('span', 'sp-chat-order-channel', channelWords(order.channel)));
    into.appendChild(top);

    var placed = dayWords(order.placed_at);
    if (placed) into.appendChild(el('div', 'sp-chat-order-line', F.ui.orders_ordered + ' ' + placed));

    (order.items || []).forEach(function (item) {
      var row = el('div', 'sp-chat-order-item');
      row.appendChild(el('span', 'sp-chat-order-item-name', item.name || ''));
      if (item.detail) row.appendChild(el('span', 'sp-chat-order-item-detail', item.detail));
      into.appendChild(row);
    });

    if (order.stage) into.appendChild(el('div', 'sp-chat-order-stage', order.stage));

    var shipBy = dayWords(order.ship_by);
    if (shipBy) into.appendChild(el('div', 'sp-chat-order-line', F.ui.orders_ship_by + ' ' + shipBy));
  }

  /* The tracking link, once there is one. With a number but no address it is
     still said, as text, rather than dropped. */
  function trackingLine(order) {
    var t = order.tracking;
    if (!t) return null;
    var detail = [t.carrier, t.number].filter(function (x) { return !!x; }).join(' ');
    if (t.url) {
      var a = el('a', 'sp-chat-order-track');
      a.href = t.url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.appendChild(el('span', null, F.ui.orders_tracking));
      if (detail) a.appendChild(el('span', 'sp-chat-order-num', detail));
      return a;
    }
    if (!detail) return null;
    return el('div', 'sp-chat-order-track sp-chat-order-track-flat',
              F.ui.orders_tracking + ' ' + detail);
  }

  /* Choosing a card. The server is told which order the chat is about and
     refuses any order that is not this customer's, so the order drawn is the one
     IT sent back, not the one the card was drawn from. */
  function chooseOrder(order, again) {
    clearCompose();
    if (!again) addMine(order.ref || '');
    api('order_choose', { token: S.token, order_id: order.id }).then(function (res) {
      S.order = (res && res.order) || order;
      showOrder(S.order);
    }).catch(function () {
      addTrouble(function () { chooseOrder(order, true); });
    });
  }

  function showOrder(order) {
    var detail = el('div', 'sp-chat-order-detail');
    orderFacts(order, detail);
    var track = trackingLine(order);
    if (track) detail.appendChild(track);
    D.log.appendChild(detail);
    scrollDown();
    askOrderAction(order);
  }

  /* The three actions, with Gorgias's labels. NEVER CANCEL ORDER: Gorgias has it
     switched on with no status picked and no reply written, so it is offered
     nowhere, and ours copies that. Return order waits for `can_return`, which is
     Gorgias's "delivered less than 30 days ago". */
  function askOrderAction(order) {
    addAsk(F.strings.order_actions_bold, null);
    var actions = (S.flow.actions || []).filter(function (a) {
      return a.needs !== 'can_return' || !!order.can_return;
    });
    composeChoices({ choices: actions }, function (choice) {
      addMine(choice.label);
      saveStep('order_action', F.strings.order_actions_bold, choice.label, function () {
        if (choice.id === 'track') doTrack(order);
        else if (choice.id === 'return') doReturn();
        else doIssue(order);
      });
    }, backToOrdersExtra());
  }

  /* "Back to my orders", offered under an answer so somebody with several orders
     can move on. It is NOT offered once the chat is over - after "Yes, thanks"
     the server has closed the conversation, and after `finish` the chat belongs
     to a person - because the token would be refused and the button would lie. */
  function backToOrdersExtra() {
    if (!S.verified || !S.orders || !S.orders.length) return null;
    return [{
      label: F.ui.back_to_orders,
      /* what was pressed is echoed as the customer's own pill, the same as every
         other press, so the question it was pressed instead of answering is not
         left hanging over a list of orders with nothing under it */
      go: function () { clearCompose(); addMine(F.ui.back_to_orders); showOrders(); }
    }];
  }

  function hasShipped(order) {
    return !!(order.shipped_at || order.delivered_at || (order.tracking && order.tracking.number));
  }

  /* TRACK ORDER. The facts first - where it is, when it has to ship, the tracking
     link - and then, ONLY for an order that has not shipped, Gorgias's reply word
     for word, because that reply says the ring is still being made. */
  function doTrack(order) {
    var block = el('div', 'sp-chat-track');
    if (order.stage) block.appendChild(el('div', 'sp-chat-order-stage', order.stage));
    var shipBy = dayWords(order.ship_by);
    if (shipBy) block.appendChild(el('div', 'sp-chat-order-line', F.ui.orders_ship_by + ' ' + shipBy));
    var track = trackingLine(order);
    if (track) block.appendChild(track);
    if (block.childNodes.length) { D.log.appendChild(block); scrollDown(); }
    if (!hasShipped(order)) addBot(S.flow.track_not_shipped_reply);
    askHelpful();
  }

  /* RETURN ORDER. Gorgias's reply word for word, with its paragraph breaks and
     the address on its own line. `addBot` keeps them. */
  function doReturn() {
    addBot(S.flow.return_reply);
    askHelpful();
  }

  /* REPORT ISSUE. The options of the order's own scenario, in Gorgias's order,
     with Gorgias's labels. An unknown scenario falls back to Fallback, which is
     what Gorgias's Fallback is for. */
  function doIssue(order) {
    var scenarios = S.flow.scenarios || {};
    var scenario = scenarios[order.scenario] || scenarios.fallback;
    if (!scenario) { askDetails(F.strings.issue_bold); return; }
    addAsk(F.strings.issue_bold, null);
    composeChoices({ choices: scenario.options }, function (option) {
      addMine(option.label);
      saveStep('issue', F.strings.issue_bold, option.label, function () {
        addBot(option.reply);
        /* Gorgias's switch decides what happens now: an option whose reply ASKS
           the customer something has to reach a person, and one that answers
           outright asks whether it helped. */
        if (option.helpful) askHelpful();
        else askDetails(option.reply);
      });
    }, backToOrdersExtra());
  }

  function askHelpful() {
    addAsk(F.strings.helpful_bold, null);
    composeChoices({
      choices: [
        { id: 'yes', label: F.ui.helpful_yes },
        { id: 'more', label: F.ui.helpful_more }
      ]
    }, function (choice) {
      addMine(choice.label);
      saveStep('helpful', F.strings.helpful_bold, choice.label, function () {
        if (choice.id === 'yes') { ordersDone(); return; }
        addAsk(F.strings.more_help, null);
        askDetails(F.strings.more_help);
      });
    }, backToOrdersExtra());
  }

  /* The message box for what a person needs to read. What they type is recorded
     as the `details` answer and then the chat FINISHES exactly the way the flows
     finish: live if somebody is on, email if nobody is. */
  function askDetails(question) {
    composeBox(function (text, ctl) {
      ctl.taken();
      clearCompose();
      addMine(text);
      saveStep('details', question, text, function () { finishChat(); });
    }, backToOrdersExtra());
  }

  /* "Yes, thanks": the chat answered itself. The contract - closed,
     `closed_by = 'self_served'`, and NO TICKET, EVER. The conversation is closed
     server side, so the token is finished with and the only way on is to start
     again. */
  function ordersDone() {
    api('orders_done', { token: S.token }).then(function () {
      S.status = 'closed';
      addSystem(F.strings.self_served_end);
      overAndStartAgain();
    }).catch(function () {
      addTrouble(ordersDone);
    });
  }

  /* One answer saved on its own, by step id: the orders chat has no `steps`, so
     it cannot use saveAnswer. Same `answer` action, same contract. */
  function saveStep(stepId, question, value, done) {
    S.stepId = stepId;
    api('answer', {
      token: S.token,
      step_id: stepId,
      question: question,
      value: value
    }).then(function () {
      done();
    }).catch(function () {
      addTrouble(function () { saveStep(stepId, question, value, done); });
    });
  }

  /* ------------------------------------ an orders chat carried onto another page
   *
   * `resume` answers `flow_key: 'orders'`. What can be put back honestly depends
   * on what it hands over:
   *
   * - A chat that is WAITING or LIVE is redrawn in full - the answers given, each
   *   under its question, then the team's replies - because from here on it is an
   *   ordinary live chat.
   * - A chat still being answered needs the verified customer's ORDERS to be
   *   drawn at all, and the contract does not promise them back from `resume`. If
   *   they are there (or `orders_list` gives them, which is what that action is
   *   for), the list is drawn again. If they are not, THE ORDERS CHAT STARTS AGAIN
   *   FROM THE EMAIL rather than being drawn wrong: a half-drawn list of somebody
   *   else's orders would be a great deal worse than one extra code.
   */
  function redrawOrders(res) {
    var flow = ordersFlow();
    S.flow = flow;
    S.phase = 'orders';
    S.email = res.email || '';
    S.status = res.status;
    D.log.innerHTML = '';
    atHome(false);
    addMine(flow.label);
    addAsk(F.strings.email_bold, F.strings.email_italic);
    if (S.email) addMine(S.email);

    var msgs = res.messages || [];
    var answers = res.answers || {};
    var loose = drawOrderAnswers(msgs, answers);

    if (res.status === 'waiting' || res.status === 'live') {
      addSystem(F.strings.after_thanks_live);
      drawLoose(loose);
      S.phase = 'live';
      liveCompose();
      restartPoll();
      return;
    }

    var orders = (res.orders && res.orders.length !== undefined) ? res.orders : null;
    if (!res.verified_at && !orders) { startOrdersAgain(); return; }
    S.verified = true;
    if (orders) {
      S.orders = orders;
      relistHistory(showOrders);
      return;
    }
    api('orders_list', { token: S.token }).then(function (r) {
      if (r && r.ok && r.orders && r.orders.length !== undefined) {
        S.orders = r.orders;
        relistHistory(showOrders);
      } else {
        startOrdersAgain();
      }
    }).catch(function () {
      startOrdersAgain();
    });
  }

  /* Every answer the customer gave, each under the question it answered, in the
     order the messages were written. Returns the messages that belong to no step
     - the team's, the system's, and anything typed while live - so the caller can
     draw them after. */
  function drawOrderAnswers(msgs, answers) {
    var loose = [];
    for (var i = 0; i < msgs.length; i++) {
      var m = msgs[i];
      if (m.id && m.id > S.lastId) S.lastId = m.id;
      if (m.sender !== 'customer' || !m.step_id) { loose.push(m); continue; }
      var stored = answers[m.step_id];
      var asked = (stored && stored.question)
        || (ORDER_STEP_ASK[m.step_id] ? F.strings[ORDER_STEP_ASK[m.step_id]] : null);
      if (asked) addAsk(asked, null);
      addMine(m.body);
    }
    return loose;
  }

  /* Starting the orders chat again, saying so rather than silently asking for an
     email a second time. The old conversation is left exactly as the server has
     it; `orders_start` opens a new one. */
  function startOrdersAgain() {
    dropToken();
    S.token = null;
    S.verified = false;
    S.orders = null;
    S.order = null;
    S.history = null;
    addSystem(F.strings.orders_again);
    askOrdersEmail();
  }

  /* ============================================ ANSWERING THE THEME'S COMMANDS
   *
   * Lorenzo, 25 October 2026: "move the chat to the draft 5.13.7 and disable the
   * Gorgias all together". The theme's own sections drive the Gorgias widget
   * directly, and were read on the drafts the same day:
   *
   *   GorgiasChat.init()           6 places (custom-ring-hero, custom-faq-section,
   *                                sp-make-it-yours), each as `window.GorgiasChat
   *                                ? init() : wait for gorgias-widget-loaded`
   *   GorgiasChat.open()          12 places, always after that promise
   *   GorgiasChat.sendMessage(x)   3 places, from `[data-gorgias-flow]` buttons in
   *                                custom-ring-hero, x being the flow's own name
   *   #open-gorgias-chat          about 40 links across the shop
   *   [data-spdr-chat]             the wedding page's button, whose own script
   *                                calls GorgiasChat.open()
   *   gorgias-widget-loaded        the event all three sections fall back to
   *
   * With the Gorgias embed off, every one of those would silently take the
   * shopper to the custom request form instead. So this file answers to the same
   * commands and NOBODY'S SECTION HAS TO CHANGE.
   *
   * IT DEFINES window.GorgiasChat ONLY IF THERE IS NONE. If the real Gorgias
   * widget is ever on the same page it keeps its own object and this one is never
   * written - the two must never fight over the name.
   */

  /* Ignoring case and spaces, which is what "equals a flow's label" has to mean:
     the flow name is typed into the theme editor by hand, and "Heirloom gold"
     and "heirloom  gold" are the same answer. */
  function flatLabel(s) {
    return String(s === undefined || s === null ? '' : s).replace(/\s+/g, '').toLowerCase();
  }

  /* The flow whose label is this text, or null. The home screen's own rows and
     the order row, which are the labels anybody could be naming. */
  function flowKeyForLabel(text) {
    var want = flatLabel(text);
    if (!want) return null;
    var keys = (F.home.flows || []).slice();
    if (ordersShown()) keys.push(F.home.orders);
    for (var i = 0; i < keys.length; i++) {
      var flow = F.flows[keys[i]];
      if (flow && flow.label && flatLabel(flow.label) === want) return keys[i];
    }
    return null;
  }

  /* Starting a flow BY COMMAND. The same one twice inside a moment is ignored,
     so two document listeners on one page - custom-ring-hero binds its own -
     cannot start it twice. A row pressed on the home screen does not come
     through here, so pressing the same row twice still starts again. */
  function startFlowByCommand(key) {
    if (!key) return false;
    var now = Date.now();
    if (S.lastStartKey === key && (now - S.lastStartAt) < SAME_FLOW_MS) return true;
    S.lastStartKey = key;
    S.lastStartAt = now;
    if (key === F.home.orders) pickOrders();
    else pickFlow(key);
    return true;
  }

  /* ------------------------------------------------------------- page mode
   *
   * One page that is one flow and nothing else, on Lorenzo's word about the
   * wedding-dress page: "we dont want to show them the customise ring or any
   * other chat option, we start with a chat about wedding rings".
   *
   * IT IS ONLY ON FOR A FLOW THAT EXISTS AND HAS STEPS. The wedding flow is a
   * placeholder until his questions arrive, so until then that page behaves like
   * every other one: the home screen, the four flows and the order row. Nothing
   * about the flow is invented here or in the flow file.
   */
  /* WHICH KIND OF CHAT THIS PAGE IS, or null for every ordinary page (which then
     takes the flow file's `general`).
     IT NO LONGER ASKS WHETHER THAT FLOW HAS STEPS. It used to, because a page
     meant "go into that flow's questions" and a flow with no questions had
     nothing to go into. Since 27 October 2026 no chat has questions: a page names
     a KIND, and a kind needs no steps. The flow still has to EXIST, so a path
     pointing at a key the flow file does not carry is ignored rather than becoming
     a flow_key nothing can label. */
  function pageFlowFromPath() {
    var pages = F && F.pages;
    if (!pages) return null;
    var path = '';
    try { path = String(window.location.pathname || ''); } catch (e) { return null; }
    /* Shopify serves the page without a trailing slash; one that arrives with
       one is the same page, so it is not a different answer. */
    if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    if (!Object.prototype.hasOwnProperty.call(pages, path)) return null;
    var key = pages[path];
    return (F.flows && F.flows[key]) ? key : null;
  }

  /* NOT REACHED SINCE 27 OCTOBER 2026. A page no longer "enters" anything: the
     launcher opens the one screen, and the page's kind is simply what a new chat
     on it carries. Kept as the record of the double-start it guarded against.
     Into the page's own flow. It does NOTHING when a conversation is already on
     screen - one carried over from another page, or one already going - because
     throwing that away would lose what the customer has said. */
  function enterPageFlow() {
    if (!S.pageFlowKey) return false;
    /* A FLOW IS ALREADY CHOSEN, OR A CONVERSATION IS ALREADY DRAWN. `S.flow` is
       the one that matters and it is set the moment pickFlow runs, before
       `start` has answered and before anything is on screen - without it,
       openChat() and openForCommand() each called this in the same tick and the
       page's flow was started TWICE, which drew its first question twice. Seen
       on 25 October 2026 in the page-mode harness, and only seen because that
       flow has no label and so draws nothing of its own at once. */
    if (S.flow || S.token || D.log.firstChild) return false;
    /* `resume` may be about to hand one back. Show the conversation side, empty,
       rather than the home screen, and start the flow when it answers. */
    if (S.resuming) { atHome(false); return false; }
    pickFlow(S.pageFlowKey);
    return true;
  }

  /* What `GorgiasChat.open()`, the launcher and every chat link all end at. There
     is one screen, so there is one thing to do: show it. */
  function openForCommand() {
    openChat();
  }

  function defineGorgiasChat() {
    if (window.GorgiasChat) return false;
    /* Everything the real widget has that nobody here needs: it must not throw
       when a theme, an app or a tag manager calls it. */
    function noop() { return undefined; }
    function self() { return shim; }
    var shim = {
      /* ---- what the theme actually calls */
      init: function () { return Promise.resolve(shim); },
      open: function () { openForCommand(); return shim; },
      close: function () { closeChat(); return shim; },
      isOpen: function () { return !!S.open; },
      /* IT JUST OPENS THE CHAT SINCE 27 OCTOBER 2026. A flow's name used to start
         that flow; there are no flows to start any more, and the kind is the
         page's. So every `sendMessage`, whatever text it carries, does what
         `open()` does - which is also what Gorgias itself does with a message it
         has no flow for. The text is deliberately NOT sent as the customer's first
         message: it comes from a theme section's own markup and is nothing a
         customer typed. */
      sendMessage: function () {
        openForCommand();
        return shim;
      },

      /* ---- harmless no-ops. None of these is called by the theme today; they
         are the rest of the Gorgias widget's own surface, so a call from
         anywhere else is answered and nothing breaks. `on`/`off`/`once` hand
         back a function, which is what a listener registration is expected to
         give, and it does nothing either. */
      on: function () { return noop; },
      off: noop,
      once: function () { return noop; },
      hidePoweredBy: noop,
      showPoweredBy: noop,
      setCurrentUser: noop,
      captureUserEmail: noop,
      identify: noop,
      setUserData: noop,
      setContactFormFields: noop,
      sendCustomEvent: noop,
      openArticle: noop,
      show: self,
      hide: self,
      hideChat: self,
      showChat: self,
      toggle: self,
      destroy: noop,
      unreadCount: function () { return 0; },
      getUnreadCount: function () { return 0; },
      /* so anybody reading the console can see whose object this is */
      isSestoShim: true
    };
    window.GorgiasChat = shim;
    return true;
  }

  /* The event all three theme sections fall back to when `window.GorgiasChat` is
     not there yet. Fired once, when this file is ready. */
  function fireReady() {
    var ev;
    try {
      ev = new Event(GORGIAS_EVENT);
    } catch (e) {
      try {
        ev = document.createEvent('Event');
        ev.initEvent(GORGIAS_EVENT, true, true);
      } catch (e2) { return; }
    }
    try { window.dispatchEvent(ev); } catch (e3) { /* nothing */ }
  }

  /* THE SHOP'S OWN CHAT LINKS. About forty `#open-gorgias-chat` links and the
     `[data-gorgias-flow]` buttons in custom-ring-hero.
     ONLY WHEN NOBODY ELSE HAS HANDLED IT. custom-ring-hero, custom-faq-section
     and sp-make-it-yours each bind their own document listener and call
     preventDefault; they are in the page before this file, so theirs runs first
     and `defaultPrevented` is already true by the time this one is asked. Doing
     nothing then is the right answer, and it is also what stops a flow being
     started twice. */
  function bindChatLinks() {
    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented) return;
      var t = ev.target;
      if (!t || !t.closest) return;
      var flowEl = t.closest('[data-gorgias-flow]');
      var linkEl = flowEl ? null : t.closest('a[href="#open-gorgias-chat"]');
      if (!flowEl && !linkEl) return;
      ev.preventDefault();
      /* ONE SCREEN: a `[data-gorgias-flow]` button and an `#open-gorgias-chat`
         link now do the same thing, because there is no flow for the button's own
         name to choose. The flow name in the markup is ignored and no theme
         section has to change. */
      openForCommand();
    });
  }

  /* ------------------------------------------------------------------- boot */

  function practiceFromPage(root) {
    var asked = null;
    try {
      var m = /[?&]sp_chat_practice=([^&#]*)/.exec(window.location.search || '');
      if (m) asked = decodeURIComponent(m[1]).toLowerCase();
    } catch (e) { asked = null; }
    if (!asked) asked = (root.getAttribute('data-sp-chat-practice') || '').toLowerCase();
    if (asked === 'offline' || asked === 'email' || asked === '0') return 'offline';
    /* `1` is what docs/chat/README.md writes; the two named modes are newer */
    if (asked === 'online' || asked === 'live' || asked === '1' || asked === 'true') return 'online';
    return null;
  }

  function init(root) {
    root = root || document.getElementById(ROOT_ID);
    if (!root) return null;
    F = window.SPChatFlows;
    if (!F) return null;                   /* the flow file has to be there */
    if (S.ready && S.root === root) return window.SPChat;

    S.root = root;
    /* an attribute that is there but EMPTY means "no function", which is not
       the same as an attribute that is missing */
    S.fnUrl = root.hasAttribute('data-sp-chat-fn')
      ? (root.getAttribute('data-sp-chat-fn') || '')
      : FN_DEFAULT;
    S.logoUrl = root.getAttribute('data-sp-chat-logo') || '';
    S.practice = practiceFromPage(root);
    /* With no address there is nothing to call, so the chat practises rather
       than failing on every step. This is what makes the preview's "calls no
       server" true by construction and not by luck. */
    if (!S.fnUrl && !S.practice) S.practice = 'online';
    /* practice mode shows the history screens too, from the invented chats in
       the flow file, so the preview demonstrates them without writing anything
       to the browser it is being looked at in */
    if (S.practice) S.practiceHistory = practiceOwnHistory();
    /* WHICH KIND OF CHAT THIS PAGE IS, worked out once and never shown. The
       page's own kind where it has one, and the flow file's `general` everywhere
       else. Before build(), because nothing should be drawn before it is known. */
    S.pageFlowKey = pageFlowFromPath();
    S.kind = S.pageFlowKey || (F.general || 'chat');
    S.ready = true;

    build();
    D.badge.hidden = !S.practice;

    window.addEventListener('resize', fitViewport);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fitViewport);
      window.visualViewport.addEventListener('scroll', fitViewport);
    }
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && S.open) closeChat();
    });

    /* THE BROWSER TAB'S OWN MARK COMES OFF THE MOMENT THE TAB IS LOOKED AT. The
       card stays: they can see it now, and it is still unread.
       AND THIS IS WHERE "they come back later" ACTUALLY HAPPENS (31 October 2026).
       A tab left open behind another one is the commonest way the answer goes
       stale, and coming back to it is not a page load, so nothing used to ask
       again. One `status` is asked, and only for a conversation that is drawn in an
       open panel - a shut panel has nobody looking at it, and it asks on the way
       open anyway. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      restoreTitle();
      if (S.open && S.token && !S.resuming) refreshOnline();
    });

    /* TWO TABS, ONE CHAT (31 October 2026). Both load with no chat, the customer
       starts it in one, and the other is still showing a fresh box - so the first
       thing typed THERE calls `start` and makes a second chat with a second token,
       which then overwrites the first. localStorage says so the moment it is
       written: `storage` fires in every OTHER tab of this origin, so the tab that
       has no chat picks up the one that has just been started, draws it, and its
       box becomes that chat's box.
       IT IS NOT ADOPTED: the token came from `sp-chat-token` itself, which is
       exactly what `resume` reads, so nothing is written back and no history row is
       touched. A tab that already has a chat is left alone, and so is practice
       mode, which must write and read nothing. */
    window.addEventListener('storage', function (e) {
      if (!e || e.key !== TOKEN_KEY || !e.newValue) return;
      if (S.practice || S.token) return;
      /* whatever is half typed HERE is carried into the box that is about to be
         built for that chat - see the foot of redrawOne */
      S.carryTyped = (S.typingBox && S.typingBox.value) || '';
      resumeToken(e.newValue, false, 0);
    });

    /* The product page's floating Add to cart, if this page has one. */
    watchSticky();

    /* practice is per page load; nothing is stored and nothing is resumed */
    if (!S.practice) resume();

    /* THE THEME'S COMMANDS, last: the object, the links, then the event that
       says both are ready. Only if no Gorgias widget already holds the name. */
    defineGorgiasChat();
    bindChatLinks();
    fireReady();

    return window.SPChat;
  }

  window.SPChat = {
    version: '8 (31 October 2026: ONE CHAT AND NOTHING THAT CLEARS IT - no "Back to '
      + 'the start" under an ended chat, the same chat says so when nobody is on and '
      + 'stops saying it the minute somebody is, the answer asked again when the panel '
      + 'is opened or the tab is looked at, and a resume that could not be read offers '
      + 'Try again instead of a box that would start a second chat)',
    init: function (root) { return init(root); },
    open: function () { if (S.ready) openForCommand(); },
    close: function () { closeChat(); },
    reset: function () { if (S.ready) reset(); },
    /* for the preview page only: switch practice mode without a reload */
    setPractice: function (mode) {
      S.practice = (mode === 'offline') ? 'offline' : (mode ? 'online' : null);
      S.practiceHistory = S.practice ? practiceOwnHistory() : null;
      if (S.ready) { D.badge.hidden = !S.practice; reset(); }
      return S.practice;
    },
    /* the state, so a preview can be driven from the console */
    state: S
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(null); });
  } else {
    init(null);
  }
}());
